import React, { Component } from 'react';
import axios from 'axios';
import { SkyLightStateless } from 'react-skylight';
import ReactDataGrid from 'react-data-grid';
import moment from 'moment';
import { Toolbar, Data } from 'react-data-grid-addons';
import _, { debounce } from 'lodash';
import ReactPaginate from 'react-paginate';
import { Field } from 'redux-form';
import {
  Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb, Input,
  Dropdown, MenuItem, DropdownButton, Spinner,
} from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';

import GenericDatePicker from '../Common/GenericDatePicker';
import EmailContentModal from './components/EmailContentModal';
import {SALES_ORDERS_URL, PICKER_URL} from '../../actions/url';
import SpinnerButton from '../Common/SpinnerButton';
import { UI_HEIGHT } from '../Common/constants';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import WidgetsSpinner from '../../components/Widgets/spinner';
import CashFormatter from '../Common/cashFormatter';
import { DateFormatter2 } from '../Common/dateFormat';
import { DatePicker } from '../Common/datePicker';
import { Selection, SelectionWithProps } from '../Common/selection';
import TypeRadios from '../../containers/Common/TypeRadios';
import GenericProductSuggest from '../../containers/Common/GenericProductSuggest';
import { toFromDates } from '../Common/cleanDates';
import ConfirmActionModal from '../Common/confirmActionModal';
import genericRadioFilter from '../Common/genericRadioFilter';
import { numberWithCommas } from '../Common/numberWithCommas';
import dateFilterRadios from '../Common/dateFilterRadios';
import dispatchFilterRadios from '../Common/dispatchFilterRadios';
import PercentFormatter from '../Common/percentFormatter';
import checkPermission from '../Common/permissions';
import checkPermissionLocal from '../Common/permissions';
import { WeightChangeModalMulti } from '../Common/weightChangeModalMulti';
import { BOLListModal } from '../Common/bolListModal';
import { DSQPrintModal } from '../Common/dsqPrintModal';
import { WIZPODModal } from '../Common/wizPODModal';
import { GenerateBOLModal } from '../Common/generateBOLModal';
import { SplitTrackingNumberModal } from '../Common/SplitTrackingNumberModal';
import PaymentMethodModal from './PaymentMethodModal';
import ShipMethodModal from './components/ShipMethodModal';
import ShipQtyModal from './components/ShipQtyModal';
import BolImagesTable from './components/BolImagesTable';
import {
  ROOT_URL, ROOT_API_URL, companyCodeTitle, isDAICHEONG, isESC, isSKH, isHMM,
  isSUN, isABBLE, isGGI, isSH, isOCM, isHO, isLAP, isOLG, isABCFF, isSV,
  isEKC, isLMH, isTQ,
} from '../../actions/root_url';
import salesOrderModals from "../Common/modals/salesOrder";
import { roundTo } from '../Common/NumberUtil';
import SalesShippingModal from '../../containers/Sales/salesShippingModal';

import { submitBolImage, podUpload, generateSOWithExcelUSPride, expressMultipleSOInvoices } from '../../actions/sales_actions';
const { 
  DriverListModal, ISAEditModal, CTNEditModal, LocationChange, InboundDateChange,
  TeapplixResyncModal, MissingSKUsModal, MonitorNoteModal, MonitorRemoveModal,
  MonitorListModal, ImageModal, ShippingRateModal
} = salesOrderModals;
const isMyuMyu =
  ROOT_API_URL === "https://mmstage-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://myumyu-scm.truckxi.com/api/";
const isCalco =
  ROOT_API_URL === "https://calco-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://calco-stage.truckxi.com/api/";
const isEcity =
  ROOT_API_URL === "https://ct-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/";
const isAFG =
  ROOT_API_URL === "https://afg-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afgstage-scm.truckxi.com/api/";
const isMAG = ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || ROOT_URL === 'https://magna-scm.truckxi.com/api/';
const isRivera =
  ROOT_API_URL === "https://rivera-scm.truckxi.com/api/" ||
  ROOT_URL === "https://rvrstage-scm.truckxi.com/api/";
const isWecom = ROOT_API_URL === "https://wecom-scm.truckxi.com/api/";
const isCO = ROOT_API_URL === "https://co-scm.truckxi.com/api/";
const isJML = ROOT_API_URL === "https://jml-scm.truckxi.com/api/";
const isSY = ROOT_API_URL === "https://sunny-scm.truckxi.com/api/";
const isAFM =
  ROOT_API_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afmstage-scm.truckxi.com/api/";
const isTN =
  ROOT_API_URL === "https://tn-scm.truckxi.com/api/" ||
  ROOT_URL === "https://tn-scm.truckxi.com/api/";
const isABC =
  ROOT_API_URL === "https://abc-scm.truckxi.com/api/" ||
  ROOT_URL === "https://abc-scm.truckxi.com/api/";
const isUSPride =
  ROOT_API_URL === "https://uspride-scm.truckxi.com/api/" ||
  ROOT_URL === "https://uspride-scm.truckxi.com/api/";
const isChinaTown = ROOT_API_URL === 'https://erp.chinatown-supermarket.com/api/' || ROOT_URL === 'https://erp.chinatown-supermarket.com/api/';
const isDSQ = ROOT_API_URL === 'https://dsq-scm.truckxi.com/api/' || ROOT_URL === 'https://dsq-scm.truckxi.com/api/';
const isWIZ = ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
const isGV = ROOT_API_URL === 'https://scm.gvyummy.com/api/' || ROOT_URL === 'https://scm.gvyummy.com/api/';
const isFJ = ROOT_API_URL === 'https://fj-scm.truckxi.com/api/' || ROOT_URL === 'https://fj-scm.truckxi.com/api/';
const isJTB = ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || ROOT_URL === 'https://jtb-scm.truckxi.com/api/';
const isFIT = ROOT_API_URL === 'https://fit-scm.truckxi.com/api/' || ROOT_URL === 'https://fit-scm.truckxi.com/api/';
const isNBT = ROOT_API_URL === 'https://nbt-scm.truckxi.com/api/' || ROOT_URL === 'https://nbt-scm.truckxi.com/api/';

import { getLocalStorageData } from '../../reducers/headerRedux';
import { getSortVal, getKeysMap } from '../../utils';
import { SALES_ORDER_SORT_KEY_OBJ } from '../../utils/map';
import { fetchSalesQuotesByFilterLap, searchSalesQuoteByNumLap } from '../../actions/salesOrderList_actions';

const createDialogShippingStyle = {
  height: '740px',
  width: window.innerWidth * 4 / 5,
  marginLeft: '-35%',
  marginTop: '-22%',
  top: '60%'
};

const {
  Draggable: {
    Container: DraggableContainer,
    RowActionsCell,
    DropTargetRowContainer,
  },
  Data: { Selectors },
} = require("react-data-grid-addons");
class ToolBarCustom extends Component {
  render() {
    return <Toolbar enableFilter {...this.props} />
  }
}
class RowRenderer extends Component {
  render() {
    return (
      <div
        style={{ backgroundColor: 'orange' }}
        onDoubleClick={() => {
          console.log('this.props', this.props);
        }}
      >
        <ReactDataGrid.Row ref="row" {...this.props}
          style={{ backgroundColor: 'orange' }}
        />
      </div>
    );
  }
}

class UPriceFormatter extends Component {
  render() {
    const { value } = this.props;
      return <span>{
        (value !== null && !isNaN(value) && `$${(Math.round(value * 100) /100)}`)
      }</span>;
  }
}
class PriceFormatter extends Component {
  render() {
    const { value } = this.props;
    if(isLAP) {
      return <span>{
        (value !== null && !isNaN(value) && `${(Math.round(value * 100) /100)}`)
      }</span>;
    } else {
      return <span>{
        value
      }</span>;
    }
  }
}

class SalesOrder extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.fiveLineButton,
      clear: true,

      salesOrders: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },

      salesOrderDetail: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },

      magSalesOrderDetail: {

      },

      shippingPdfFrameLoaded: true,
      pickingListPdfFrameLoaded: true,
      packingListPdfFrameLoaded: true,
      salesOrderPdfFrameLoaded: true,
      bolIdPdfFrameLoaded: true,
      bolWithoutLogPdfFrameLoaded: true,
      bolFbaPdfFrameLoaded: true,
      bolLabelFrameLoaded: true,

      suggestValue: "",
      productSearchType: "invoiceNo",
      days: "1",
      FromDate: undefined,
      ToDate: undefined,
      filteredByItem: false,
      Status: "all",
      rowsCount: 0,
      total: 0,
      canceledOrders: 0,
      canceledTotal: 0,
      dispatchDays: null,
      dispatchDateGT: undefined,
      dispatchDateLT: undefined,

      checkAuthorizeOpen: false,
      action: null,
      title: "Quote",
      breadcrumbTitle: "mobile_sales_order",
      changeWeightOpen: false,
      displayTrackingOpen: false,
      changePullSheetOpen: false,
      confirmReshipOpen: false,
      confirmQuoteOpen: false,
      confirmQuotePending: false,
      confirmOpenToQuote: false,
      showDriverImageOpen: false,
      showSignatureImageOpen: false,
      submitImageOpen: false,
      printBolOpen: false,
      finalShippingWeight: 0,
      pullSheetAmount: 0,
      pullSheetSort: "",
      scrollTopPositionIndex: null,
      trackingNumberSelected: null,
      invoiceNoSearchTerm: "",
      trackingNoSearchTerm: "",

      bolListModalVisibility: false,
      generateBOLModalVisibility: false,
      dsqPrintVisibility: false,
      wizPODVisibility: false,

      paymentMethodModalVisibility: false,
      shipMethodModalVisibility: false,
      shipQtyModalVisibility: false,
      changeShipQtyId: null,
      voidNoteModalVisibility: false,
      voidReason: "",
      voidNote: "",

      chowbusModalVisibility: false,
      chowbusImportFile: null,

      mag1: {
      DRYRUN: false,
      OFFHIRE: false,
      EXTRA_STOP: false,
      EXAM: false,
      EXTRA_DELIVERY: false,
      STORAGE: false,
      BOBTAIL_FEE: false,
      },

      mag2: {
        FREIGHT_HOLD: false,
        CUSTOM_HOLD: false,
        PIERPASS_HOLD: false,
        EXAM: false,
        CLOSED_AREA: false,
        },

      rows: [],
      file: [],
      bolAddressFBA: "",

      quoteSelectedCustomerId: null,
      quoteSelectedCustomerName: "",
      quoteSelectedWarehouseId: null,
      quoteSelectedCustomerPlaceholder: "",
      quoteSelectedWarehousePlaceholder: "",
      quoteCustomerOptions: [],
      quoteWarehouseOptions: [],
      quoteShippingOptions: [],

      davisPOVisibility: false,
      driverListModalVisibility: false,
      isaEditModalVisibility: false,
      ctnEditModalVisibility: false,

      limit: isABC ? 25 : 30,
      limitDisplay: isABC ? '25' : isOCM ? '30' : 'all',
      currentPage: 0,
      searchFilter: {
        SQNum: '',
        CompanyName: '',
        FBACode: '',
        CustomerBOLNo: '',
        IsaNo: '',
        ContainerNo: '',
        ShippingStatus: '',
      },

      pridePrintVisibility: false,

      assigningInboundDriver: false,
      assigningOutboundDriver: false,
      PODIframeLoaded: false,
      selectedPODFile: '',
      abcDatePickerShow: true,

      isLocationChangeModalVisible: false,

      USPrideCreateOpen: false,
      USPridePlatform: "",

      PickerOpen: false,
      SelectedPicker: null,

      isInboundDateChangeModalVisibile: false,
      Type: null,
      emailContentModalVisibility: false,
      emailSubjectTemplate: '',
      emailContentTemplate: '',
      isTeapplixResyncModalVisibile: false,
      isMissingSKUsModalVisible: false,
      isMonitorNoteModalVisible: false,
      monitorRow: null,
      isCancelMonitorModalVisible: false,
      isMonitorListModalVisible: false,
      isOrderImageModalVisible: false,
      showShippingOpen: false,
      duplicateSOLoading: false,
      isShipingRateVisible: false,
    };

    this.handleResize = this.handleResize.bind(this);
    this.printForm = this.printForm.bind(this);
    this.loadsPost = this.loadsPost.bind(this);
    this.fetchSalesOrdersByDetails = this.fetchSalesOrdersByDetails.bind(this);
    this.fetchSalesOrdersByDispatch = this.fetchSalesOrdersByDispatch.bind(
      this
    );
    this.checkAuthorize = this.checkAuthorize.bind(this);
    this.openCheckAuthorize = this.openCheckAuthorize.bind(this);
    this.closeCheckAuthorize = this.closeCheckAuthorize.bind(this);
    this.onDrop = this.onDrop.bind(this);
    // this.renderImage = this.renderImage.bind(this);
    this.renderDriverImage = this.renderDriverImage.bind(this);
    this.closeConfirmQuote = this.closeConfirmQuote.bind(this);
    this.openConfirmQuote = this.openConfirmQuote.bind(this);

    this.openGenerateBOLModal = this.openGenerateBOLModal.bind(this);
    this.closeGenerateBOLModal = this.closeGenerateBOLModal.bind(this);

    this.openDSQPrint = this.openDSQPrint.bind(this);
    this.closeDSQPrint = this.closeDSQPrint.bind(this);

    this.openWIZPOD = this.openWIZPOD.bind(this);
    this.closeWIZPOD = this.closeWIZPOD.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    document.title = companyCodeTitle;
    if (isABC) {
      // this.grid.onToggleFilter()
    }
    if (isOCM) {
      this.state.currentPage = this.props.currentPage;
    }
    const salesOrdersFilter = this.props.salesOrdersFilter;
    const route = this.context.router.routes[1].path;
    if (salesOrdersFilter && route === salesOrdersFilter.currentPage) {
      const selectedRows = salesOrdersFilter.currentRows.filter((r, idx) => {
        if (r.isSelected === true) {
          this.setState({
            scrollTopPositionIndex: idx,
          });
        }
        return r.isSelected === true;
      });
      const salesOrders = {
        ...this.state.salesOrders,
        rows: salesOrdersFilter.currentRows,
        selectedRows,
        // filters: {},
      };
      this.setState({
        salesOrders,
        Status: salesOrdersFilter.Status,
        FromDate: salesOrdersFilter.FromDate,
        ToDate: salesOrdersFilter.ToDate,
        days: salesOrdersFilter.Days,
      });
      this.props.setValue("salesQuotes", "Seller", salesOrdersFilter.Seller);
      this.props.setValue("salesQuotes", "ProductNum", salesOrdersFilter.ProductNum);
      const todayDate = new Date();
      let fromDate = moment(todayDate).format("YYYY-MM-DD")
      if (salesOrdersFilter.FromDate) {
        fromDate = this.formatDate(salesOrdersFilter.FromDate);
      }
      let toDate = moment(todayDate).format("YYYY-MM-DD");
      if (salesOrdersFilter.ToDate) {
        toDate = this.formatDate(salesOrdersFilter.ToDate);
      }
      let seller = salesOrdersFilter.Seller;
      if (salesOrdersFilter.Seller) {
        seller = salesOrdersFilter.Seller.value;
      }
      this.props.fetchSalesQuotesByFilterLap(
        fromDate,
        toDate,
        salesOrdersFilter.Days,
        salesOrdersFilter.Status,
        seller,
        salesOrdersFilter.ProductNum,
        route,
        null,
        null,
        null,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.state.Type,
      );
      this.props.fetchBaseUsers(false,true);
      this.props.fetchBolAddress();
    } else {
      const fromDate = moment().format('YYYY-MM-DD');
      const toDate = moment().format('YYYY-MM-DD');
      let days = "1";
      let status = "all";
      if (isRivera) {
        status = "open";
      }
      if (route === "mobileSalesOrders") {
        if (isMyuMyu || isAFG || isWecom || isJML || isSKH) {
          days = "1";
        } else if (isABC) {
          status = 'all';
        } else {
          status = "open";
        }
      }
      this.props.setDefaultDays("salesQuotes");
      this.setState({ Status: status, days }, () =>
        this.props.fetchSalesQuotesByFilterLap(
          fromDate,
          toDate,
          days,
          status,
          null,
          null,
          route,
          null,
          null,
          this.state.dispatchDays,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.state.Type,
        ),
      );
      this.props.fetchBaseUsers(false,true);
      this.props.fetchBolAddress();
    }
    if (salesOrdersFilter && route !== salesOrdersFilter.currentPage) {
      this.props.setSalesOrdersFilter(null);
    }
    this.handleBreadCrumbTitle();
    this.props.fetchCustomers();
    this.props.fetchWarehouses();
  }

  componentWillUnmount() {
    if (this.state.clear) {
      this.props.setSalesOrdersFilter(null);
    }
    window.removeEventListener("resize", this.handleResize);
  }

  // Once products are ready, reset state.

  componentWillReceiveProps(nextProps) {
    if (this.props.salesShippingCustomerDetails !== nextProps.salesShippingCustomerDetails && nextProps.salesShippingCustomerDetails) {
      const quoteShippingOptions = [];
      nextProps.salesShippingCustomerDetails.Shipping.forEach(shipping => {
        quoteShippingOptions.push({
          label: [shipping.Street, shipping.City, shipping.State].join(', '),
          value: shipping.CustomerDetail_id,
        })
      })
      this.setState({ quoteShippingOptions });
    }
    if (this.props.selectedWarehouse !== nextProps.selectedWarehouse && nextProps.selectedWarehouse.value) {
      this.props.fetchBaseUsers(false,true);
      this.refreshSOList();
    }
    const route = this.context.router.routes[1].path;
    if (
      nextProps.checkPasswordSuccess &&
      nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess
    ) {
      this.closeCheckAuthorize();
      if (this.state.action === "void") {
        if (isAFG) {
          this.openVoidNote();
        } else {
          this.voidOrder();
        }
      }
    }
    if (
      nextProps.salesOrders &&
      nextProps.salesOrders !== this.props.salesOrders
    ) {
      // Split Weight
      if (
        this.state.salesOrders &&
        this.state.salesOrders.selectedRows &&
        this.state.salesOrders.selectedRows.length === 1
        && nextProps.salesOrders && nextProps.salesOrders.Quotes
      ) {
        nextProps.salesOrders.Quotes.map((orders) => {
          if (orders.SQNum === this.state.salesOrders.selectedRows[0].SQNum) {
            this.state.salesOrders.selectedRows[0].FinalShippingWeight =
              orders.FinalShippingWeight;
          }
        });
      }
      this.setState({
        total: nextProps.salesOrders.Total });
      if (
        this.props.salesOrdersFilter &&
        this.props.salesOrdersFilter.currentRows &&
        this.context.router.routes[1].path ===
          this.props.salesOrdersFilter.currentPage
      ) {
        const salesOrders = nextProps.salesOrders.Quotes;
        // let rows = [...this.state.salesOrders.rows];
        // rows = rows.map((r) => {
        //   const index = _.findIndex(salesOrders, { SalesQuote_id: r.SalesQuote_id });
        //   if (index > -1) {
        //     r.OrderDate = salesOrders[index].OrderDate;
        //     r.DispatchDate = salesOrders[index].DispatchDate;
        //     r.SaleStatus = salesOrders[index].SaleStatus;
        //   } else {
        //     r = null;
        //   }
        //   return r;
        // });
        // rows = rows.filter(r => r !== null);
        let rows = salesOrders.map((order) => {
          if (
            order.InvoiceNum ===
              this.state.salesOrders.selectedRows[0].InvoiceNum &&
            order.SQNum === this.state.salesOrders.selectedRows[0].SQNum
          ) {
            return {
              ...order,
              isSelected: true,
            };
          } else {
            return {
              ...order,
              isSelected: false,
            };
          }
        });
        const newSalesOrders = {
          ...this.state.salesOrders,
          rows,
          selectedRows: this.state.salesOrders.selectedRows || [],
        };
        if (this.props.salesOrderDetail) {
          var salesOrderDetail = {
            ...this.state.salesOrderDetail,
            rows: this.props.salesOrderDetail.Sales_Quote_Lines,
          };
          this.setState({ salesOrderDetail });
        }
        this.setState({ salesOrders: newSalesOrders });
        this.props.setSalesOrdersFilter(null);
      } else {
        const salesOrders = {
          ...this.state.salesOrders,
          rows: nextProps.salesOrders.Quotes,
          // filters: {},
          selectedRows: []
        };
        _.forEach(salesOrders.selectedRows, selectedRow => {
          salesOrders.rows = _.map(salesOrders.rows, row => {
            if(row.SalesQuote_id === selectedRow.SalesQuote_id) {
              return {
                ...row,
                isSelected: true
              }
            }
            return row;
          })
        })
        // for (var i = 0; i < salesOrders.rows.length; i++) {
        //   if (
        //     salesOrders.selectedRows[0] &&
        //     salesOrders.rows[i].InvoiceNum ===
        //       salesOrders.selectedRows[0].InvoiceNum &&
        //     salesOrders.rows[i].SQNum === salesOrders.selectedRows[0].SQNum
        //   ) {
        //     salesOrders.rows[i].isSelected = true;
        //   }
        // }
        var salesOrderDetail = { ...this.state.salesOrderDetail, rows: [] };
        this.setState({ salesOrders, salesOrderDetail });
        this.props.setSalesOrdersFilter(null);
      }

      if (this.state.scrollTopPositionIndex !== null) {
        var top = 25 * this.state.scrollTopPositionIndex;
        if (this.grid) {
          var gridCanvas = this.grid
            .getDataGridDOMNode()
            .querySelector(".react-grid-Canvas");
          gridCanvas.scrollTop = top;
        }
      }
    }

    if (
      nextProps.salesOrderDetail &&
      nextProps.salesOrderDetail !== this.props.salesOrderDetail
    ) {
      var salesOrderDetail = {
        ...this.state.salesOrderDetail,
        rows: nextProps.salesOrderDetail.Sales_Quote_Lines,
      };

      this.state.mag1 = {};
      let mag1TempSplit = [];
      // if (isMAG && nextProps.salesOrderDetail.mag_note) {
      //
      //   mag1TempSplit = nextProps.salesOrderDetail.mag_note.split(',');
      //   mag1TempSplit.map(r=>{
      //     if (r === 'DRYRUN') {this.state.mag1.DRYRUN = true;}
      //     if (r === 'OFFHIRE') {this.state.mag1.OFFHIRE = true;}
      //     if (r === 'EXTRA_STOP') {this.state.mag1.EXTRA_STOP = true;}
      //     if (r === 'EXAM') {this.state.mag1.EXAM = true;}
      //     if (r === 'EXTRA_DELIVERY') {this.state.mag1.EXTRA_DELIVERY = true;}
      //     if (r === 'STORAGE') {this.state.mag1.STORAGE = true;}
      //     if (r === 'BOBTAIL_FEE') {this.state.mag1.BOBTAIL_FEE = true;}
      //    });
      // }

      this.state.mag2 = {};
      let mag2TempSplit = [];
      // if (isMAG && nextProps.salesOrderDetail.DeliveryStatus) {
      //   mag2TempSplit = nextProps.salesOrderDetail.DeliveryStatus.split(',');
      //   mag2TempSplit.map(r=>{
      //     if (r === 'FREIGHT_HOLD') {this.state.mag2.FREIGHT_HOLD = true;}
      //     if (r === 'CUSTOM_HOLD') {this.state.mag2.CUSTOM_HOLD = true;}
      //     if (r === 'PIERPASS_HOLD') {this.state.mag2.PIERPASS_HOLD = true;}
      //     if (r === 'EXAM') {this.state.mag2.EXAM = true;}
      //     if (r === 'CLOSED_AREA') {this.state.mag2.CLOSED_AREA = true;}
      //    });
      // }

      this.setState({ magSalesOrderDetail: {} });
      this.setState({ salesOrderDetail, magSalesOrderDetail: nextProps.salesOrderDetail });
    }

    if (nextProps.Seller && nextProps.Seller !== this.props.Seller) {
      const salesOrdersFilter = this.props.salesOrdersFilter;
      if (!salesOrdersFilter) {
        let seller = nextProps.Seller;
        if (nextProps.Seller) {
          seller = nextProps.Seller.value;
        }
        const fromDate = this.state.FromDate
          ? this.formatDate(this.state.FromDate)
          : moment().format('YYYY-MM-DD');
        const toDate = this.state.ToDate
          ? this.formatDate(this.state.ToDate)
          : moment().format('YYYY-MM-DD');
        const days = this.state.days;

        // if (fromDate == null) {
        //   fromDate = '1900-01-01';
        // }
        // if (toDate == null) {
        //   toDate = '3000-01-01';
        // }
            
        let filterParams = "";
        // if (isOCM) {
        //   const filterPaires = [];
        //   _.forOwn(this.state.salesOrders.filters, (value, key) => {
        //     filterPaires.push([key, value.filterTerm].join('='))
        //   });
        //   filterParams = filterPaires.join('&');
        // }
        const productNum = this.state.filterProductID;
        this.props.fetchSalesQuotesByFilterLap(
          fromDate,
          toDate,
          days,
          this.state.Status,
          seller,
          productNum,
          route,
          null,
          null,
          null,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.state.Type,
          filterParams,
        );
      }
    }

    if (nextProps.Picker) {
      this.setState({SelectedPicker: nextProps.Picker});
    }

    if (this.props.Seller && nextProps.Seller == null) {
      const seller = nextProps.Seller;
      const fromDate = this.state.FromDate
        ? this.formatDate(this.state.FromDate)
        : moment().format('YYYY-MM-DD');
      const toDate = this.state.ToDate
        ? this.formatDate(this.state.ToDate)
        : moment().format('YYYY-MM-DD');
      const days = this.state.days;

      // if (fromDate == null) {
      //   fromDate = '1900-01-01';
      // }
      // if (toDate == null) {
      //   toDate = '3000-01-01';
      // }
          
      let filterParams = "";
      // if (isOCM) {
      //   const filterPaires = [];
      //   _.forOwn(this.state.salesOrders.filters, (value, key) => {
      //     filterPaires.push([key, value.filterTerm].join('='))
      //   });
      //   filterParams = filterPaires.join('&');
      // }
      const productNum = this.state.filterProductID;
      this.props.fetchSalesQuotesByFilterLap(
        fromDate,
        toDate,
        this.state.days,
        this.state.Status,
        seller,
        productNum,
        route,
        null,
        null,
        null,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.state.Type,
        filterParams
      );
    }

    if (
      nextProps.shippingListPDF &&
      nextProps.shippingListPDF !== this.props.shippingListPDF
    ) {
      this.setState({ shippingPdfFrameLoaded: false });
    }

    if (
      nextProps.pickingListPDF &&
      nextProps.pickingListPDF !== this.props.pickingListPDF
    ) {
      this.setState({ pickingListPdfFrameLoaded: false });
    }

    if (
      nextProps.packingListPDF &&
      nextProps.packingListPDF !== this.props.packingListPDF
    ) {
      this.setState({ packingListPdfFrameLoaded: false });
    }

    if (
      nextProps.salesOrderPDF &&
      nextProps.salesOrderPDF !== this.props.salesOrderPDF
    ) {
      if (isLAP && this.state.salesOrders && this.state.salesOrders.selectedRows && this.state.salesOrders.selectedRows.length > 0) {
        let a = document.createElement("a");
        a.style = "display: none";
        document.body.appendChild(a);
        let url = window.URL.createObjectURL(nextProps.salesOrderPDF);
        a.href = url;
        a.download = this.state.salesOrders.selectedRows[0].SQNum;
        a.click();
        window.URL.revokeObjectURL(url);
      } else {
      this.setState({ salesOrderPdfFrameLoaded: false });
      }
    }
    if (nextProps.bolIdPDF && nextProps.bolIdPDF !== this.props.bolIdPDF) {
      this.setState({ bolIdPdfFrameLoaded: false });
    }
    if (nextProps.bolWithoutLogPDF && nextProps.bolWithoutLogPDF !== this.props.bolWithoutLogPDF) {
      this.setState({ bolWithoutLogPdfFrameLoaded: false });
    }
    if (nextProps.bolLabel && nextProps.bolLabel !== this.props.bolLabel) {
      this.setState({ bolLabelFrameLoaded: false });
    }
    if (nextProps.bolFbaPDF && nextProps.bolFbaPDF !== this.props.bolFbaPDF) {
      this.setState({ bolFbaPdfFrameLoaded: false });
    }
    if (nextProps.currentPage && nextProps.currentPage !== this.props.currentPage) {
      this.setState({ currentPage: nextProps.currentPage });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      nextState.shippingPdfFrameLoaded !== this.state.shippingPdfFrameLoaded &&
      this.state.shippingPdfFrameLoaded === false
    ) {
      return false;
    }
    if (
      nextState.pickingListPdfFrameLoaded !==
        this.state.pickingListPdfFrameLoaded &&
      this.state.pickingListPdfFrameLoaded === false
    ) {
      return false;
    }
    if (
      nextState.packingListPdfFrameLoaded !==
        this.state.packingListPdfFrameLoaded &&
      this.state.packingListPdfFrameLoaded === false
    ) {
      return false;
    }
    if (
      nextState.salesOrderPdfFrameLoaded !==
        this.state.salesOrderPdfFrameLoaded &&
      this.state.salesOrderPdfFrameLoaded === false
    ) {
      return false;
    }
    if (
      nextState.bolIdPdfFrameLoaded !== this.state.bolIdPdfFrameLoaded &&
      this.state.bolIdPdfFrameLoaded === false
    ) {
      return false;
    }
    if (
      nextState.bolWithoutLogPdfFrameLoaded !== this.state.bolWithoutLogPdfFrameLoaded &&
      this.state.bolWithoutLogPdfFrameLoaded === false
    ) {
      return false;
    }
    if (
      nextState.bolLabelFrameLoaded !== this.state.bolLabelFrameLoaded &&
      this.state.bolLabelFrameLoaded === false
    ) {
      return false;
    }

    if (
      nextState.bolFbaPdfFrameLoaded !== this.state.bolFbaPdfFrameLoaded &&
      this.state.bolFbaPdfFrameLoaded === false
    ) {
      return false;
    }

    return true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.salesOrders !== this.state.salesOrders) {
      let canceledTotal = 0;
      let totalNetWeight = 0;
      let totalCancelledNetWeight = 0;
      const canceledOrders = this.state.salesOrders.rows.filter((row) => {
        const match = row.SaleStatus === "Canceled";
        totalNetWeight += row.FinalNetWeight;
        if (match) {
          canceledTotal += row.FinalPrice;
          totalCancelledNetWeight += row.FinalNetWeight;
        }
        return match;
      });
      this.setState({
        rowsCount: (this.props.totalRows && isOCM) ? this.props.totalRows : Data.Selectors.getRows(this.state.salesOrders).length,
        canceledOrders: canceledOrders.length,
        canceledTotal,
        totalNetWeight,
        totalCancelledNetWeight,
      });
    }
    if (this.state.salesOrders.selectedRows.length && (this.state.salesOrders.selectedRows !== prevState.salesOrders.selectedRows)) {
      let canceledTotal = 0;
      let total = 0;
      let totalNetWeight = 0;
      let totalCancelledNetWeight = 0;
      const canceledOrders = this.state.salesOrders.selectedRows.filter((row) => {
        const match = row.SaleStatus === "Canceled";
        if (match) {
          canceledTotal += row.FinalPrice;
          totalCancelledNetWeight += row.FinalNetWeight;
        }
        return match;
      });
      _.forEach(this.state.salesOrders.selectedRows, row => {
        total += row.FinalPrice;
        totalNetWeight += row.FinalNetWeight;
      })
      this.setState({
        // rowsCount: Data.Selectors.getRows(this.state.salesOrders).length,
        canceledOrders: canceledOrders.length,
        canceledTotal,
        total,
        totalNetWeight,
        totalCancelledNetWeight
      });
    }
    if ((this.state.salesOrders.selectedRows.length === 0) && (prevState.salesOrders.selectedRows.length !== 0)) {
      let canceledTotal = 0;
      let total = 0;
      let totalNetWeight = 0;
      let totalCancelledNetWeight = 0;

      const canceledOrders = this.state.salesOrders.rows.filter((row) => {
        const match = row.SaleStatus === "Canceled";
        if (match) {
          totalCancelledNetWeight += row.FinalNetWeight
          canceledTotal += row.FinalPrice;
        }
        return match;
      });
      _.forEach(this.state.salesOrders.rows, row => {
        total += row.FinalPrice;
        totalNetWeight += row.FinalNetWeight
      })
      this.setState({
        // rowsCount: Data.Selectors.getRows(this.state.salesOrders).length,
        canceledOrders: canceledOrders.length,
        canceledTotal,
        total,
        totalNetWeight,
        totalCancelledNetWeight,
      });
    }
    if (prevState.currentPage !== prevProps.currentPage) {
      this.props.setSalesOrdersPaginationFilter({currentPage: prevState.currentPage})
    }
  }

  setDriverListModalVisibility = (driverListModalVisibility = false) =>
    this.setState({ driverListModalVisibility });
  handleAssignSOToDriverSuccess = () => {
    this.setDriverListModalVisibility();
    this.fetchSalesOrdersByDetails(this.state.days);
  };
  setISAEditModalVisibility = (isaEditModalVisibility = false) => this.setState({ isaEditModalVisibility });
  setCTNEditModalVisibility = (ctnEditModalVisibility = false) => this.setState({ ctnEditModalVisibility });

  handleISANoUpdateSuccess = () => {
    this.setISAEditModalVisibility();
    this.fetchSalesOrdersByDetails(this.state.days);
  }

  openPridePrint = () => {
    this.setState({ pridePrintVisibility: true });
  }
  closePridePrint = () => {
    this.setState({ pridePrintVisibility: false });
  }
  onConfirmPridePrint = () => {
    const {
      selectedRows,
    } = this.state.salesOrders;

    const salesQuote_id = [];
    selectedRows.forEach(({ SalesQuote_id }) => {
      salesQuote_id.push(SalesQuote_id);
    });
    this.props.printSalesOrderLabelUSPride({ salesQuote_id });
    this.closePridePrint();
  }

  handleCTNNoUpdateSuccess = () => {
    this.setCTNEditModalVisibility();
    this.fetchSalesOrdersByDetails(this.state.days);
  }
  openDavisPO = () => {
    this.setState({ davisPOVisibility: true });
  };
  closeDavisPO = () => {
    this.setState({ davisPOVisibility: false });
  };
  onConfirmDavisPO() {
    const { salesOrders } = this.state;
    if (
      salesOrders &&
      salesOrders.selectedRows &&
      salesOrders.selectedRows[0]
    ) {
      this.props.setDavisPO(salesOrders.selectedRows[0].SalesQuote_id);
    }
    this.setState({ davisPOVisibility: false });

    // const route = this.context.router.routes[1].path;
    // const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
    // const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
    // const days = this.state.days;
    // const productNum = this.state.filterProductID;
    // const seller = this.props.Seller;
    // setTimeout(() => {
    //   this.props.fetchSalesQuotesByFilterLap(fromDate, toDate, days, this.state.Status, seller, productNum, route);
    // }, 1000);
  }

  openChowbusModal = () => {
    this.setState({ chowbusModalVisibility: true });
  };
  closeChowbusModal = () => {
    this.setState({ chowbusModalVisibility: false, chowbusImportFile: null });
  };
  onChangeChowbusImport = (event) => {
    this.setState({ chowbusImportFile: event.target.files[0] });
  };
  onConfirmChowbusImport() {
    if (!this.state.chowbusImportFile) {
      alert("Please select a file to import");
      return;
    }
    const data = new FormData();
    data.append("file", this.state.chowbusImportFile);
    this.props.chowbusImport(data).then(
      (response) => {
        alert("Chowbus Orders Imported");
        this.closeChowbusModal();
      },
      (err) => {
        alert("Import Error:" + err.data);
      },
    );
  }

  openVoidNote = () => {
    this.setState({ voidNoteModalVisibility: true });
  };
  closeVoidNote = () => {
    this.setState({
      voidNoteModalVisibility: false,
      voidReason: "",
      voidNote: "",
    });
  };
  onVoidReasonChange = (e) => {
    this.setState({ voidReason: e.value });
  };
  onVoidNoteChange = (e) => {
    this.state.voidNote = e.target.value;
  };
  onConfirmVoidNote() {
    const salesQuote_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesQuote_id;
    let voidString = "";
    if (this.state.voidReason) {
      voidString = this.state.voidReason + ": ";
    }
    voidString += this.state.voidNote;
    this.props.updateVoidNote(salesQuote_id, voidString);
    setTimeout(() => {
      this.voidOrder();
    }, 1000);
    this.closeVoidNote();
  }

  closePrintTrackingConfirm = () => {
    this.setState({ printTrackingConfirmOpen: false });
  };
  openPrintTrackingConfirm = () => {
    this.setState({ printTrackingConfirmOpen: true });
  };
  printTrackingConfirm = () => {
    const { trackingNumberSelected } = this.state;
    this.props.printSalesOrderLabelBatch(trackingNumberSelected);
    this.setState({ printTrackingConfirmOpen: false });
  };

  openDisplayTracking() {
    this.setState({ displayTrackingOpen: true });
  }
  closeDisplayTracking() {
    this.setState({ displayTrackingOpen: false });
  }

  openChangeWeight() {
    this.setState({
      changeWeightOpen: true,
      finalShippingWeight: this.state.salesOrders.selectedRows[0]
        .FinalShippingWeight,
    });
  }

  openbolListModal() {
    this.setState({ bolListModalVisibility: true });
  }
  closebolListModal() {
    this.setState({ bolListModalVisibility: false });
  }

  openDSQPrint() {
    this.setState({ dsqPrintVisibility: true });
  }
  closeDSQPrint() {
    this.setState({ dsqPrintVisibility: false });
  }

  openWIZPOD() {
    this.setState({ wizPODVisibility: true });
  }
  closeWIZPOD() {
    this.setState({ wizPODVisibility: false });
  }

  openGenerateBOLModal() {
    this.setState({ generateBOLModalVisibility: true });
  }
  closeGenerateBOLModal() {
    this.setState({ generateBOLModalVisibility: false });
  }

  openChangePaymentMethodModal() {
    this.setState({
      paymentMethodModalVisibility: true,
    });
  }
  closePaymentMethodModal() {
    this.setState({
      paymentMethodModalVisibility: false,
    });
  }
  
  openChangeShipMethodModal() {
    this.setState({ shipMethodModalVisibility: true });
  }
  closeChangeShipMethodModal() {
    this.setState({ shipMethodModalVisibility: false });
  }
  handleSOShipMethodSaved = () => {
    this.closeChangeShipMethodModal();
    this.refreshSOList();
  };
  
  openChangeShipQtyModal(id) {
    this.setState({ changeShipQtyId: id, shipQtyModalVisibility: true });
  }
  closeChangeShipQtyModal() {
    this.setState({ changeShipQtyId: null, shipQtyModalVisibility: false });
  }
  
  handleSOShipQtySaved = () => {
    this.closeChangeShipQtyModal();
    this.refreshSOList();
  };
  
  handleSOPaymentMethodSaved = (so_id, method) => {
    this.closePaymentMethodModal();
    const salesOrderRows = [...this.state.salesOrders.rows];
    const newRows = salesOrderRows.map((row) => {
      if (row.SalesQuote_id === so_id) {
        return {
          ...row,
          PaymentType: method,
        };
      }
      return row;
    });
    this.setState({
      salesOrders: {
        ...this.state.salesOrders,
        rows: newRows,
      },
    });
    // const route = this.context.router.routes[1].path;
    // const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
    // const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
    // const days = this.state.days;
    // const productNum = this.state.filterProductID;
    // const seller = this.props.Seller;
    // setTimeout(() => {
    //   this.props.fetchSalesQuotesByFilterLap(fromDate, toDate, days, this.state.Status, seller, productNum, route);
    // }, 1000);
  };

  closeChangeWeight() {
    this.setState({ changeWeightOpen: false });
  }
  onChangeWeightSubmit = (splitArray) => {
    const salesQuote_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesQuote_id;
    this.props.updateShippingWeightSplit(salesQuote_id, splitArray);
    this.setState({ changeWeightOpen: false });
    const route = this.context.router.routes[1].path;
    const fromDate = this.state.FromDate
      ? this.formatDate(this.state.FromDate)
      : moment().format('YYYY-MM-DD');
    const toDate = this.state.ToDate
      ? this.formatDate(this.state.ToDate)
      : moment().format('YYYY-MM-DD');
    const days = this.state.days;
    const productNum = this.state.filterProductID;
    const seller = this.props.Seller;
    setTimeout(() => {
      this.props.fetchSalesQuotesByFilterLap(
        fromDate,
        toDate,
        days,
        this.state.Status,
        seller,
        productNum,
        route,
        null,
        null,
        null,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.state.Type,
      );
    }, 1000);
  };
  onChangeWeightSubmitPrint = (splitArray) => {
    const salesQuote_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesQuote_id;
    if (
      this.state.salesOrders.selectedRows[0].InvoiceNum === "" ||
      !this.state.salesOrders.selectedRows[0].InvoiceNum
    ) {
      alert("Cannot print without Invoice Number");
      return;
    }
    this.props.updateShippingWeightSplit(salesQuote_id, splitArray);
    this.setState({ changeWeightOpen: false });
    const route = this.context.router.routes[1].path;
    const fromDate = this.state.FromDate
      ? this.formatDate(this.state.FromDate)
      : moment().format('YYYY-MM-DD');
    const toDate = this.state.ToDate
      ? this.formatDate(this.state.ToDate)
      : moment().format('YYYY-MM-DD');
    const days = this.state.days;
    const productNum = this.state.filterProductID;
    const seller = this.props.Seller;
    this.props.fetchSalesQuotesByFilterLap(
      fromDate,
      toDate,
      days,
      this.state.Status,
      seller,
      productNum,
      route,
      null,
      null,
      null,
      this.state.limit,
      this.state.currentPage,
      this.state.searchFilter,
      this.state.Type,
    );
    const SalesQuote_id = [];
    SalesQuote_id.push(salesQuote_id);
    setTimeout(() => {
      this.props.printSalesOrderLabelBatch(SalesQuote_id);
    }, 1000);
  };

  onShippingWeightChange = (e) => {
    this.setState({
      finalShippingWeight: e.target.value,
    });
  };

  openConfirmReship() {
    this.setState({ confirmReshipOpen: true });
  }
  closeConfirmReship() {
    this.setState({ confirmReshipOpen: false });
  }
  onConfirmReship() {
    const salesQuote_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesQuote_id;
    this.props.reshipOrder(salesQuote_id);
    this.setState({ confirmReshipOpen: false });
  }

  // USPride create with excel modal
  openUSPrideCreate() {
    this.setState({USPrideCreateOpen: true });
  }
  closeUSPrideCreate() {
    this.setState({ USPrideCreateOpen: false });
  }
  onUSPridePlatformChange = (e) => {
    this.setState({ USPridePlatform: e.value });
  };

  openPicker() {
    this.setState({PickerOpen: true });
  }
  closePicker() {
    this.setState({ PickerOpen: false });
  }
  onPickerChange = (e) => {
    this.setState({ SelectedPicker: e.value });
  };

  openConfirmQuote() {
    const { salesOrders } = this.state;
    const { customers, warehouses} = this.props;
    let quoteSelectedCustomerId = null;
    let quoteSelectedCustomerName = "";
    let quoteSelectedWarehouseId = null;
    let quoteSelectedCustomerPlaceholder = "";
    let quoteSelectedWarehousePlaceholder = "";
    let quoteSelectedShipping = null;
    let quoteSelectedShippingPH = '';
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        quoteSelectedCustomerId = salesOrder.Deliver_Customer_id;
        if (isABBLE && !quoteSelectedCustomerId) {
          quoteSelectedCustomerId = salesOrder.Deliver_Customer_id_id;
        }
        quoteSelectedCustomerName = salesOrder.Deliver_CustomerName;
        quoteSelectedCustomerPlaceholder = salesOrder.Deliver_CustomerName;
        
        const warehouseFilter = warehouses.filter(w => w.id === salesOrder.Pickup_Warehouse_id_id);
        if (warehouseFilter.length > 0 ) {
          quoteSelectedWarehouseId = warehouseFilter[0].Pickup_Warehouse_id_id;
          quoteSelectedWarehousePlaceholder = warehouseFilter[0].name;
        }
        quoteSelectedShipping = salesOrder.Deliver_CustomerDetail_id;
        // Deliver_CustomerDetail_id //Deliver_Customer_id //Deliver_CustomerName
      });
    }
    let quoteCustomerOptions = [];
    let quoteWarehouseOptions = [];
    
    if (customers) {
      customers.map((r) => {
        quoteCustomerOptions.push({ label: r.Name, value: r.Customer_id });
      });
    }
    
    if (warehouses) {
      warehouses.map((r) => {
        quoteWarehouseOptions.push({ label: r.Name, value: r.Warehouse_id });
      });
    }
    this.props.fetchSalesCustomerDetail(quoteSelectedCustomerId, null, true, (response) => {
      _.forEach(response.data.Shipping, shipping => {
        if (shipping.CustomerDetail_id === quoteSelectedShipping) {
          quoteSelectedShippingPH = [shipping.Street, shipping.City, shipping.State, shipping.Zip].join(', ');
        }
      })
      this.setState({
        confirmQuoteOpen: true,
        quoteSelectedCustomerId,
        quoteSelectedCustomerName,
        quoteCustomerOptions,
        quoteWarehouseOptions,
        quoteSelectedCustomerPlaceholder,
        quoteSelectedWarehousePlaceholder,
        quoteSelectedShipping,
        quoteSelectedShippingPH,
      });
      this.props.setValue("salesQuotes", "hmmCustomer", "");
      this.props.setValue("salesQuotes", "hmmWarehouse", "");
      
    });
  }
  closeConfirmQuote() {
    this.setState({ confirmQuoteOpen: false });
  }
  onQuoteCustomerChange = (e) => {
    this.props.fetchSalesCustomerDetail(e.value, false, true);
    this.props.setValue('salesQuotes', 'customerShipping', '');
    if (e) {
      this.setState({
        quoteSelectedCustomerId: e.value,
        quoteSelectedCustomerName: e.label,
        quoteSelectedShipping: null,
        quoteSelectedShippingPH: ''
      });
    } else {
      this.setState({
        quoteSelectedCustomerId: null,
        quoteSelectedCustomerName: "",
        quoteSelectedShipping: null,
        quoteSelectedShippingPH: ''
      });
    }
  };
  
  onQuoteWarehouserChange = (e) => {
    if (e) {
      this.setState({
        quoteSelectedWarehouseId: e.value,
      });
    } else {
      this.setState({
        quoteSelectedWarehouseId: null,
      });
    }
  };
  
  onQuoteShippingChange = (e) => {
    if (e) {
      this.setState({
        quoteSelectedShipping: e.value,
        quoteSelectedShippingPH: e.label,
      });
    } else {
      this.setState({
        quoteSelectedShipping: null,
        quoteSelectedShippingPH: "",
      });
    }
  }
  onConfirmQuote() {
    const { salesOrders, quoteSelectedCustomerId, quoteSelectedWarehouseId, quoteSelectedShipping } = this.state;
    const salesOrderIds = [];
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesQuote_id);
      });
    }
    if (isESC) {
      this.props.setQuoteOrderForEsc(salesOrderIds.join(","), quoteSelectedCustomerId, quoteSelectedWarehouseId, quoteSelectedShipping);
    } else {
      this.props.setQuoteOrder(salesOrderIds.join(","), quoteSelectedCustomerId, quoteSelectedWarehouseId, quoteSelectedShipping);
    }
    this.setState({ confirmQuoteOpen: false });
    const route = this.context.router.routes[1].path;
    const fromDate = this.state.FromDate
      ? this.formatDate(this.state.FromDate)
      : moment().format('YYYY-MM-DD');
    const toDate = this.state.ToDate
      ? this.formatDate(this.state.ToDate)
      : moment().format('YYYY-MM-DD');
    const days = this.state.days;
    const productNum = this.state.filterProductID;
    const seller = this.props.Seller;

        
    let filterParams = "";
    // if (isOCM) {
    //   const filterPaires = [];
    //   _.forOwn(salesOrders.filters, (value, key) => {
    //     filterPaires.push([key, value.filterTerm].join('='))
    //   });
    //   filterParams = filterPaires.join('&');
    // }

    setTimeout(() => {
      this.props.fetchSalesQuotesByFilterLap(
        fromDate,
        toDate,
        days,
        this.state.Status,
        seller,
        productNum,
        route,
        null,
        null,
        null,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.state.Type,
        filterParams,
      );
    }, 1000);
  }

  setPendingConfirmModalVisibility = (confirmQuotePending = false) => this.setState({ confirmQuotePending });
  setQuoteConfirmModalVisibility = (confirmOpenToQuote = false) => this.setState({ confirmOpenToQuote });
  openShowDriverImage() {
    this.setState({ showDriverImageOpen: true });
  }
  closeShowDriverImage() {
    this.setState({ showDriverImageOpen: false });
  }
  openSignatureImage() {
    this.setState({ showSignatureImageOpen: true });
  }
  closeSignatureImage() {
    this.setState({ showSignatureImageOpen: false });
  }

  openSubmitImage() {
    this.setState({ submitImageOpen: true });
  }
  closeSubmitImage() {
    this.setState({ submitImageOpen: false });
  }
  onSubmitImage(successCallback) {
    const salesQuote_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesQuote_id;
    this.props.submitBolImage(salesQuote_id, this.state.file);
    this.setState({ submitImageOpen: false });
  }

  openPrintBol() {
    this.setState({ printBolOpen: true });
  }
  closePrintBol() {
    this.setState({ printBolOpen: false });
  }
  onChangeBolAddress = (address) => {
    this.setState({ bolAddressFBA: address.value });
  };

  openChangePullSheet() {
    this.setState({ changePullSheetOpen: true });
  }
  closeChangePullSheet() {
    this.setState({ changePullSheetOpen: false });
  }
  onChangePullSheetSubmit() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows.length > 1) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesQuote_id);
      });
    }
    if (
      this.state.pullSheetAmount < 0 ||
      this.state.pullSheetAmount > salesOrders.selectedRows.length
    ) {
      alert("Invalid Value!");
      return;
    }
    this.props.printPickingListAFG(
      salesOrderIds.join(","),
      this.state.pullSheetAmount,
      this.state.pullSheetSort,
    );
    this.state.pullSheetAmount = null;
    this.setState({ changePullSheetOpen: false });
    // this.context.router.push(`/${this.context.router.routes[1].path}`);
  }
  onPullSheetChange = (e) => {
    this.state.pullSheetAmount = e.target.value;
  };

  handleResize() {
    this.setState({
      tableHeight: window.innerHeight - UI_HEIGHT.fiveLineButton,
    });
  }

  handleOptionChange = (changeEvent) => {
    this.setState({ productSearchType: changeEvent.target.value });
  };

  // Set product being selected to be currentProduct and navigate user to the edit page
  setCurrentSalesOrder(e) {
    e.preventDefault();
    this.setState({ clear: false });
    const currentSalesOrderId = this.state.salesOrders.selectedRows[0]
      .SalesQuote_id;
    const salesOrders = this.state.salesOrders.rows.filter((row) => {
      const match = row.SalesQuote_id === currentSalesOrderId;
      return match;
    });

    const FromDate = this.state.FromDate;
    const ToDate = this.state.ToDate;
    this.props.resetCurrentSalesOrder();

    this.props.selectSalesOrder(salesOrders[0]);
    const currentRows = Data.Selectors.getRows(this.state.salesOrders);
    const route = this.context.router.routes[1].path;
    this.props.setSalesOrdersFilter({
      Days: this.state.days,
      FromDate,
      ToDate,
      Status: this.state.Status,
      Seller: this.props.Seller,
      ProductNum: this.props.ProductNum,
      currentRows,
      currentPage: route,
    });
    // this.context.router.push('/salesOrders/'+currentSalesOrder.SalesQuote_id);
    this.context.router.push(
      `/${this.context.router.routes[1].path}/${currentSalesOrderId}`
    );
  }

  checkAuthorize(password) {
    this.props.checkPassword(password);
  }

  openCheckAuthorize(action) {
    this.props.clearCheckPassword();
    this.setState({ checkAuthorizeOpen: true, action });
  }

  closeCheckAuthorize() {
    this.setState({ checkAuthorizeOpen: false });
  }

  clickNew(e) {
    e.preventDefault();
    this.props.resetCurrentSalesOrder();
    // this.context.router.push('/salesOrders/new')
    this.context.router.push(`/${this.context.router.routes[1].path}/new`);
  }

  voidOrder() {
    let newRows = this.state.salesOrders.rows;
    this.state.salesOrders.selectedRows.map((row) => {
      this.props.voidSalesQuoteLap(
        row.SalesQuote_id,
        this.context.router.routes[1].path
      );
      newRows = newRows.filter((obj) => obj !== row);
      const salesOrders = { ...this.state.salesOrders, rows: newRows };
      this.setState({ salesOrders });
    });
  }

  shouldVoidButtonDisable() {
    const { selectedRows } = this.state.salesOrders;

    // Always disable void if selected more than 1 row
    if (selectedRows.length !== 1) {
      return true;
    }

    const status = selectedRows[0] ? selectedRows[0].SaleStatus : "disable";
    const disabled =
      status === "Canceled" ||
      status === "Refunded" ||
      status === "Partially Refunded" ||
      status === "Finalized" ||
      status === "Released" ||
      status === "disable";
    return disabled;
  }

  shouldQuoteButtonDisable() {
    const { selectedRows } = this.state.salesOrders;
    if (selectedRows.length !== 1) {
      return true;
    }
    const status = selectedRows[0] ? selectedRows[0].SaleStatus : "disable";
    const disabled =
      status === "Canceled" ||
      status === "Refunded" ||
      status === "Partially Refunded" ||
      status === "Finalized" ||
      status === "Released" ||
      status === "Packing" ||
      status === "disable";
    return disabled;
  }

  printForm(e) {
    e.preventDefault();
  }

  loadsPost() {
    this.props.loadsPost(this.state.salesOrders.selectedRows[0].SalesQuote_id);
  }

  quoteConversion = () => {
    const route = this.context.router.routes[1].path;
    const status = this.state.salesOrders.selectedRows[0].SaleStatus;
    const id = this.state.salesOrders.selectedRows[0].SalesQuote_id;

        
    let filterParams = "";
    // if (isOCM) {
    //   const filterPaires = [];
    //   _.forOwn(this.state.salesOrders.filters, (value, key) => {
    //     filterPaires.push([key, value.filterTerm].join('='))
    //   });
    //   filterParams = filterPaires.join('&');
    // }

    if (status === "Open") {
      this.props.orderToQuote(id).then(() => {
        const seller = this.props.Seller;
        const fromDate = this.state.FromDate
          ? this.formatDate(this.state.FromDate)
          : moment().format('YYYY-MM-DD');
        const toDate = this.state.ToDate
          ? this.formatDate(this.state.ToDate)
          : moment().format('YYYY-MM-DD');
        const days = this.state.days;
        const productNum = this.state.filterProductID;
        this.props.fetchSalesQuotesByFilterLap(
          fromDate,
          toDate,
          days,
          this.state.Status,
          seller,
          productNum,
          route,
          null,
          null,
          null,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.state.Type,
          filterParams,
        );
      });
    } else if (status === "Quote") {
      this.props.quoteToOrder(id).then(() => {
        const seller = this.props.Seller;
        const fromDate = this.state.FromDate
          ? this.formatDate(this.state.FromDate)
          : moment().format('YYYY-MM-DD');
        const toDate = this.state.ToDate
          ? this.formatDate(this.state.ToDate)
          : moment().format('YYYY-MM-DD');
        const days = this.state.days;
        const productNum = this.state.filterProductID;
        this.props.fetchSalesQuotesByFilterLap(
          fromDate,
          toDate,
          days,
          this.state.Status,
          seller,
          productNum,
          route,
          null,
          null,
          null,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.state.Type,
          filterparams,
        );
      });
    }
  };

  quoteButton = () => (
    <Button
      bsStyle="success"
      type="reset"
      disabled={this.shouldQuoteButtonDisable()}
      onClick={() => {
        this.quoteConversion();
      }}
    >
      <Translate value={this.state.title} />
    </Button>
  );

  handleSalesStatusClick = (row) => {
    this.setState({
      monitorRow: row,
    }, () => {
      if (row.IsMonitor) {
        this.setCancelMonitorModalVisibility(true);
      } else {
        this.setMonitorNoteModalVisibility(true);
      }
    });
  }

  setMonitorNoteModalVisibility = (isMonitorNoteModalVisible = false) => this.setState({ isMonitorNoteModalVisible });
  handleMonitorOrderSuccess = () => {
    this.setMonitorNoteModalVisibility();
    this.setCancelMonitorModalVisibility();
    this.refreshSOList();
  }

  setCancelMonitorModalVisibility = (isCancelMonitorModalVisible = false) => this.setState({ isCancelMonitorModalVisible });


  // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
  renderTable() {
    const route = this.context.router.routes[1].path;
    const isMobile = route === "mobileSalesOrders";
    if (this.props.isLoading && !this.props.error && !isOCM) return <WidgetsSpinner />;
    // else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>;

    // Parameters of the react-data-grid
    let tableHeight = window.innerHeight < 930 ? 270 : 270;
    if (isABC) {
      tableHeight = window.innerHeight < 930 ? 800 : 800;
    }
    const getRows = () => Data.Selectors.getRows(this.state.salesOrders);
    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      let rows = getRows();

      // if (isABBLE) {
      //   rows.map((r,i)=>{
      //     if (!r.Tracking && r.TTracking) {
      //       rows[i].Tracking = rows[i].TTracking;
      //     } else if (!r.Tracking && !r.TTracking) {
      //       rows[i].Tracking = "";
      //     } else {
      //
      //     }
      //   })
      //   rows.map((r,i)=>{
      //     if (!r.carrierName && r.Carrier) {
      //       rows[i].carrierName = rows[i].Carrier;
      //     } else if (!r.carrierName && !r.Carrier) {
      //       rows[i].Tracking = "";
      //     } else {
      //
      //     }
      //   })
      // }

      // this.state.total = 0;
      // for (let i = 0; i < rows.length; i++) {
      //   this.state.total += rows[i].FinalPrice;
      // }
      return rows[rowIdx];
    };

    const onTrackingNumRouter = (trackingNum) => {
      const url =
        "https://www.fedex.com/apps/fedextrack/?tracknumbers=" + trackingNum;
      let win = window.open(url);
      if (win != null) {
        win.focus();
      }
    };

    const onClearFilters = () => {
      // all filters removed
      const salesOrders = { ...this.state.salesOrders, filters: {} };
      this.setState({ salesOrders }, () => {
        // if (isOCM) {
        //   handleOnPageChange({
        //     selected: 0,
        //   })
        // }
      })
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      if (isOCM) {
        // const route = this.context.router.routes[1].path;
        // let filterParams = "";
        // const filterPaires = [];
        // _.forOwn(this.state.salesOrders.filters, (value, key) => {
        //   filterPaires.push([key, value.filterTerm].join('='))
        // });
        // filterParams = filterPaires.join('&');
        // if (['ASC', 'DESC'].includes(sortDirection)) {
        //   const key = getKeysMap(sortColumn, SALES_ORDER_SORT_KEY_OBJ);
        //   const sort = getSortVal(key,sortDirection === "DESC");
        //   filterParams += `&sort=${sort}`;
        // }
        //
        // this.props.fetchSalesQuotesByFilterLap(
        //   this.state.FromDate,
        //   this.state.ToDate,
        //   this.state.days,
        //   this.state.Status,
        //   null,
        //   null,
        //   route,
        //   this.state.dispatchDateLT,
        //   this.state.dispatchDateGT,
        //   null,
        //   this.state.limit,
        //   this.state.currentPage,
        //   this.state.searchFilter,
        //   this.state.Type,
        //   filterParams,
        // );
      } else {
        const state = Object.assign({}, this.state.salesOrders, {
          sortColumn,
          sortDirection,
        });
        if (state.sortColumn === "OrderDateDisplay") {
          state.sortColumn = "OrderDate";
        }

        if (state.sortDirection === "ASC") {
          this.state.pullSheetSort = state.sortColumn;
        } else if (state.sortDirection === "DESC") {
          this.state.pullSheetSort = `-${state.sortColumn}`;
        } else {
          this.state.pullSheetSort = "";
        }
        this.setState({ salesOrders: state });
      }
    };

    const handleFilterChange = debounce(
      (filter) => {
        this.state.total = 0;
        this.state.salesOrders.rows = this.props.salesOrders.Quotes;
        this.state.salesOrders.selectedRows = [];
        let filterParams = "";
        const newFilters = Object.assign({}, this.state.salesOrders.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const salesOrders = { ...this.state.salesOrders, filters: newFilters };
        this.setState({ salesOrders }, () => {
          if (filter.column.key === "SQNum" || filter.column.key === "InvoiceNum" || filter.column.key === "Deliver_Customer_num" || filter.column.key === "Deliver_CustomerName" || filter.column.key === "Sales_User_Name" || filter.column.key === "PONum") {
            handleOnPageChange({
              selected: 0
            })
          }
        });
      },
      500,
      { maxWait: 800 },
    );

    // Handle the row select function
    const onRowClick = (rowIdx, row) => {
      if (rowIdx !== -1) {
        const rows = getRows();
        /* Multi row select on row click
          let selectedRows = [...this.state.salesOrders.selectedRows];

          let id = rows[rowIdx].SalesQuote_id;
          let idx = selectedRows.indexOf(id);
          if (idx == -1) {
            rows[rowIdx].isSelected = true;
            selectedRows.push(id);
          } else {
            rows[rowIdx].isSelected = false;
            selectedRows.splice(idx, 1);
          }
        */

        /* Single row select on row click */
        rows.map((r) => {
          r.isSelected = false;
        });
        const selectedRows = [rows[rowIdx]];
        rows[rowIdx].isSelected = true;

        const salesOrders = { ...this.state.salesOrders, rows, selectedRows };
        this.setState({ salesOrders });
        this.props.fetchSalesQuoteDetailLap(row.SalesQuote_id, route, this.state.Status);
      }
    };


    const handleLimitChange = (el) => {
      this.state.currentPage = 0;
      this.state.limit = el.value;
      this.state.limitDisplay = el.label;
      const route = this.context.router.routes[1].path;

      let salesOrders = {
        ...this.state.salesOrders,
        selectedRows: [],
      };
      this.setState({ salesOrders });

          
      let filterParams = "";
      // if (isOCM) {
      //   const filterPaires = [];
      //   _.forOwn(salesOrders.filters, (value, key) => {
      //     filterPaires.push([key, value.filterTerm].join('='))
      //   });
      //   filterParams = filterPaires.join('&');
      // }
      // salesOrders: {
      //   rows: [],
      //   selectedRows: [],
      //   filters: {},
      //   sortColumn: null,
      //   sortDirection: null,
      // },


      this.props.fetchSalesQuotesByFilterLap(
        this.state.FromDate,
        this.state.ToDate,
        this.state.days,
        this.state.Status,
        null,
        null,
        route,
        this.state.dispatchDateLT,
        this.state.dispatchDateGT,
        null,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.state.Type,
        filterParams,
      );
      // this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    }

    const handleOnPageChange = (data) => {
      this.state.currentPage = data.selected;

      const route = this.context.router.routes[1].path;
      let filterParams = "";
      let salesOrders = {
        ...this.state.salesOrders,
        selectedRows: [],
        rows: [],
      };
      // if (isOCM) {
      //   const filterPaires = [];
      //   _.forOwn(salesOrders.filters, (value, key) => {
      //     filterPaires.push([key, value.filterTerm].join('='))
      //   });
      //   filterParams = filterPaires.join('&');
      // }
      this.setState({ salesOrders });
      this.props.fetchSalesQuotesByFilterLap(
        this.state.FromDate,
        this.state.ToDate,
        this.state.days,
        this.state.Status,
        null,
        null,
        route,
        this.state.dispatchDateLT,
        this.state.dispatchDateGT,
        null,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.state.Type,
        filterParams,
      );

      // this.props.fetchSalesQuotesByFilterLap(
      //   this.state.FromDate,
      //   this.state.ToDate,
      //   this.state.days,
      //   this.state.Status,
      //   seller,
      //   productNum,
      //   route,
      //   this.state.dispatchDateLT,
      //   this.state.dispatchDateGT,
      //   dispatchDays,
      // );

      // this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    }

    const onRowSelect = (rows) => {
      const salesOrders = { ...this.state.salesOrders, selectedRows: rows };
      this.setState({ salesOrders });
    };

    const onCellSelected = (coordinates) => {
      const newRows = getRows();
      /* Multi row select on cell selected
                  let selectedRows = [...this.state.salesOrders.selectedRows];
                  newRows[coordinates.rowIdx].isSelected = true;
                  let id = newRows[coordinates.rowIdx].SalesQuote_id;
                  if (selectedRows.indexOf(id) == -1) {
                      selectedRows.push(id);
                  }
                */
      /* Single row select on cell selected */
      newRows.map((r) => {
        r.isSelected = false;
      });
      const selectedRows = [newRows[coordinates.rowIdx]];
      newRows[coordinates.rowIdx].isSelected = true;
      const salesOrders = {
        ...this.state.salesOrders,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrders });
    };

    const checkLabel = () => {
      const selectedRows = [...this.state.salesOrders.selectedRows];
      if (selectedRows[0].SaleStatus === "Quote") {
        this.setState({
          title: "Open",
        });
      } else if (selectedRows[0].SaleStatus !== "Quote") {
        this.setState({
          title: "Quote",
        });
      }
    };

    const onRowsSelected = (rows) => {
      this.setState({
        scrollTopPositionIndex: rows[0].rowIdx,
      });
      const newRows = getRows();
      const selectedRows = [...this.state.salesOrders.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
        selectedRows.push(r.row);
      });
      const salesOrders = {
        ...this.state.salesOrders,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrders }, () => {
        checkLabel();
      });
    };

    const onRowsDeselected = (rows) => {
      const newRows = [...this.state.salesOrders.rows];
      const selectedRows = [...this.state.salesOrders.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
        const rowIndex = selectedRows.indexOf(r.row);
        selectedRows.splice(rowIndex, 1);
      });
      const salesOrders = {
        ...this.state.salesOrders,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrders, title: "Quote" });
    };

    // Custom Formatter component

    const DateMonthFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const dateMap = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ];
          const date = new Date(this.props.value);
          const index = dateMap.indexOf(date.toString().slice(4, 3));
          const localDate = index + date.toString().slice(8, 6);
          return <span>{date.toString().slice(4, 15)}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    const shippingAddressFormatter = React.createClass({
      render() {
        if (this.props.dependentValues) {
          return (
            <span>{`${this.props.dependentValues.Deliver_CustomerAddress} ${this.props.dependentValues.City} ${this.props.dependentValues.State}`}</span>
          );
        }
        return (
          <span></span>
        );
      },
    });

    const SecondsDateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const date = moment(this.props.value).format("MM-DD-YY HH:mm");
          return <span>{date}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    const YuansferFormatter = React.createClass({
      render() {
        if (this.props.value === "alipay") {
          return <span>Alipay</span>;
        }
        if (this.props.value === "wechatpay") {
          return <span>WeChatPay</span>;
        } else {
          return <span>{this.props.value}</span>;
        }
      },
    });
    // Custom Delivery Time component

    const DeliveryTimeFormatter = React.createClass({
      render() {
        if (this.props.value) {
          let d1 = moment.utc(moment(this.props.value)).local().format("LT");
          let d2 = moment
            .utc(moment(this.props.value))
            .local()
            .subtract(2, "hours")
            .format("MM-DD-YY hh:mm A");
          // This is the old way Julie designed it. Keeping it here in case a new bug is discovered with my alterations.
          // d1 = moment(d1).format("h a");
          // d2 = moment(d2).subtract(2, 'hours').format('MM-DD-YY hh:mm:ss a');
          // d2 = moment(d2).format("h a");

          return <span>{`${d2}-${d1}`}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    const VendorNameFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.Name}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    const VendorNumFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    const InvoiceNumFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    const PromoCodeFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value}</span>;
        return <span>-</span>;
      },
    });

    const soNumWidth =
      this.context.router.routes[1].path === "mobileSalesOrders" ? 145 : 100;

    let finalWeightLBS = <Translate value="total_weight_lb" />;
    // if (isSH) {
    //   finalWeightLBS = <Translate value="total_pcs" />
    // }

    // Column difinition
    const columns = [
      {
        key: "SQNum",
        name: <Translate value="sq_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 115,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "FinalNetWeight",
        name: finalWeightLBS,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "Modifier_User_Name",
        name: <Translate value="modifier" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "Picker_User_Name",
        name: <Translate value="picker" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "IsUnderBuffer",
        name: <Translate value="under_buffer" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => (
          <div style={{ textAlign: 'center', backgroundColor: dependentValues.IsUnderBuffer ? "orange" : "inherit"}}>
            { (value === true || value === 'true') ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        // formatter: SecondsDateFormatter,
      },
      // {
      //   key: "DispatchDate",
      //   name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
      //   resizable: true,
      //   sortable: true,
      //   width: 125,
      //   filterable: true,
      //   formatter: DateMonthFormatter,
      // },
      {
        key: "ExpirDate",
        name: <Translate value={"quote_esp_date"} />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ];

    // if (isOCM) {
    //   const CreateTime = {
    //     key: "CreateTime",
    //     name: <Translate value="modified" />,
    //     resizable: true,
    //     sortable: true,
    //     // width: 50,
    //     // filterable: true,
    //     getRowMetaData: row => row,
    //     formatter: (props) => {
    //       const modified = props.value !== props.dependentValues.UpdateTime;
    //       if (!modified) return <span />
    //       return <span style={{ display:'block', width: '100%', height: '22px', backgroundColor: 'orange' }}></span>
    //     }
    //   };
    //   const CPO = {
    //     key: "PONum",
    //     name: <Translate value="CPO" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   };
    //
    //   const SONumIndex = _.findIndex(columns, { key: 'SQNum' });
    //   const Deliver_Customer_numIdx = _.findIndex(columns, { key: 'Deliver_Customer_num' });
    //
    //   columns.splice(Deliver_Customer_numIdx, 0, CPO);
    //   columns.splice(SONumIndex, 0, CreateTime);
    //
    // }
    //
    // if (isGGI) {
    //   const warehouseCol = {
    //     key: "WarehouseName",
    //     name: <Translate value="warehouse" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 110,
    //     filterable: true,
    //   }
    //   const CPO = {
    //     key: "PONum",
    //     name: <Translate value="CPO" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   }
    //   const file = {
    //     key: "file",
    //     name: <Translate value="file" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 90,
    //     filterable: true,
    //     formatter: (props) => {
    //       if (!props.value) return <span/>
    //       return <a href={props.value}>download</a>
    //     },
    //   }
    //   const IsOverCreditLimit = {
    //     key: "IsOverCreditLimit",
    //     name: <Translate value="exceed_credit_limit" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 130,
    //     // filterable: true,
    //     getRowMetaData: row => row,
    //     formatter: (props) => {
    //       const IsOverCreditLimit = props.value;
    //       if (!IsOverCreditLimit) return <span />
    //       return <span style={{ display:'block', width: '100%', height: '22px', backgroundColor: 'orange' }}></span>
    //     }
    //   }
    //   const IsLowerThanLowestPrice = {
    //     key: "IsLowerThanLowestPrice",
    //     name: <Translate value="lower_then_lowest_price" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     // filterable: true,
    //     getRowMetaData: row => row,
    //     formatter: (props) => {
    //       const IsLowerThanLowestPrice = props.value;
    //       if (!IsLowerThanLowestPrice) return <span />
    //       return <span style={{ display:'block', width: '100%', height: '22px', backgroundColor: 'orange' }}></span>
    //     }
    //   };
    //   const TPO = {
    //     key: "TPONum",
    //     name: <Translate value="TPO" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   }
    //   const FinalPriceIndex = _.findIndex(columns, { key: 'FinalPrice' });
    //   const exceedCreditLimitIndex = _.findIndex(columns, { key: "IsOverCreditLimit" });
    //   const Deliver_CustomerNameIndex = _.findIndex(columns, { key: 'Deliver_CustomerName' });
    //   const SONumIndex = _.findIndex(columns, { key: 'SQNum' });
    //   columns.splice(exceedCreditLimitIndex + 1, 0, warehouseCol);
    //   columns.splice(FinalPriceIndex, 0, file);
    //   columns.splice(Deliver_CustomerNameIndex, 0, CPO, TPO);
    //   columns.splice(SONumIndex, 0, IsOverCreditLimit, IsLowerThanLowestPrice);
    // }
    //
    // if (isABBLE) {
    //   const CPO = {
    //     key: "PONum",
    //     name: <Translate value="CPO" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   }
    //   const Location = {
    //     key: "Location",
    //     name: <Translate value="location" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   }
    //   const carrier = {
    //     key: "carrierName",
    //     name: <Translate value="carrier" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //     getRowMetaData: row => row,
    //     formatter: (props) => {
    //       if (!props.value) {
    //         return <span>{props.dependentValues.Carrier}</span>
    //       } else {
    //         return <span>{props.value}</span>
    //       }
    //     }
    //   };
    //   const tracking = {
    //     key: "Tracking",
    //     name: <Translate value="tracking" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //     getRowMetaData: row => row,
    //     formatter: (props) => {
    //       if (!props.value) {
    //         return <span>{props.dependentValues.TTracking}</span>
    //       } else {
    //         return <span>{props.value}</span>
    //       }
    //     }
    //   }
    //   const storeName = {
    //     key: "Store",
    //     name: <Translate value="store" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //   }
    //   const warehouseNum = {
    //     key: "warehouse_num",
    //     name: <Translate value="warehouse_num" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //   }
    //   const salesStatus = {
    //     key: "SaleStatus",
    //     name: <Translate value="sales_status" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //     getRowMetaData: row => row,
    //     formatter: (row) => {
    //       const IsMonitor = row.dependentValues.IsMonitor;
    //       const IsMonitorStyle = {
    //         color: 'orange',
    //         fontWeight: 'bold'
    //       }
    //       return <span style={{ width: '100', cursor: 'pointer', ...IsMonitor&&IsMonitorStyle }} onDoubleClick={() => this.handleSalesStatusClick(row.dependentValues)}>{row.value}</span>
    //     }
    //   }
    //   const currentSalesStatusIndex = _.findIndex(columns, { key: 'SaleStatus' });
    //   columns.splice(currentSalesStatusIndex, 1);
    //   const Deliver_CustomerNameIndex = _.findIndex(columns, { key: 'Deliver_CustomerName' });
    //   columns[Deliver_CustomerNameIndex].key = 'shipToName';
    //   columns.splice(Deliver_CustomerNameIndex, 0, CPO, Location, carrier, tracking, storeName, salesStatus, warehouseNum);
    //   const creatorIndex = columns.findIndex(column => column.key === 'Creator_User_Name');
    //   if(creatorIndex !== -1) {
    //     columns.splice(creatorIndex, 0 , {
    //       key: "TOTAL CBM",
    //       name: <Translate value="total_cbm" />,
    //       resizable: true,
    //       width: 80,
    //       sortable: true,
    //       formatter: ({ value }) => (
    //         <div style={{ width: "100%", height: "100%" }}>
    //           {value ? value.toFixed(3) : null}
    //         </div>
    //       )
    //     })
    //   }
    // }
    //
    if (isHO || isLAP) {
      if (isLAP) {
        columns.push({
          key: "Profit",
          name: <Translate value="profit" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          formatter:({value}) => (
            <span>${Math.round(value * 100) / 100}</span>
          )
        });
      }
      columns.push({
        key: "SalesMargin",
        name: <Translate value="sales_margin" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter:({value}) => (
          <span>{Math.round(value * 100) / 100}%</span>
        )
      });
    }
    // if (isHO || isRivera) {
    //   const finalPriceIndex = columns.findIndex(item => item.key === 'FinalNetWeight')
    //   if (finalPriceIndex !== -1) {
    //     columns.splice(finalPriceIndex, 0, {
    //       key: "TaxAmount",
    //       name: <Translate value="total_tax" />,
    //       resizable: true,
    //       width: 80,
    //       sortable: true,
    //     }, {
    //       key: "TotalCRV",
    //       name: <Translate value="total_crv" />,
    //       resizable: true,
    //       width: 80,
    //       sortable: true,
    //     })
    //   }
    // }
    //
    // const MAGColumn = [
    //   {
    //     key: "SQNum",
    //     name: <Translate value="so_no" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: soNumWidth,
    //   },
    //   {
    //     key: "InvoiceNum",
    //     name: <Translate value="invoice_no" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 113,
    //     formatter: InvoiceNumFormatter,
    //   },
    //   {
    //     key: "SaleStatus",
    //     name: <Translate value="status" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 90,
    //     filterable: true,
    //   },
    //   {
    //     key: "Deliver_CustomerName",
    //     name: <Translate value="cust_name" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 115,
    //   },
    //   {
    //     key: "delivery_address",
    //     name: <Translate value="delivery_address" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 200,
    //   },
    //   {
    //     key: "delivery_eta",
    //     name: <Translate value="eta" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 125,
    //     filterable: true,
    //     formatter: DateMonthFormatter,
    //   },
    //   {
    //     key: "cntrNum",
    //     name: <Translate value="container_num" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 120,
    //   },
    //   {
    //     key: "bolNum",
    //     name: <Translate value="bol_num" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 120,
    //   },
    //   {
    //     key: "terminal",
    //     name: <Translate value="terminal" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 120,
    //   },
    //   {
    //     key: "delivery_lfd",
    //     name: <Translate value="lfd" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 125,
    //     filterable: true,
    //     formatter: DateMonthFormatter,
    //   },
    //   {
    //     key: "DeliveryStatus",
    //     name: <Translate value="hold_select" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 250,
    //   },
    //   {
    //     key: "DeliveryStatusOther",
    //     name: <Translate value="hold_other" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 200,
    //   },
    //   {
    //     key: "cntrLocation",
    //     name: <Translate value="cntr_location" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 200,
    //   },
    //   {
    //     key: "mag_note",
    //     name: <Translate value="note_select" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 250,
    //   },
    //   {
    //     key: "mag_note_other",
    //     name: <Translate value="note_other" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 200,
    //   },
    //   {
    //     key: "size",
    //     name: <Translate value="size" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 120,
    //   },
    //   {
    //     key: "shipping_line",
    //     name: <Translate value="shipping_line" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 120,
    //   },
    //   {
    //     key: "cargo_weight",
    //     name: <Translate value="cargo_weight" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 120,
    //   },
    //   {
    //     key: "contact_person",
    //     name: <Translate value="contact_person" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 120,
    //   },
    //   {
    //     key: "contact_email",
    //     name: <Translate value="contact_email" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 120,
    //   },
    //   {
    //     key: "Deliver_Customer_num",
    //     name: <Translate value="cust_no" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //   },
    //   {
    //     key: isTN ? "ClientCustName" : isChinaTown ? "ShippingMethod": "Description",
    //     name: isTN ? "Client.Cust" : isChinaTown ?  <Translate value="shipping_method" /> : <Translate value="description" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 124,
    //   },
    //   {
    //     key: "FinalPrice",
    //     name: <Translate value="final_dollarsign" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //     formatter: CashFormatter,
    //   },
    //   {
    //     key: "Sales_User_Name",
    //     name: <Translate value="sales" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //   },
    //   {
    //     key: "PaymentType",
    //     name: <Translate value="payment" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //     formatter: YuansferFormatter,
    //   },
    //   {
    //     key: "OrderDate",
    //     name: <Translate value="ordered" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //     // formatter: SecondsDateFormatter,
    //   },
    //   {
    //     key: "DispatchDate",
    //     name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 125,
    //     filterable: true,
    //     formatter: DateMonthFormatter,
    //   },
    //   {
    //     key: "ShipmentDate",
    //     name: <Translate value="shipped" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 110,
    //     filterable: true,
    //     formatter: SecondsDateFormatter,
    //   },
    // ];

    // if (isRivera) {
    //   const indexSalesStatus = _.findIndex(columns, { key: 'OrderDate' });
    //   const orderDateColumn = {
    //     key: 'OrderDate',
    //     name: <Translate value="ordered" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: SecondsDateFormatter,
    //   };
    //   columns.splice(indexSalesStatus, 1, orderDateColumn);
    // }

    // For Ecity, add SalesMargin Column before SaleStatus
    // if (isEcity) {
    //   const indexSalesStatus = _.findIndex(columns, { key: "SaleStatus" });
    //   const salesMarginColumn = {
    //     key: "SalesMargin",
    //     name: <Translate value="sales_margin_percentsign" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: PercentFormatter,
    //   };
    //   columns.splice(indexSalesStatus, 0, salesMarginColumn);
    // }
    //
    // if (isTN) {
    //   const indexTN = _.findIndex(columns, { key: "InvoiceNum" });
    //   const cpoCol = {
    //     key: "CPONum",
    //     name: <Translate value="cpo_num" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 90,
    //   }
    //   const refCol = {
    //     key: "RefNum",
    //     name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 90,
    //   }
    //   columns.splice(indexTN, 0, cpoCol, refCol);
    //
    //   const orderCol = _.findIndex(columns, { key: "OrderDate" });
    //   const typeCol = {
    //     key: "Type",
    //     name: <Translate value="type" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 90,
    //   }
    //   columns.splice(orderCol, 0, typeCol);
    // }

    // if (isAFG) {
    if (true) {
      const indexOrderDate = _.findIndex(columns, { key: "OrderDate" });
      const orderColum = {
        key: "OrderDateDisplay",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      };
      columns.splice(indexOrderDate, 1, orderColum);

      if (this.state.salesOrders && this.state.salesOrders.rows && this.state.salesOrders.rows.length > 0) {
        this.state.salesOrders.rows.map((row) => {
          row.OrderDateDisplay = moment(row.OrderDate).format("MM-DD-YY HH:mm");
        });
      }

      // const jmlTrackingNumColumn = {
      //   key: "TrackingNum",
      //   name: <Translate value="tracking_num" />,
      //   resizable: true,
      //   sortable: true,
      //   width: 110,
      //   filterable: true,
      //   formatter: ({ value }) => (
      //     <div
      //       style={{ width: "100%", height: "100%", textAlign: "center" }}
      //       onDoubleClick={() => {
      //         this.openDisplayTracking();
      //       }}
      //     >
      //       <Translate value="details" />
      //     </div>
      //   ),
      // };
      // if (isJML || isSY) {
      //   columns.splice(indexOrderDate, 0, jmlTrackingNumColumn);
      // }
    }

    // if (isMyuMyu || isAFG || isWecom ) {
    //   const indexEstDelivery = _.findIndex(columns, { key: "DispatchDate" });
    //   const estColum = {
    //     key: "DispatchDateDisplay",
    //     name: <Translate value="est_delivery" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 160,
    //     filterable: true,
    //   };
    //   columns.splice(indexEstDelivery, 1, estColum);
    //   if (this.state.salesOrders && this.state.salesOrders.rows && this.state.salesOrders.rows.length > 0) {
    //     this.state.salesOrders.rows.map((row) => {
    //       let date1 = moment
    //         .utc(moment(row.DispatchDate))
    //         .local()
    //         .format("HH:mm");
    //       let date2 = moment
    //         .utc(moment(row.DispatchDate))
    //         .local()
    //         .subtract(2, "hours")
    //         .format("MM-DD-YY HH:mm");
    //       row.DispatchDateDisplay = `${date2}-${date1}`;
    //     });
    //   }
    // } else if (isAFM || isHMM) {
    //   const indexEstDelivery = _.findIndex(columns, { key: "DispatchDate" });
    //   const estColum = {
    //     key: "TimeRange",
    //     name: <Translate value="est_delivery" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 160,
    //     filterable: true,
    //   };
    //   columns.splice(indexEstDelivery, 1, estColum);
    // }
    //
    // if (isGV) {
    //   columns.splice(5, 0, {
    //     key: "GvTicketQRCodeUrl",
    //     name: <Translate value="qr_code" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 90,
    //     formatter: ({ value }) => {
    //       if (value) {
    //         return <a href={value}>download</a>
    //       } else {
    //         return null;
    //       }
    //     },
    //   });
    // };
    //
    // if (isAFM) {
    //   columns.splice(8, 0, {
    //     key: "ShippingStatus",
    //     name: <Translate value="shipping_status" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 90,
    //   });
    //   columns.splice(9, 0, {
    //     key: "OrderImage",
    //     name: <Translate value="order_image" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 90,
    //     formatter: ({ value }) => (
    //       <div
    //         style={{ width: "100%", height: "100%", textAlign: "center" }}
    //         onDoubleClick={() => {
    //           if (value !== '') {
    //             this.openShowDriverImage();
    //           }
    //         }}
    //       >
    //         {value !== '' && <Translate value="show" />}
    //       </div>
    //     ),
    //   });
    // }
    //
    // if (isTN) {
    //   const indexDispatchPrice = _.findIndex(columns, { key: "ShipmentDate" });
    //   const shipByColumn = {
    //     key: "ShipByDate",
    //     name: <Translate value="ship_by" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 125,
    //     filterable: true,
    //     formatter: DateMonthFormatter,
    //   };
    //   const createTimeColumn = {
    //     key: "CreateTime",
    //     name: <Translate value="create_time" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 125,
    //     filterable: true,
    //     formatter: DateMonthFormatter,
    //   };
    //   columns.splice(indexDispatchPrice, 0, shipByColumn, createTimeColumn);
    // }
    if (!isTN && !isFIT) {
      const indexFinalPrice = _.findIndex(columns, { key: "FinalPrice" });
      const discountColumn = {
        key: "discountDisplay",
        name: <Translate value="discount" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      };
      const promoCodeColumn = {
        key: "PromoCode",
        name: <Translate value="promo_code" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        // formatter: PromoCodeFormatter,
      };
      const channelColumn = {
        key: "Channel",
        name: <Translate value="channel" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      };
      
      if (!isOCM && !isSV) {
        columns.splice(indexFinalPrice, 0, promoCodeColumn);
      }
      if (this.state.salesOrders && this.state.salesOrders.rows && this.state.salesOrders.rows.length > 0) {
        this.state.salesOrders.rows.map((row) => {
          if (!row.PromoCode) {
            row.PromoCode = "-";
          }
        });
      }

      columns.splice(indexFinalPrice, 0, discountColumn);
      if (this.state.salesOrders && this.state.salesOrders.rows && this.state.salesOrders.rows.length > 0) {
        this.state.salesOrders.rows.map((row) => {
          if (row.Discount !== 0 && row.Savings) {
            row.discountDisplay =
              row.Discount + "% - $" + row.Savings.toFixed(2);
          } else if (row.Discount === 0 && row.Savings !== 0) {
            row.discountDisplay = "$" + row.Savings.toFixed(2);
          } else {
            row.discountDisplay = "-";
          }
        });
      }
      // if (isSKH) {
      //   const promoCodeIdx = _.findIndex(columns, { key: "PromoCode" });
      //   const salesStatusIdx = _.findIndex(columns, { key: "SaleStatus" });
      //   const trackingCol = {
      //     key: "Tracking",
      //     name: <Translate value="tracking" />,
      //     resizable: true,
      //     sortable: true,
      //     filterable: true,
      //     width: 100,
      //   };
      //   const statusCol = {
      //     key: "SaleStatus",
      //     name: <Translate value="status" />,
      //     resizable: true,
      //     sortable: true,
      //     width: 80,
      //     filterable: true,
      //   };
      //   columns.splice(salesStatusIdx, 1);
      //   columns.splice(indexFinalPrice, 0, channelColumn);
      //   columns.splice(promoCodeIdx, 0, statusCol);
      //   columns.splice(promoCodeIdx, 0, trackingCol);
      // }
  
    }

    // For mobile sales order, replace Sales_User_Name with City
    if (this.context.router.routes[1].path === "mobileSalesOrders") {
      const indexFinalPrice = _.findIndex(columns, { key: "FinalPrice" });
      const groupBuyColumn = {
        key: "IsGroupBuyDisplay",
        name: <Translate value="group_buy" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: ({ value }) => (
          <div style={{ width: "100%", height: "100%", textAlign: "center" }}>
            {value}
          </div>
        ),
      };
      // if (isWecom) {
      //   columns.splice(indexFinalPrice, 0, groupBuyColumn);
      //   if (this.state.salesOrders.rows.length > 0) {
      //     this.state.salesOrders.rows.map((row) => {
      //       if (row.IsGroupBuy === true) {
      //         row.IsGroupBuyDisplay = "yes";
      //       } else {
      //         row.IsGroupBuyDisplay = "no";
      //       }
      //     });
      //   }
      // }
      //
      // if (isAFG) {
      //   const alcoholColumn = {
      //     key: "Alcohol",
      //     name: <Translate value="alcohol" />,
      //     resizable: true,
      //     sortable: true,
      //     width: 90,
      //     filterable: true,
      //   };
      //   const platformColumn = {
      //     key: "platform",
      //     name: <Translate value="platform" />,
      //     resizable: true,
      //     sortable: true,
      //     width: 90,
      //     filterable: true,
      //   };
      //   columns.splice(indexFinalPrice, 0, alcoholColumn);
      //   columns.splice(indexFinalPrice, 0, platformColumn);
      // }

      // Find item index using _.findIndex
      const indexEstDeliveryName = _.findIndex(columns, {
        key: "DispatchDate",
      });
      const indexSalesUserName = _.findIndex(columns, {
        key: "Sales_User_Name",
      });
      const indexCreateTime = _.findIndex(columns, { key: "CreateTime" });
      const descriptionIndex = _.findIndex(columns, { key: "Description" });
      const cityColumn = {
        key: "City",
        name: <Translate value="city" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      };

      const stateColumn = {
        key: "State",
        name: <Translate value="state" />,
        resizable: true,
        sortable: true,
        width: 50,
        filterable: true,
      };

      const shippingWeight = {
        key: "FinalShippingWeight",
        name: <Translate value="shipping_weight" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: ({ value }) => (
          <div style={{ width: "100%", height: "100%" }}>
            {value ? value.toFixed(2) : null}
          </div>
        ),
      };

      const shippingmethodColumn = {
        key: "ShippingMethod",
        name: <Translate value="shippingMethod" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      };

      // const trackingNumColumn = {
      //   key: "TrackingNum",
      //   name: <Translate value="tracking_num" />,
      //   resizable: true,
      //   sortable: true,
      //   width: 110,
      //   filterable: true,
      //   formatter: ({ value }) => (
      //     <div
      //       style={{ width: "100%", height: "100%", textAlign: "center" }}
      //       onDoubleClick={() => {
      //         if (value === "split") {
      //           this.openDisplayTracking();
      //         } else {
      //           onTrackingNumRouter(value);
      //         }
      //       }}
      //     >
      //       {value}
      //     </div>
      //   ),
      // };

      // if (isAFG) {
      //   columns.splice(indexEstDeliveryName, 1);
      //   columns.splice(indexEstDeliveryName, 0, trackingNumColumn);
      // }
      if (!isRivera) {
        columns.splice(
          indexSalesUserName,
          1,
          shippingWeight,
          cityColumn,
          stateColumn,
        );
      } else {
        columns.splice(indexSalesUserName, 1, cityColumn, stateColumn);
      }
      columns.splice(indexCreateTime, 1, shippingmethodColumn);
      columns.splice(descriptionIndex, 1); // hide desc on mobile order
    } else {
      const yuansferColName = _.findIndex(columns, { key: "PaymentType" });
      columns.splice(yuansferColName, 1); // hide payment on sales order
    }

    // if (isFIT) {
    //   const trackingNumColumn = {
    //     key: "TrackingNum",
    //     name: <Translate value="tracking_num" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 110,
    //   };
    //   const index = _.findIndex(columns, { key: "SaleStatus" });
    //   columns.splice(index+1, 0, trackingNumColumn);
    // }

    // const ABCColumn = [
    //   {
    //     key: "SQNum",
    //     name: <Translate value="so_num" />,
    //     resizable: true,
    //     // sortable: true,
    //     width: 120,
    //     filterable: true,
    //     locked: true,
    //   },
    //   {
    //     key: "CompanyName",
    //     name: <Translate value="company_name" />,
    //     resizable: true,
    //     // sortable: true,
    //     width: 120,
    //     filterable: true,
    //     locked: true,
    //   },
    //   {
    //     key: "CreateTime",
    //     name: <Translate value="date" />,
    //     resizable: true,
    //     // sortable: true,
    //     width: 120,
    //     filterable: true,
    //     locked: true,
    //     formatter: SecondsDateFormatter,
    //   },
    //   {
    //     key: "FBACode",
    //     name: <Translate value="FBA" />,
    //     resizable: true,
    //     // sortable: true,
    //     width: 120,
    //     filterable: true,
    //     locked: true,
    //   },
    //   {
    //     key: "CustomerBOLNo",
    //     name: <Translate value="BOL" />,
    //     resizable: true,
    //     // sortable: true,
    //     width: 120,
    //     filterable: true,
    //     locked: true,
    //   },
    //   {
    //     key: "TotalPalletQuantity",
    //     name: <Translate value="plt" />,
    //     resizable: true,
    //     // sortable: true,
    //     width: 70,
    //     filterable: true,
    //   },
    //   {
    //     key: "TotalInboundQuantity",
    //     name: <Translate value="inbound_plt" />,
    //     resizable: true,
    //     // sortable: true,
    //     width: 90,
    //     filterable: true,
    //   },
    //   {
    //     key: "TotalOutboundQuantity",
    //     name: <Translate value="outbound_plt" />,
    //     resizable: true,
    //     // sortable: true,
    //     width: 90,
    //     filterable: true,
    //   },
    //   {
    //     key: "ESTInboundDate",
    //     name: <Translate value="EST_date" />,
    //     resizable: true,
    //     // sortable: true,
    //     width: 150,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "IsaNo",
    //     name: <Translate value="ISA" />,
    //     resizable: true,
    //     // sortable: true,
    //     width: 90,
    //     filterable: true,
    //   },
    //   {
    //     key: "Reason",
    //     name: <Translate value="reason" />,
    //     resizable: true,
    //     // sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: ({ value }) => (
    //       <div
    //         // style={{ width: '100%', height: '100%' }}
    //         style={{color: value ? 'red' : ''}}
    //       >
    //         { value }
    //       </div>
    //     ),
    //   },
    //   {
    //     key: "TotalCartonQuantity",
    //     name: <Translate value="ctn" />,
    //     resizable: true,
    //     // sortable: true,
    //     width: 70,
    //     filterable: true,
    //   },
    //   {
    //     key: "ShippingStatus",
    //     name: <Translate value="shpping_status" />,
    //     resizable: true,
    //     // sortable: true,
    //     width: 70,
    //     filterable: true,
    //   },
    //   {
    //     key: "Location",
    //     name: <Translate value="location" />,
    //     resizable: true,
    //     // sortable: true,
    //     width: 120,
    //     filterable: true,
    //   },
    //   {
    //     key: "PodFileUrl",
    //     name: <Translate value="pod" />,
    //     resizable: true,
    //     // sortable: true,
    //     width: 90,
    //     filterable: true,
    //     formatter: ({ value }) => (
    //       <a
    //         style={{color: value ? 'green' : '', cursor: 'pointer'}}
    //         href={value}
    //       >
    //         { value && 'uploaded' }
    //       </a>
    //     ),
    //   },
    //   {
    //     key: "ContainerNo",
    //     name: <Translate value="container" />,
    //     resizable: true,
    //     // sortable: true,
    //     width: 90,
    //     filterable: true,
    //   },
    //   {
    //     key: "PickUpDriverName",
    //     name: <Translate value="inbound_driver" />,
    //     resizable: true,
    //     // sortable: true,
    //     width: 90,
    //     filterable: true,
    //   },
    //   {
    //     key: "OutboundDriverName",
    //     name: <Translate value="outbound_driver" />,
    //     resizable: true,
    //     // sortable: true,
    //     width: 90,
    //     filterable: true,
    //   },
    //   {
    //     key: "ShipFrom",
    //     name: <Translate value="ship_from" />,
    //     resizable: true,
    //     // sortable: true,
    //     width: 200,
    //     filterable: true,
    //   },
    //   {
    //     key: "ShipTo",
    //     name: <Translate value="ship_to" />,
    //     resizable: true,
    //     // sortable: true,
    //     width: 200,
    //     filterable: true,
    //   },
    //   // {
    //   //   key: "ShipTo",
    //   //   name: <Translate value="ship_to" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 270,
    //   //   filterable: true,
    //   // },
    //   // {
    //   //   key: "ShippingStatus",
    //   //   name: <Translate value="shipping_status" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 90,
    //   //   filterable: true,
    //   // },
    //   // {
    //   //   key: "SaleStatus",
    //   //   name: <Translate value="sales_status" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 90,
    //   //   filterable: true,
    //   // },
    // ];
    // const USPrideColumn = [
    //   {
    //     key: "SQNum",
    //     name: <Translate value="SQNum" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "InvoiceNum",
    //     name: <Translate value="invoice_no" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 113,
    //     formatter: InvoiceNumFormatter,
    //   },
    //   {
    //     key: "Deliver_CustomerName",
    //     name: <Translate value="store_name" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "poNum",
    //     name: <Translate value="po_num" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "OrderDate",
    //     name: <Translate value="po_date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 120,
    //     filterable: true,
    //     formatter: DateMonthFormatter,
    //   },
    //   {
    //     key: "DispatchDate",
    //     name: <Translate value="must_ship_by" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 120,
    //     filterable: true,
    //     formatter: SecondsDateFormatter,
    //   },
    //   {
    //     key: "backorderDate",
    //     name: <Translate value="backorder_date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 120,
    //     filterable: true,
    //     formatter: SecondsDateFormatter,
    //   },
    //   {
    //     key: "ExternalStatus",
    //     name: <Translate value="order_status" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 120,
    //     filterable: true,
    //     // formatter: SecondsDateFormatter,
    //   },
    //   {
    //     key: "SaleStatus",
    //     name: <Translate value="sale_status" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "ShippingStatus",
    //     name: <Translate value="shipping_status" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "ShippingMethod",
    //     name: <Translate value="shipping_method" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "carrierName",
    //     name: <Translate value="carrier_name" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "shipToName",
    //     name: <Translate value="ship_to_name" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     // key: "shipToAddress",
    //     name: <Translate value="ship_to_address" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 250,
    //     filterable: true,
    //     getRowMetaData: (row) => row,
    //     formatter: shippingAddressFormatter,
    //   },
    //   {
    //     key: "Deliver_CustomerPhone",
    //     name: <Translate value="ship_to_phone" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "shipToSpeed",
    //     name: <Translate value="ship_to_speed" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "TrackingNum",
    //     name: <Translate value="tracking_num" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 120,
    //     filterable: true,
    //   },
    // ];

    // const DSQColumn = this.context.router.routes[1].path === 'outboundOrders' ? [
    //   {
    //     key: "SQNum",
    //     name: <Translate value="ob_no" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: soNumWidth,
    //   },
    //   {
    //     key: "InvoiceNum",
    //     name: <Translate value="invoice_no" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 113,
    //     formatter: InvoiceNumFormatter,
    //   },
    //   // {
    //   //   key: "TrailerNum",
    //   //   name: <Translate value="trailer_num" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 100,
    //   //   filterable: true,
    //   // },
    //   {
    //     key: "DSQID",
    //     name: <Translate value="dsq_id" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Appointment",
    //     name: <Translate value="apnt_time" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 120,
    //     filterable: true,
    //   },
    //   {
    //     key: "AppointmentDate",
    //     name: <Translate value="apnt_date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 120,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "ISANum",
    //     name: <Translate value="isa" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Deliver_CustomerName",
    //     name: <Translate value="cust_name" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 130,
    //   },
    //   {
    //     key: "ContainerNum",
    //     name: <Translate value="container_num" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "OrderPalletQty",
    //     name: <Translate value="pallet_qty" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "IsDirectShip",
    //     name: <Translate value="direct_ship" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     // filterable: true,
    //     formatter: ({ value }) => (
    //       <div>
    //         { value ? "true" : "false" }
    //       </div>
    //     ),
    //   },
    //   {
    //     key: "Carrier",
    //     name: <Translate value="carrier" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Port",
    //     name: <Translate value="port" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "LFDate",
    //     name: <Translate value="LF_Date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 110,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //     // formatter: SecondsDateFormatter,
    //   },
    //   // {
    //   //   key: "OrderPalletQty",
    //   //   name: <Translate value="order_pallet_qty" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 100,
    //   //   filterable: true,
    //   // },
    //   // {
    //   //   key: "LFDate",
    //   //   name: <Translate value="LF_Date" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 110,
    //   //   filterable: true,
    //   //   formatter: DateFormatter2,
    //   //   // formatter: SecondsDateFormatter,
    //   // },
    //   {
    //     key: "IsDO",
    //     name: <Translate value="IsDO" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     // filterable: true,
    //     formatter: ({ value }) => (
    //       <div>
    //         { value ? "true" : "false" }
    //       </div>
    //     ),
    //   },
    //   {
    //     key: "IsBOL",
    //     name: <Translate value="IsBOL" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     // filterable: true,
    //     formatter: ({ value }) => (
    //       <div>
    //         { value ? "true" : "false" }
    //       </div>
    //     ),
    //   },
    //   {
    //     key: "IsPOD",
    //     name: <Translate value="IsPOD" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     // filterable: true,
    //     formatter: ({ value }) => (
    //       <div>
    //         { value ? "true" : "false" }
    //       </div>
    //     ),
    //   },
    //   // {
    //   //   key: "FBARoute",
    //   //   name: <Translate value="fba_route" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 100,
    //   //   filterable: true,
    //   // },
    //   // {
    //   //   key: "Appointment",
    //   //   name: <Translate value="appointment" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 100,
    //   //   filterable: true,
    //   // },
    //   // {
    //   //   key: "ISANum",
    //   //   name: <Translate value="isa" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 100,
    //   //   filterable: true,
    //   // },
    //   {
    //     key: "TruckingCo",
    //     name: <Translate value="trucking_co" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "DeliverTo",
    //     name: <Translate value="deliver_to" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "IsReturnEmpty",
    //     name: <Translate value="return_empty" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: ({ value }) => (
    //       <div>
    //         { value ? "true" : "false" }
    //       </div>
    //     ),
    //   },
    //   {
    //     key: "ArrivalDate",
    //     name: <Translate value="arrival_date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "ReturnDate",
    //     name: <Translate value="return_date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "StorageInDate",
    //     name: <Translate value="storage_in" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "StorageOutDate",
    //     name: <Translate value="storage_out" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "Deliver_Customer_num",
    //     name: <Translate value="cust_no" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //   },
    //   // {
    //   //   key: "Deliver_CustomerName",
    //   //   name: <Translate value="cust_name" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   filterable: true,
    //   //   width: 115,
    //   // },
    //   {
    //     key: isTN ? "ClientCustName" : "Description",
    //     name: isTN ? "Client.Cust" : <Translate value="description" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 124,
    //   },
    //
    //   {
    //     key: "FinalPrice",
    //     name: <Translate value="final_dollarsign" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //     formatter: CashFormatter,
    //   },
    //   {
    //     key: "Sales_User_Name",
    //     name: <Translate value="sales" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //   },
    //   {
    //     key: "SaleStatus",
    //     name: <Translate value="status" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //   },
    //   {
    //     key: "PaymentType",
    //     name: <Translate value="payment" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //     formatter: YuansferFormatter,
    //   },
    //   {
    //     key: "OrderDate",
    //     name: <Translate value="ordered" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //   },
    //   {
    //     key: "DispatchDate",
    //     name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 125,
    //     filterable: true,
    //     formatter: DateMonthFormatter,
    //   },
    //   {
    //     key: "ShipmentDate",
    //     name: <Translate value="shipped" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 110,
    //     filterable: true,
    //     formatter: SecondsDateFormatter,
    //   },
    // ] : [
    //   {
    //     key: "SQNum",
    //     name: <Translate value="ib_no" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: soNumWidth,
    //   },
    //   {
    //     key: "InvoiceNum",
    //     name: <Translate value="invoice_no" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 113,
    //     formatter: InvoiceNumFormatter,
    //   },
    //
    //   // {
    //   //   key: "TrailerNum",
    //   //   name: <Translate value="trailer_num" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 100,
    //   //   filterable: true,
    //   // },
    //   {
    //     key: "DSQID",
    //     name: <Translate value="dsq_id" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Appointment",
    //     name: <Translate value="apnt_time" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 120,
    //     filterable: true,
    //   },
    //   {
    //     key: "AppointmentDate",
    //     name: <Translate value="apnt_date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 120,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "ISANum",
    //     name: <Translate value="isa" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Deliver_CustomerName",
    //     name: <Translate value="cust_name" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 130,
    //   },
    //   {
    //     key: "ContainerNum",
    //     name: <Translate value="container_num" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "OrderPalletQty",
    //     name: <Translate value="pallet_qty" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Carrier",
    //     name: <Translate value="carrier" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Port",
    //     name: <Translate value="port" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "LFDate",
    //     name: <Translate value="LF_Date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 110,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //     // formatter: SecondsDateFormatter,
    //   },
    //   // {
    //   //   key: "OrderPalletQty",
    //   //   name: <Translate value="order_pallet_qty" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 100,
    //   //   filterable: true,
    //   // },
    //   // {
    //   //   key: "LFDate",
    //   //   name: <Translate value="LF_Date" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 110,
    //   //   filterable: true,
    //   //   formatter: DateFormatter2,
    //   //   // formatter: SecondsDateFormatter,
    //   // },
    //   {
    //     key: "IsDO",
    //     name: <Translate value="IsDO" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: ({ value }) => (
    //       <div>
    //         { value ? "true" : "false" }
    //       </div>
    //     ),
    //   },
    //   {
    //     key: "IsBOL",
    //     name: <Translate value="IsBOL" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: ({ value }) => (
    //       <div>
    //         { value ? "true" : "false" }
    //       </div>
    //     ),
    //   },
    //   {
    //     key: "IsPOD",
    //     name: <Translate value="IsPOD" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: ({ value }) => (
    //       <div>
    //         { value ? "true" : "false" }
    //       </div>
    //     ),
    //   },
    //   // {
    //   //   key: "FBARoute",
    //   //   name: <Translate value="fba_route" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 100,
    //   //   filterable: true,
    //   // },
    //   // {
    //   //   key: "Appointment",
    //   //   name: <Translate value="appointment" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 100,
    //   //   filterable: true,
    //   // },
    //   // {
    //   //   key: "ISANum",
    //   //   name: <Translate value="isa" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 100,
    //   //   filterable: true,
    //   // },
    //   {
    //     key: "TruckingCo",
    //     name: <Translate value="trucking_co" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "DeliverTo",
    //     name: <Translate value="deliver_to" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "IsReturnEmpty",
    //     name: <Translate value="return_empty" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: ({ value }) => (
    //       <div>
    //         { value ? "true" : "false" }
    //       </div>
    //     ),
    //   },
    //   {
    //     key: "ArrivalDate",
    //     name: <Translate value="arrival_date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "ReturnDate",
    //     name: <Translate value="return_date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "StorageInDate",
    //     name: <Translate value="storage_in" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "StorageOutDate",
    //     name: <Translate value="storage_out" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "Deliver_Customer_num",
    //     name: <Translate value="cust_no" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //   },
    //   // {
    //   //   key: "Deliver_CustomerName",
    //   //   name: <Translate value="cust_name" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   filterable: true,
    //   //   width: 115,
    //   // },
    //   {
    //     key: isTN ? "ClientCustName" : "Description",
    //     name: isTN ? "Client.Cust" : <Translate value="description" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 124,
    //   },
    //   {
    //     key: "FinalPrice",
    //     name: <Translate value="final_dollarsign" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //     formatter: CashFormatter,
    //   },
    //   {
    //     key: "Sales_User_Name",
    //     name: <Translate value="sales" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //   },
    //   {
    //     key: "SaleStatus",
    //     name: <Translate value="status" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //   },
    //   {
    //     key: "PaymentType",
    //     name: <Translate value="payment" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //     formatter: YuansferFormatter,
    //   },
    //   {
    //     key: "OrderDate",
    //     name: <Translate value="ordered" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //   },
    //   {
    //     key: "DispatchDate",
    //     name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 125,
    //     filterable: true,
    //     formatter: DateMonthFormatter,
    //   },
    //   {
    //     key: "ShipmentDate",
    //     name: <Translate value="shipped" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 110,
    //     filterable: true,
    //     formatter: SecondsDateFormatter,
    //   },
    // ];

    // const JTBColumn = this.context.router.routes[1].path === 'outboundOrders' ? [
    //   {
    //     key: "SQNum",
    //     name: <Translate value="ob_no" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: soNumWidth,
    //   },
    //   {
    //     key: "InvoiceNum",
    //     name: <Translate value="invoice_no" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 113,
    //     formatter: InvoiceNumFormatter,
    //   },
    //   {
    //     key: "ContainerNum",
    //     name: <Translate value="container_num" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "ContainerSize",
    //     name: <Translate value="container_size" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   // {
    //   //   key: "ReceiveType",
    //   //   name: <Translate value="receive_type" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 100,
    //   //   filterable: true,
    //   // },
    //   {
    //     key: "OrderType",
    //     name: <Translate value="order_type" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "DropshipType",
    //     name: <Translate value="dropship_type" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Carrier",
    //     name: <Translate value="carrier" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Port",
    //     name: <Translate value="port" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   // {
    //   //   key: "LFDate",
    //   //   name: <Translate value="LF_Date" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 110,
    //   //   filterable: true,
    //   //   formatter: DateFormatter2,
    //   //   // formatter: SecondsDateFormatter,
    //   // },
    //   {
    //     key: "BOL",
    //     name: <Translate value="BOL" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "POD",
    //     name: <Translate value="POD" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "FBARoute",
    //     name: <Translate value="fba_route" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Appointment",
    //     name: <Translate value="appointment" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "TruckingCo",
    //     name: <Translate value="trucking_co" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "DeliverTo",
    //     name: <Translate value="deliver_to" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "IsReturnEmpty",
    //     name: <Translate value="return_empty" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: ({ value }) => (
    //       <div>
    //         { value ? "true" : "false" }
    //       </div>
    //     ),
    //   },
    //   {
    //     key: "ArrivalDate",
    //     name: <Translate value="arrival_date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "ReturnDate",
    //     name: <Translate value="return_date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "StorageInDate",
    //     name: <Translate value="storage_in" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "StorageOutDate",
    //     name: <Translate value="storage_out" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "Deliver_Customer_num",
    //     name: <Translate value="cust_no" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //   },
    //   {
    //     key: "Deliver_CustomerName",
    //     name: <Translate value="cust_name" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 115,
    //   },
    //   {
    //     key: isTN ? "ClientCustName" : "Description",
    //     name: isTN ? "Client.Cust" : <Translate value="description" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 124,
    //   },
    //   {
    //     key: "FinalPrice",
    //     name: <Translate value="final_dollarsign" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //     formatter: CashFormatter,
    //   },
    //   {
    //     key: "Sales_User_Name",
    //     name: <Translate value="sales" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //   },
    //   {
    //     key: "SaleStatus",
    //     name: <Translate value="status" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //   },
    //   {
    //     key: "PaymentType",
    //     name: <Translate value="payment" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //     formatter: YuansferFormatter,
    //   },
    //   {
    //     key: "OrderDate",
    //     name: <Translate value="ordered" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //   },
    //   {
    //     key: "DispatchDate",
    //     name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 125,
    //     filterable: true,
    //     formatter: DateMonthFormatter,
    //   },
    //   {
    //     key: "ShipmentDate",
    //     name: <Translate value="shipped" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 110,
    //     filterable: true,
    //     formatter: SecondsDateFormatter,
    //   },
    // ] : [
    //   {
    //     key: "SQNum",
    //     name: <Translate value="ib_no" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: soNumWidth,
    //   },
    //   {
    //     key: "InvoiceNum",
    //     name: <Translate value="invoice_no" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 113,
    //     formatter: InvoiceNumFormatter,
    //   },
    //   {
    //     key: "ContainerNum",
    //     name: <Translate value="container_num" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "ContainerSize",
    //     name: <Translate value="container_size" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "ReceiveType",
    //     name: <Translate value="receive_type" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "ReceiveUnit",
    //     name: <Translate value="receive_unit" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   // {
    //   //   key: "OrderType",
    //   //   name: <Translate value="order_type" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 100,
    //   //   filterable: true,
    //   // },
    //   {
    //     key: "Carrier",
    //     name: <Translate value="carrier" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Port",
    //     name: <Translate value="port" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   // {
    //   //   key: "LFDate",
    //   //   name: <Translate value="LF_Date" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 110,
    //   //   filterable: true,
    //   //   formatter: DateFormatter2,
    //   //   // formatter: SecondsDateFormatter,
    //   // },
    //   {
    //     key: "BOL",
    //     name: <Translate value="BOL" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "POD",
    //     name: <Translate value="POD" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "FBARoute",
    //     name: <Translate value="fba_route" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Appointment",
    //     name: <Translate value="appointment" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "TruckingCo",
    //     name: <Translate value="trucking_co" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "DeliverTo",
    //     name: <Translate value="deliver_to" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "IsReturnEmpty",
    //     name: <Translate value="return_empty" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: ({ value }) => (
    //       <div>
    //         { value ? "true" : "false" }
    //       </div>
    //     ),
    //   },
    //   {
    //     key: "ArrivalDate",
    //     name: <Translate value="arrival_date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "ReturnDate",
    //     name: <Translate value="return_date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "StorageInDate",
    //     name: <Translate value="storage_in" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "StorageOutDate",
    //     name: <Translate value="storage_out" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "Deliver_Customer_num",
    //     name: <Translate value="cust_no" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //   },
    //   {
    //     key: "Deliver_CustomerName",
    //     name: <Translate value="cust_name" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 115,
    //   },
    //   {
    //     key: isTN ? "ClientCustName" : "Description",
    //     name: isTN ? "Client.Cust" : <Translate value="description" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 124,
    //   },
    //   {
    //     key: "FinalPrice",
    //     name: <Translate value="final_dollarsign" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //     formatter: CashFormatter,
    //   },
    //   {
    //     key: "Sales_User_Name",
    //     name: <Translate value="sales" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //   },
    //   {
    //     key: "SaleStatus",
    //     name: <Translate value="status" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //   },
    //   {
    //     key: "PaymentType",
    //     name: <Translate value="payment" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //     formatter: YuansferFormatter,
    //   },
    //   {
    //     key: "OrderDate",
    //     name: <Translate value="ordered" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //   },
    //   {
    //     key: "DispatchDate",
    //     name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 125,
    //     filterable: true,
    //     formatter: DateMonthFormatter,
    //   },
    //   {
    //     key: "ShipmentDate",
    //     name: <Translate value="shipped" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 110,
    //     filterable: true,
    //     formatter: SecondsDateFormatter,
    //   },
    // ];

    // const WIZColumn = this.context.router.routes[1].path === 'outboundOrders' ? [
    //   {
    //     key: "SQNum",
    //     name: <Translate value="ob_no" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: soNumWidth,
    //   },
    //   {
    //     key: "InvoiceNum",
    //     name: <Translate value="invoice_no" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 113,
    //     formatter: InvoiceNumFormatter,
    //   },
    //   {
    //     key: "OutboundStatus",
    //     name: <Translate value="outbound_status" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 130,
    //     filterable: true,
    //   },
    //   // {
    //   //   key: "DrayageTrucker",
    //   //   name: <Translate value="drayage_trucker" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 110,
    //   //   filterable: true,
    //   // },
    //   {
    //     key: "Trucker",
    //     name: <Translate value="trucker" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "ReleaseDate",
    //     name: <Translate value="release_date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 125,
    //     filterable: true,
    //     formatter: DateMonthFormatter,
    //   },
    //   {
    //     key: "ReadyDate",
    //     name: <Translate value="ready_date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 125,
    //     filterable: true,
    //     formatter: DateMonthFormatter,
    //   },
    //   {
    //     key: "OutboundDate",
    //     name: <Translate value="outbound_date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 125,
    //     filterable: true,
    //     formatter: DateMonthFormatter,
    //   },
    //   {
    //     key: "ShipmentID",
    //     name: <Translate value="shipment_id" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Destination",
    //     name: <Translate value="destination" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   // {
    //   //   key: "ContainerNum",
    //   //   name: <Translate value="container_num" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 120,
    //   //   filterable: true,
    //   // },
    //   // {
    //   //   key: "ContainerSize",
    //   //   name: <Translate value="container_size" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 100,
    //   //   filterable: true,
    //   // },
    //   // {
    //   //   key: "Trailer",
    //   //   name: <Translate value="trailer" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 80,
    //   //   filterable: true,
    //   // },
    //   {
    //     key: "ISANum",
    //     name: <Translate value="isa" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //   },
    //   // {
    //   //   key: "DLNum",
    //   //   name: <Translate value="dl" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 80,
    //   //   filterable: true,
    //   // },
    //   {
    //     key: "Deliver_Customer_num",
    //     name: <Translate value="cust_no" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //   },
    //   {
    //     key: "Deliver_CustomerName",
    //     name: <Translate value="cust_name" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 115,
    //   },
    //   {
    //     key: isTN ? "ClientCustName" : "Description",
    //     name: isTN ? "Client.Cust" : <Translate value="description" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 124,
    //   },
    //   {
    //     key: "FinalPrice",
    //     name: <Translate value="final_dollarsign" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //     formatter: CashFormatter,
    //   },
    //   {
    //     key: "Sales_User_Name",
    //     name: <Translate value="sales" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //   },
    //   {
    //     key: "SaleStatus",
    //     name: <Translate value="status" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //   },
    //   {
    //     key: "Notation",
    //     name: <Translate value="customer_note" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 200,
    //     filterable: true,
    //   },
    //   {
    //     key: "EmployeeNote",
    //     name: <Translate value="employee_note" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 200,
    //     filterable: true,
    //   },
    //   {
    //     key: "PaymentType",
    //     name: <Translate value="payment" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //     formatter: YuansferFormatter,
    //   },
    //   {
    //     key: "OrderDate",
    //     name: <Translate value="ordered" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //   },
    //   {
    //     key: "DispatchDate",
    //     name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 125,
    //     filterable: true,
    //     formatter: DateMonthFormatter,
    //   },
    //   {
    //     key: "ShipmentDate",
    //     name: <Translate value="shipped" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 110,
    //     filterable: true,
    //     formatter: SecondsDateFormatter,
    //   },
    // ] : [
    //   {
    //     key: "SQNum",
    //     name: <Translate value="ib_no" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: soNumWidth,
    //   },
    //   {
    //     key: "InvoiceNum",
    //     name: <Translate value="invoice_no" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 113,
    //     formatter: InvoiceNumFormatter,
    //   },
    //
    //   {
    //     key: "ContainerNum",
    //     name: <Translate value="container_num" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 120,
    //     filterable: true,
    //   },
    //   {
    //     key: "ContainerSize",
    //     name: <Translate value="container_size" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Deliver_Customer_num",
    //     name: <Translate value="cust_no" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //   },
    //   {
    //     key: "Deliver_CustomerName",
    //     name: <Translate value="cust_name" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 115,
    //   },
    //   {
    //     key: isTN ? "ClientCustName" : "Description",
    //     name: isTN ? "Client.Cust" : <Translate value="description" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 124,
    //   },
    //   {
    //     key: "FinalPrice",
    //     name: <Translate value="final_dollarsign" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //     formatter: CashFormatter,
    //   },
    //   {
    //     key: "Sales_User_Name",
    //     name: <Translate value="sales" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //   },
    //   {
    //     key: "SaleStatus",
    //     name: <Translate value="status" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //   },
    //   {
    //     key: "Notation",
    //     name: <Translate value="customer_note" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 200,
    //     filterable: true,
    //   },
    //   {
    //     key: "EmployeeNote",
    //     name: <Translate value="employee_note" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 200,
    //     filterable: true,
    //   },
    //   {
    //     key: "PaymentType",
    //     name: <Translate value="payment" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //     formatter: YuansferFormatter,
    //   },
    //   // {
    //   //   key: "DrayageTrucker",
    //   //   name: <Translate value="drayage_trucker" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 110,
    //   //   filterable: true,
    //   // },
    //   {
    //     key: "OrderDate",
    //     name: <Translate value="ordered" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //   },
    //   {
    //     key: "DispatchDate",
    //     name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 125,
    //     filterable: true,
    //     formatter: DateMonthFormatter,
    //   },
    //   {
    //     key: "ShipmentDate",
    //     name: <Translate value="arrived" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 110,
    //     filterable: true,
    //     formatter: SecondsDateFormatter,
    //   },
    // ];

    const FJCompleteBackground = (props) => {
      const rowBackground = props.dependentValues.IsComplete
        ? "#4caf50"
        : '';
      return (
        <div style={{ backgroundColor: rowBackground }}>
          <span>{ props.value }</span>
        </div>
      );
    };

    // const FJColumn = this.context.router.routes[1].path === 'outboundOrders' ? [
    //   {
    //     key: "SQNum",
    //     name: <Translate value="ob_no" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: soNumWidth,
    //     formatter: FJCompleteBackground,
    //     getRowMetaData: row => row,
    //   },
    //   {
    //     key: "InvoiceNum",
    //     name: <Translate value="invoice_no" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 113,
    //     formatter: InvoiceNumFormatter,
    //   },
    //   {
    //     key: "Agent",
    //     name: <Translate value="agent" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "ContainerNum",
    //     name: <Translate value="container_num" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Carrier",
    //     name: <Translate value="carrier" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "DeliverByDate",
    //     name: <Translate value="deliver_by_date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "DeliverByTime",
    //     name: <Translate value="deliver_by_time" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "ExtInvoiceNum",
    //     name: <Translate value="ext_invoice" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Broker",
    //     name: <Translate value="broker" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Truckload",
    //     name: <Translate value="truckload" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "TruckNum",
    //     name: <Translate value="truck_num" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "PickupDriver",
    //     name: <Translate value="pickup_driver" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "DropoffDriver",
    //     name: <Translate value="dropoff_driver" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "PickupTrailerNum",
    //     name: <Translate value="pickup_trailer" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "DropoffTrailerNum",
    //     name: <Translate value="dropoff_trailer" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "PickupDate",
    //     name: <Translate value="pickup_date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "PickupTime",
    //     name: <Translate value="pickup_time" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "DropoffDate",
    //     name: <Translate value="dropoff_date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "DropoffTime",
    //     name: <Translate value="dropoff_time" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "PickupCity",
    //     name: <Translate value="pickup_city" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "DropoffCity",
    //     name: <Translate value="dropoff_city" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "PickupState",
    //     name: <Translate value="pickup_state" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "DropoffState",
    //     name: <Translate value="dropoff_state" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Dispatch",
    //     name: <Translate value="dispatch" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "DetentionRate",
    //     name: <Translate value="detention_rate" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "LumperFee",
    //     name: <Translate value="lumper_fee" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Deliver_Customer_num",
    //     name: <Translate value="cust_no" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //   },
    //   {
    //     key: "Deliver_CustomerName",
    //     name: <Translate value="cust_name" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 115,
    //   },
    //   {
    //     key: isTN ? "ClientCustName" : "Description",
    //     name: isTN ? "Client.Cust" : <Translate value="description" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 124,
    //   },
    //   {
    //     key: "FinalPrice",
    //     name: <Translate value="final_dollarsign" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //     formatter: CashFormatter,
    //   },
    //   {
    //     key: "SaleStatus",
    //     name: <Translate value="status" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //   },
    //   {
    //     key: "PaymentType",
    //     name: <Translate value="payment" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //     formatter: YuansferFormatter,
    //   },
    //   {
    //     key: "OrderDate",
    //     name: <Translate value="ordered" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //   },
    //   {
    //     key: "ShipmentDate",
    //     name: <Translate value="shipped" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 110,
    //     filterable: true,
    //     formatter: SecondsDateFormatter,
    //   },
    // ] : [
    //   {
    //     key: "SQNum",
    //     name: <Translate value="ib_no" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: soNumWidth,
    //     formatter: FJCompleteBackground,
    //     getRowMetaData: row => row,
    //   },
    //   {
    //     key: "InvoiceNum",
    //     name: <Translate value="invoice_no" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 113,
    //     formatter: InvoiceNumFormatter,
    //   },
    //   {
    //     key: "Agent",
    //     name: <Translate value="agent" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "ContainerNum",
    //     name: <Translate value="container_num" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "ExtInvoiceNum",
    //     name: <Translate value="ext_invoice" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Broker",
    //     name: <Translate value="broker" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Truckload",
    //     name: <Translate value="truckload" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "TruckNum",
    //     name: <Translate value="truck_num" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "PickupDriver",
    //     name: <Translate value="pickup_driver" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "DropoffDriver",
    //     name: <Translate value="dropoff_driver" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "PickupTrailerNum",
    //     name: <Translate value="pickup_trailer" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "DropoffTrailerNum",
    //     name: <Translate value="dropoff_trailer" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "PickupDate",
    //     name: <Translate value="pickup_date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "PickupTime",
    //     name: <Translate value="pickup_time" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "DropoffDate",
    //     name: <Translate value="dropoff_date" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "DropoffTime",
    //     name: <Translate value="dropoff_time" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "PickupCity",
    //     name: <Translate value="pickup_city" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "DropoffCity",
    //     name: <Translate value="dropoff_city" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "PickupState",
    //     name: <Translate value="pickup_state" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "DropoffState",
    //     name: <Translate value="dropoff_state" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "Dispatch",
    //     name: <Translate value="dispatch" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "DetentionRate",
    //     name: <Translate value="detention_rate" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //   {
    //     key: "LumperFee",
    //     name: <Translate value="lumper_fee" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   },
    //
    //   {
    //     key: "Deliver_Customer_num",
    //     name: <Translate value="cust_no" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //   },
    //   {
    //     key: "Deliver_CustomerName",
    //     name: <Translate value="cust_name" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 115,
    //   },
    //   {
    //     key: isTN ? "ClientCustName" : "Description",
    //     name: isTN ? "Client.Cust" : <Translate value="description" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 124,
    //   },
    //   {
    //     key: "FinalPrice",
    //     name: <Translate value="final_dollarsign" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //     formatter: CashFormatter,
    //   },
    //   {
    //     key: "SaleStatus",
    //     name: <Translate value="status" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //     filterable: true,
    //   },
    //   {
    //     key: "PaymentType",
    //     name: <Translate value="payment" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //     formatter: YuansferFormatter,
    //   },
    //   {
    //     key: "OrderDate",
    //     name: <Translate value="ordered" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 95,
    //     filterable: true,
    //   },
    //   {
    //     key: "ShipmentDate",
    //     name: <Translate value="shipped" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 110,
    //     filterable: true,
    //     formatter: SecondsDateFormatter,
    //   },
    // ];

    let limitSelection = [
      {
        label: '25',
        value: 25,
        name: 'limit',
      },
      {
        label: '50',
        value: 50,
        name: 'limit',
      },
      {
        label: '100',
        value: 100,
        name: 'limit',
      },
      {
        label: <Translate value="all" />,
        value: 99999,
        name: 'limit',
      },
    ]
    // if (isOCM) {
    //   limitSelection = [{
    //     label: '30',
    //     value: 30,
    //     name: 'limit',
    //   }]
    // }

    // if (isSKH) {
    //   const shippingMethodIdx = _.findIndex(columns, { key: 'ShippingMethod' });
    //   const trackingIdx = _.findIndex(columns, { key: "Tracking" });
    //   const ShippingMethodCol = {
    //     key: "ShippingMethod",
    //     name: <Translate value="shipping_method" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 140,
    //     filterable: true,
    //   }
    //   columns.splice(shippingMethodIdx, 1);
    //   columns.splice(trackingIdx + 1, 0, ShippingMethodCol);
    // }

    const generateColumns = () => {
      // if (isABC) {
      //   return ABCColumn;
      // }
      // if (isUSPride) {
      //   return USPrideColumn;
      // }
      // if (isDSQ) {
      //   return DSQColumn;
      // }
      // if (isJTB) {
      //   return JTBColumn;
      // }
      // if (isWIZ) {
      //   return WIZColumn;
      // }
      // if (isFJ) {
      //   return FJColumn;
      // }
      // if (isMAG) {
      //   return MAGColumn;
      // }
      return columns;
    }
    const renderTotalOrders = () => {
      return `${this.state.rowsCount} - ${
        this.state.canceledOrders
      } = ${this.state.rowsCount - this.state.canceledOrders}`
    }
    const showPagination = (isOCM && !isMobile) || (isABC && this.context.router.routes[1].path !== 'salesQuotes')
    const totalPages = isOCM ? this.props.totalPages : this.props.msoTotalPages
    
    let selectedOrderCount = 0;
    if (this.state.salesOrders && this.state.salesOrders.selectedRows && this.state.salesOrders.selectedRows.length > 0) {
      selectedOrderCount = this.state.salesOrders.selectedRows.length;
    }

    return (
      // React Table Sales Order History Table
      <div id={(isTN || isUSPride || isDSQ || isWIZ || isFJ || isJTB || isMAG || isSV || isSKH) && "TNMSOTable"}>
        <Row>
          <Col xs={12}>
            <div id="salesOrders-dataGrid1">
              <ReactDataGrid
                rowRenderer={
                  <RowRenderer
                    // onDoubleClick={this.moveInvoices}
                  />
                }
                rowKey="SalesQuote_id"
                ref={(g) => {
                  this.grid = g;
                }}
                onGridSort={handleGridSort}
                toolbar={isABC ? null : <ToolBarCustom />}
                onAddFilter={handleFilterChange}
                columns={generateColumns()}
                rowHeight={25}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                onClearFilters={onClearFilters}
                minHeight={tableHeight - (isABC ? 100 : 0)} //LALALA
                enableRowSelect="multi"
                rowSelection={{
                  showCheckbox: true,
                  enableShiftSelect: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: "isSelected",
                  },
                }}
                onRowClick={onRowClick}
                onCellSelected={onCellSelected}
              />
            </div>
          </Col>
        </Row>
        {
          showPagination &&
          // false &&
          <Row>
            <Col xs={6} style={{display: 'flex'}}>
              <div style={{ width: '600px' }} id="react-pagination">
                <ReactPaginate
                  previousLabel={<Translate value="prev_page" />}
                  nextLabel={<Translate value="next_page" />}
                  containerClassName={'pagination'}
                  activeClassName={'active'}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  pageCount={totalPages}
                  onPageChange={handleOnPageChange}
                  forcePage={this.state.currentPage}
                />
              </div>
              <div  style={{ width: '100px', marginTop: '6px', marginLeft: '15px'}}>
                <Dropdown>
                  <Dropdown.Toggle style={{ height: '28px', width: '60px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                    {this.state.limitDisplay}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="super-colors">
                    {limitSelection.map(el => {
                      return (
                        <MenuItem onClick={() => handleLimitChange(el)}>{el.label}</MenuItem>
                      )
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Col>
            {/* <Col className="col-sm-3" style={{ width: '90px' }} > */}
            {/*<Col xs={6} >
              <Dropdown>
                <Dropdown.Toggle style={{ width: '60px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                  {this.state.limitDisplay}
                </Dropdown.Toggle>
                <Dropdown.Menu className="super-colors">
                  {limitSelection.map(el => {
                    return (
                      <MenuItem onClick={() => handleLimitChange(el)}>{el.label}</MenuItem>
                    )
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </Col>*/}
          </Row>
        }
        { !isABC &&
          <Row>
            <Col xs={12}>
              <div>
                <Col xs={2}>
                  <label className="row-count">
                    <Translate value="total_orders" />
                    :&nbsp;
                    <span className="font-color-orange" id="row-count-equation">
                      {renderTotalOrders()}
                    </span>
                  </label>
                  <label className="row-count" style={{marginTop: '0px'}}>
                    <Translate value="selected_orders" />
                    :&nbsp;
                    <span className="font-color-orange" id="row-count-equation">
                      {selectedOrderCount}
                    </span>
                  </label>
                </Col>
                <Col xs={6}>
                  <label className="grand-total">
                    <span className="grand-total-label">
                      <Translate value="grand_total" />
                      :&nbsp;
                    </span>
                    <span className="font-color-grey" id="total-equation">
                      {`$${numberWithCommas(
                        (this.state.total || 0).toFixed(2)
                      )} - $${numberWithCommas(
                        (this.state.canceledTotal || 0).toFixed(2)
                      )} = $${numberWithCommas(
                        (this.state.total - this.state.canceledTotal).toFixed(2)
                      )}`}
                    </span>
                  </label>
                  <label className="grand-total" style={{ marginTop: '0px' }}>
                    <span className="grand-total-label">
                      <Translate value="total_weight" />
                      :&nbsp;
                    </span>
                    <span className="font-color-grey" id="total-equation">
                      {`${numberWithCommas(
                        (this.state.totalNetWeight || 0).toFixed(2)
                      )} - ${numberWithCommas(
                        (this.state.totalCancelledNetWeight || 0).toFixed(2)
                      )} = ${numberWithCommas(
                        (this.state.totalNetWeight - this.state.totalCancelledNetWeight).toFixed(2)
                      )}`}
                    </span>
                  </label>
                </Col>
                <Col xs={4}>
                  <div className="mso-footnotes">
                    <span>
                      <Translate value="msg_total_orders_equation" />
                    </span>
                    <span>
                      <Translate value="msg_grand_total_equation" />
                    </span>
                    <span>
                      <Translate value="msg_total_weight_equation" />
                    </span>
                  </div>
                </Col>
              </div>
            </Col>
          </Row>
        }
      </div>
    );
  }

  renderDatePickers() {
    if (this.state.days === -1) {
      return (
        <div className="form-group date-picker-positioner">
          <label className="col-xs-2 from-label col-xs-offset-5">
            <Translate value="from" />
          </label>
          <div className="col-xs-2 control-date-picker">
            <Field name="FromDate" component={DatePicker} />
          </div>
          <label className="col-xs-1 to-label">
            <Translate value="to" />
          </label>
          <div className="col-xs-2 control-date-picker">
            <Field name="ToDate" component={DatePicker} />
          </div>
        </div>
      );
    }
  }

  renderUsers() {
    if (this.props.usersIsLoading) return <WidgetsSpinner />; // If group is loading, show a spinner.
    const Users = this.getUsers();
    return (
      <div style={{ marginRight: "10px" }} className="control-dropdown">
        <Field name="Seller" component={Selection} options={Users} />
      </div>
    );
  }

  getUsers() {
    const Users = [];
    this.props.users.map((user) => {
      Users.push({ value: user.user_id, label: user.username });
    });
    return Users;
  }

  renderAddresses() {
    const Addresses = this.getAddress();
    return (
      <div style={{ margin: "10px" }} className="control-dropdown">
        <Field
          name="Warehouse"
          component={SelectionWithProps}
          options={Addresses}
          onChange={this.onChangeBolAddress}
        />
      </div>
    );
  }

  getAddress() {
    const Addresses = [];
    this.props.bolAddress.map((address) => {
      Addresses.push({
        value: address.FBACode,
        label: address.FBACode + " - " + address.Address,
      });
    });
    return Addresses;
  }

  setToDate = (e) => {
    if (e < this.state.FromDate) {
      return;
    }
    this.setState({ ToDate: e });
  };

  setFromDate = (e) => {
    if (e > this.state.ToDate) {
      return;
    }
    this.setState({ FromDate: e });
  };

  setFromDispatchDate = (e) => {
    if (e > this.state.dispatchDateGT) {
      return;
    }
    this.setState({ dispatchDateLT: e });
  };

  setToDispatchDate = (e) => {
    if (e < this.state.dispatchDateLT) {
      return;
    }
    this.setState({
      dispatchDateGT: e,
    });
  };

  setToRangeSearch = () => {
    this.setState({ days: "-1" });
  };

  setToDispatchRangeSearch = () => {
    this.setState({ dispatchDays: "-1" });
  };

  fetchSalesOrdersByDispatch(dispatchDays) {
    if (this.state.filteredByItem) {
      this.setState({ dispatchDays }, () => {
        this.fetchSalesOrdersByProduct(this.state.filterProductID);
      });
      return;
    }
    let seller = this.props.Seller;
    const productNum = this.props.ProductNum;
    const route = this.context.router.routes[1].path;
    if (this.props.Seller) {
      seller = this.props.Seller.value;
    }

        
    let filterParams = "";
    // if (isOCM) {
    //   const filterPaires = [];
    //   _.forOwn(this.state.salesOrders.filters, (value, key) => {
    //     filterPaires.push([key, value.filterTerm].join('='))
    //   });
    //   filterParams = filterPaires.join('&');
    // }

    if (dispatchDays === "-1" || dispatchDays === -1) {
      this.setState({ dispatchDays }, () => {
        this.props.fetchSalesQuotesByFilterLap(
          this.state.FromDate,
          this.state.ToDate,
          this.state.days,
          this.state.Status,
          seller,
          productNum,
          route,
          this.state.dispatchDateLT,
          this.state.dispatchDateGT,
          dispatchDays,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.state.Type,
          filterParams,
        );
      });
    } else {
      this.setState(
        { dispatchDays, dispatchDateLT: undefined, dispatchDateGT: undefined },
        () => {
          this.props.fetchSalesQuotesByFilterLap(
            this.state.FromDate,
            this.state.ToDate,
            this.state.days,
            this.state.Status,
            seller,
            productNum,
            route,
            this.state.dispatchDateLT,
            this.state.dispatchDateGT,
            dispatchDays,
            this.state.limit,
            this.state.currentPage,
            this.state.searchFilter,
            this.state.Type,
            filterParams
          );
        },
      );
    }
  }

  fetchSalesOrdersByDetails(days, toggleFilterRowBtn) {
    // if (toggleFilterRowBtn) {
    //   if (!_.isEmpty(this.state.salesOrders.filters)) {
    //     const filterRowBtn = document.querySelectorAll('#sales-orders-list .react-grid-Container .react-grid-Toolbar .btn');
    //     filterRowBtn[0].click();
    //   }
    // }
    this.setState({currentPage: 0});
    let salesOrders = {
      ...this.state.salesOrders,
      selectedRows: [],
    };
    let filterParams = "";
    // if (isOCM) {
    //   const filterPaires = [];
    //   _.forOwn(salesOrders.filters, (value, key) => {
    //     filterPaires.push([key, value.filterTerm].join('='))
    //   });
    //   filterParams = filterPaires.join('&');
    // }
    // if (isABC || isABBLE) {
    //   this.setState({ salesOrders });
    // }

    if (this.state.filteredByItem) {
      this.setState({ days }, () => {
        this.fetchSalesOrdersByProduct(this.state.filterProductID);
      });
      return;
    }
    let FromDate = moment().format('YYYY-MM-DD')
    let ToDate = moment().format('YYYY-MM-DD');
    let seller = this.props.Seller;
    const productNum = this.props.ProductNum;
    const route = this.context.router.routes[1].path;
    if (this.state.FromDate != null) {
      FromDate = this.state.FromDate;
    }

    if (this.state.ToDate != null) {
      ToDate = this.state.ToDate;
    }

    if (this.props.Seller) {
      seller = this.props.Seller.value;
    }

    // if (isOCM) {
    //   this.setState({
    //     salesOrders: {
    //       ...this.state.salesOrders,
    //       filters: {},
    //     }
    //   })
    // }

    if (days === "-1" || days === -1) {
      this.setState({ days }, () => {
        this.props.fetchSalesQuotesByFilterLap(
          FromDate,
          ToDate,
          days,
          this.state.Status,
          seller,
          productNum,
          route,
          this.state.dispatchDateLT,
          this.state.dispatchDateGT,
          this.state.dispatchDays,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.state.Type,
          filterParams,
        );
      });
    } else {
      this.setState({ days, FromDate: undefined, ToDate: undefined }, () => {
        this.props.fetchSalesQuotesByFilterLap(
          FromDate,
          ToDate,
          days,
          this.state.Status,
          seller,
          productNum,
          route,
          this.state.dispatchDateLT,
          this.state.dispatchDateGT,
          this.state.dispatchDays,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.state.Type,
          filterParams,
        );
      });
    }
  }

  fetchSalesOrdersByProduct = (productID) => {
    let dateRange = -1;
    let FromDate = moment().format('YYYY-MM-DD');
    let ToDate = moment().format('YYYY-MM-DD');
    let seller = this.props.Seller;
    const route = this.context.router.routes[1].path;
    const productNum = productID;
    if (this.state.FromDate != null) {
      FromDate = this.formatDate(this.state.FromDate);
    }

    if (this.state.ToDate != null) {
      ToDate = this.formatDate(this.state.ToDate);
    }

    if (this.state.days != null) {
      dateRange = this.state.days;
    }
    if (this.props.Seller) {
      seller = this.props.Seller.value;
    }

        
    let filterParams = "";
    // if (isOCM) {
    //   const filterPaires = [];
    //   _.forOwn(this.state.salesOrders.filters, (value, key) => {
    //     filterPaires.push([key, value.filterTerm].join('='))
    //   });
    //   filterParams = filterPaires.join('&');
    // }

    this.setState({
      filteredByItem: true,
      selectedRows: [{}],
      filterProductID: productID,
    });
    this.props.fetchSalesQuotesByFilterLap(
      FromDate,
      ToDate,
      dateRange,
      this.state.Status,
      seller,
      productNum,
      route,
      null,
      null,
      null,
      this.state.limit,
      this.state.currentPage,
      this.state.searchFilter,
      this.state.Type,
      filterParams
    );
  };

  formatDate(date) {
    let formattedDate = `${date.getFullYear()}-`;

    formattedDate += `${date.getMonth() + 1}-`;
    if (date.getDate() < 10) {
      formattedDate += `0${date.getDate()}`;
    } else {
      formattedDate += date.getDate();
    }
    return formattedDate;
  }

  // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

  renderProductsTable() {
    if (this.props.salesOrderIsLoading && !this.props.salesOrderError)
      return <WidgetsSpinner />;
    else if (this.props.salesOrderError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">
            {JSON.stringify(this.props.salesOrderError)}
          </div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid
    const tableHeight = window.innerHeight < 930 ? 185 : 185;
    const getRows = () => Data.Selectors.getRows(this.state.salesOrderDetail);
    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.salesOrderDetail, {
        sortColumn,
        sortDirection,
      });
      this.setState({ salesOrderDetail: state });
    };

    const onClearFilters = () => {
      // all filters removed
      const salesOrderDetail = { ...this.state.salesOrderDetail, filters: {} };
      this.setState({ salesOrderDetail });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.salesOrderDetail.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const salesOrderDetail = {
        ...this.state.salesOrderDetail,
        filters: newFilters,
      };
      this.setState({ salesOrderDetail });
    };

    // Handle the row select function
    const onRowSelect = (rows) => {
      const salesOrderDetail = {
        ...this.state.salesOrderDetail,
        selectedRows: rows,
      };
      this.setState({ salesOrderDetail });
    };

    const VendorNameFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.Name}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    const VendorNumFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    // Column definition
    const showProductCost = () => {
      // if (isHMM || isJML) {
      //   return false;
      // }
      // if ((isJML || isChinaTown) && checkPermissionLocal('no_show_product_cost')) {
      //   return false;
      // }
      return !checkPermissionLocal('no_show_product_cost')
      // return true;
    }

    let netWeightName = <Translate value="net_weight" />;
    let totalWeightName = <Translate value="total_weight" />;

    const columns = [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 140,
      },
      {
        key: "RefNum",
        name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
        resizable: true,
        sortable: true,
        width: 140,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 500,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 140,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 140,
        sortable: true,
        formatter: isLAP? UPriceFormatter : CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 140,
        sortable: true,
        formatter: PriceFormatter,
      }] : [],
      {
        key: "Profit",
        name: <Translate value="profit" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter:({value}) => (
          <span>${Math.round(value * 100) / 100}</span>
        )
      },
      {
        key: "SalesMargin",
        name: <Translate value="sales_margin" />,
        resizable: true,
        width: 120,
        sortable: true,
        formatter:({value}) => (
          <span>{Math.round(value * 100) / 100}%</span>
        )
      }
    ];

    // if (isHO) {
    //   columns.push({
    //     key: "SalesMargin",
    //     name: <Translate value="sales_margin" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //   })
    // }
    // if (isHO || isRivera) {
    //   const totalWTIndex = columns.findIndex(item => item.key === 'TotalNetWeight');
    //   if (totalWTIndex !== -1) {
    //     columns.splice(totalWTIndex, 0, {
    //       key: "ProductTax",
    //       name: <Translate value="total_tax" />,
    //       resizable: true,
    //       width: 70,
    //       sortable: true,
    //     }, {
    //       name: <Translate value="total_crv" />,
    //       resizable: true,
    //       width: 80,
    //       sortable: true,
    //       getRowMetaData: row => row,
    //       formatter: ({ dependentValues }) => {
    //         return <span>{dependentValues.Quantity * dependentValues.CRV}</span>
    //       }
    //     })
    //   }
    // }
    //
    // if (isJML) {
    //   const index1 = _.findIndex(columns, { key: "NetWeight" });
    //   columns.splice(index1, 1);
    //   const index2 = _.findIndex(columns, { key: "TotalNetWeight" });
    //   columns.splice(index2, 1);
    // }
    //
    // if (isABC) {
    //   const indexABC = _.findIndex(columns, { key: "PickupQuantity" });
    //   const temp = {
    //     key: "OriginalQuantity",
    //     name: <Translate value="original_qty" />,
    //     resizable: true,
    //     width: 100,
    //     sortable: true,
    //   };
    //   columns.splice(indexABC, 0, temp);
    // }
    //
    // if (isGGI) {
    //   const col = {
    //     key: 'smallUnitPrice',
    //     name: <Translate value="small_unit_price" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //     getRowMetaData: row => row,
    //     formatter: ({ dependentValues }) => {
    //       if (dependentValues.ProductType !== "Fixed") return null;
    //       const smallUnitPrice = roundTo(dependentValues.UnitPrice / dependentValues.PackageSize_1, 2);
    //       if (isNaN(smallUnitPrice)) return 0;
    //       return <span>${smallUnitPrice}</span>
    //     },
    //   };
    //   const index1 = _.findIndex(columns, { key: "UnitPrice" });
    //   columns.splice(index1, 0, col);
    // }

    // if (isTN) {
    //   const invCol = {
    //     key: "Inventory",
    //     name: <Translate value="inventory" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   };
    //   const handCol = {
    //     key: "OnHand",
    //     name: <Translate value="on_hand" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   };
    //   const convertNumCol = {
    //     key: "pc_box",
    //     name: <Translate value="pack" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   };
    //   const totalBoxNumCol = {
    //     key: "total_box",
    //     name: <Translate value="carton" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     filterable: true,
    //   };
    //   const indexTN = _.findIndex(columns, { key: "PickupQuantity" });
    //   columns.splice(indexTN, 0, invCol, handCol, convertNumCol, totalBoxNumCol);
    // }
    //
    // if (isDAICHEONG) {
    //   const temp = {
    //     key: "UnitPrice",
    //     name: <Translate value="unit_dollarsign" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     getRowMetaData: row => row,
    //     formatter: ({ value, dependentValues }) => {
    //       const markItRed = parseFloat(dependentValues.UnitPrice) < parseFloat(dependentValues.LowestSalePrice)
    //       return <CashFormatter className={markItRed ? 'text-danger' : ''} value={value} />
    //     },
    //   };
    //   const indexDAICHEONG = _.findIndex(columns, { key: "UnitPrice" });
    //   columns.splice(indexDAICHEONG, 1, temp);
    //
    // }

    const isMobile = this.context.router.routes[1].path === "mobileSalesOrders";

    // const dsqColumnBottom = this.context.router.routes[1].path === 'outboundOrders' ? [
    //   // {
    //   //   key: "ContainerNum",
    //   //   name: <Translate value="container_num" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 100,
    //   // },
    //   {
    //     key: "ProductNum",
    //     name: <Translate value="product_num" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "RefNum",
    //     name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
    //     resizable: true,
    //     sortable: true,
    //     width: 70,
    //   },
    //   {
    //     key: "Name",
    //     name: <Translate value="product_name" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 150,
    //   },
    //   {
    //     key: "Description",
    //     name: <Translate value="description" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 150,
    //   },
    //   {
    //     key: "ReceivedQuantity",
    //     name: <Translate value="received_qty" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "FBACode",
    //     name: <Translate value="fba_code" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 90,
    //   },
    //   {
    //     key: "FBARoute",
    //     name: <Translate value="fba_route" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 90,
    //   },
    //   {
    //     key: "TrailerNum",
    //     name: <Translate value="trailer" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 90,
    //   },
    //   {
    //     key: "POList",
    //     name: <Translate value="po_list" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 90,
    //   },
    //   {
    //     key: "POD",
    //     name: <Translate value="pod" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 90,
    //   },
    //   {
    //     key: "InnerLabelQty",
    //     name: <Translate value="inner_label" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 90,
    //   },
    //   {
    //     key: "OuterLabelQty",
    //     name: <Translate value="outer_label" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 90,
    //   },
    //   {
    //     key: "DimUnit",
    //     name: <Translate value="dim_unit" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 90,
    //   },
    //   {
    //     key: "WeightUnit",
    //     name: <Translate value="weight_unit" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 90,
    //   },
    //   {
    //     key: "BoxLength",
    //     name: "Box L",
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 80,
    //   },
    //   {
    //     key: "BoxWidth",
    //     name: "Box W",
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 80,
    //   },
    //   {
    //     key: "BoxHeight",
    //     name: "Box H",
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 80,
    //   },
    //   {
    //     key: "BoxVol",
    //     name: <Translate value="box_cbm" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "BoxWeight",
    //     name: <Translate value="box_weight" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "PalletLength",
    //     name: "Plt L",
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 80,
    //   },
    //   {
    //     key: "PalletWidth",
    //     name: "Plt W",
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 80,
    //   },
    //   {
    //     key: "PalletHeight",
    //     name: "Plt H",
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 80,
    //   },
    //   {
    //     key: "PalletVol",
    //     name: <Translate value="plt_cbm" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "PalletWeight",
    //     name: <Translate value="pallet_weight" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "Quantity",
    //     name: <Translate value="qty" />,
    //     resizable: true,
    //     width: 100,
    //     sortable: true,
    //   },
    //   {
    //     key: "PickupQuantity",
    //     name: <Translate value="shipped_qty" />,
    //     resizable: true,
    //     width: 80,
    //     sortable: true,
    //   },
    //   {
    //     key: "PackageType",
    //     name: <Translate value="pkg_type" />,
    //     resizable: true,
    //     width: 80,
    //     sortable: true,
    //   },
    //   {
    //     key: "UnitPrice",
    //     name: <Translate value="unit_dollarsign" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     formatter: CashFormatter,
    //   },
    //   ...showProductCost() ? [{
    //     key: "CostPrice",
    //     name: <Translate value="cost_price" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //   }] : [],
    //   // {
    //   //   key: 'CostPrice',
    //   //   name: <Translate value="cost_price" />,
    //   //   resizable: true,
    //   //   width: 70,
    //   //   sortable: true,
    //   //   // formatter: CashFormatter,
    //   // },
    //   {
    //     key: "TotalPrice",
    //     name: <Translate value="total_dollarsign" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     formatter: CashFormatter,
    //   },
    //   {
    //     key: "ProductTax",
    //     name: <Translate value="tax" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     formatter: CashFormatter,
    //   },
    //   {
    //     key: "NetWeight",
    //     name: <Translate value="net_weight" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     // formatter: CashFormatter,
    //   },
    //   {
    //     key: "TotalNetWeight",
    //     name: <Translate value="total_weight" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     // formatter: CashFormatter,
    //   },
    // ] : [
    //   {
    //     key: "ProductNum",
    //     name: <Translate value="product_num" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "RefNum",
    //     name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
    //     resizable: true,
    //     sortable: true,
    //     width: 70,
    //   },
    //   {
    //     key: "Name",
    //     name: <Translate value="product_name" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 150,
    //   },
    //   {
    //     key: "Description",
    //     name: <Translate value="description" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 150,
    //   },
    //   {
    //     key: "ReceivedQuantity",
    //     name: <Translate value="received_qty" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "FBACode",
    //     name: <Translate value="fba_code" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 90,
    //   },
    //   {
    //     key: "FBARoute",
    //     name: <Translate value="fba_route" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 90,
    //   },
    //   {
    //     key: "TrailerNum",
    //     name: <Translate value="trailer" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 90,
    //   },
    //   {
    //     key: "POList",
    //     name: <Translate value="po_list" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 90,
    //   },
    //   {
    //     key: "POD",
    //     name: <Translate value="pod" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 90,
    //   },
    //   {
    //     key: "DimUnit",
    //     name: <Translate value="dim_unit" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 90,
    //   },
    //   {
    //     key: "WeightUnit",
    //     name: <Translate value="weight_unit" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 90,
    //   },
    //   {
    //     key: "Quantity",
    //     name: <Translate value="box_qty" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 80,
    //   },
    //   {
    //     key: "BoxLength",
    //     name: "Box L",
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 80,
    //   },
    //   {
    //     key: "BoxWidth",
    //     name: "Box W",
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 80,
    //   },
    //   {
    //     key: "BoxHeight",
    //     name: "Box H",
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 80,
    //   },
    //   {
    //     key: "BoxVol",
    //     name: <Translate value="box_cbm" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "BoxWeight",
    //     name: <Translate value="box_weight" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "PalletQuantity",
    //     name: <Translate value="plt_qty" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 80,
    //   },
    //   {
    //     key: "PalletLength",
    //     name: "Plt L",
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 80,
    //   },
    //   {
    //     key: "PalletWidth",
    //     name: "Plt W",
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 80,
    //   },
    //   {
    //     key: "PalletHeight",
    //     name: "Plt H",
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 80,
    //   },
    //   {
    //     key: "PalletVol",
    //     name: <Translate value="plt_cbm" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "PalletWeight",
    //     name: <Translate value="pallet_weight" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   // {
    //   //   key: "Quantity",
    //   //   name: <Translate value="qty" />,
    //   //   resizable: true,
    //   //   width: 100,
    //   //   sortable: true,
    //   // },
    //   {
    //     key: "PickupQuantity",
    //     name: <Translate value="shipped_qty" />,
    //     resizable: true,
    //     width: 80,
    //     sortable: true,
    //   },
    //   {
    //     key: "PackageType",
    //     name: <Translate value="pkg_type" />,
    //     resizable: true,
    //     width: 80,
    //     sortable: true,
    //   },
    //   {
    //     key: "UnitPrice",
    //     name: <Translate value="unit_dollarsign" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     formatter: CashFormatter,
    //   },
    //   ...showProductCost() ? [{
    //     key: "CostPrice",
    //     name: <Translate value="cost_price" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //   }] : [],
    //   // {
    //   //   key: 'CostPrice',
    //   //   name: <Translate value="cost_price" />,
    //   //   resizable: true,
    //   //   width: 70,
    //   //   sortable: true,
    //   //   // formatter: CashFormatter,
    //   // },
    //   {
    //     key: "TotalPrice",
    //     name: <Translate value="total_dollarsign" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     formatter: CashFormatter,
    //   },
    //   {
    //     key: "ProductTax",
    //     name: <Translate value="tax" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     formatter: CashFormatter,
    //   },
    //   {
    //     key: "NetWeight",
    //     name: <Translate value="net_weight" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     // formatter: CashFormatter,
    //   },
    //   {
    //     key: "TotalNetWeight",
    //     name: <Translate value="total_weight" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     // formatter: CashFormatter,
    //   },
    // ];

    // const wizColumnBottom = this.context.router.routes[1].path === 'outboundOrders' ? [
    //   // {
    //   //   key: "ContainerNum",
    //   //   name: <Translate value="container_num" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   width: 100,
    //   // },
    //   {
    //     key: "ProductNum",
    //     name: <Translate value="product_num" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "RefNum",
    //     name: <Translate value="sku" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 70,
    //   },
    //   {
    //     key: "Name",
    //     name: <Translate value="product_name" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 150,
    //   },
    //   {
    //     key: "Description",
    //     name: <Translate value="description" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 150,
    //   },
    //   {
    //     key: "FBACode",
    //     name: <Translate value="fba" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 80,
    //   },
    //   {
    //     key: "Quantity",
    //     name: isABC ? <Translate value="inbound_qty" /> : <Translate value="shipped_qty" />,
    //     resizable: true,
    //     width: 100,
    //     sortable: true,
    //   },
    //
    //   {
    //     key: "CustomerBoxQty",
    //     name: <Translate value="customer_box" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "OutsideLabelQty",
    //     name: <Translate value="outside_label" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "InsideLabelQty",
    //     name: <Translate value="inside_label" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "SpecialHandling",
    //     name: <Translate value="special_handling" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 150,
    //   },
    //   {
    //     key: "CustomerNote",
    //     name: <Translate value="customer_note" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 150,
    //   },
    //   {
    //     key: "InboundCustomer",
    //     name: <Translate value="inbound_customer" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 110,
    //   },
    //   {
    //     key: "InboundContainer",
    //     name: <Translate value="inbound_container" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 110,
    //   },
    //   {
    //     key: "InboundDate",
    //     name: <Translate value="inbound_date" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 90,
    //     formatter: DateFormatter2,
    //   },
    //   {
    //     key: "ReceivedQuantity",
    //     name: <Translate value="customer_qty" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "ShipmentID",
    //     name: <Translate value="shipment_id" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "BillablePallets",
    //     name: <Translate value="billable_pallets" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "PalletQuantity",
    //     name: <Translate value="real_pallets" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //     editable: true,
    //   },
    //   {
    //     key: "BoxPerPallet",
    //     name: <Translate value="box_per_plt" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //     editable: true,
    //   },
    //   {
    //     key: "DispatchType",
    //     name: <Translate value="dispatch_type" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "BoxLength",
    //     name: "Box L",
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 80,
    //   },
    //   {
    //     key: "BoxWidth",
    //     name: "Box W",
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 80,
    //   },
    //   {
    //     key: "BoxHeight",
    //     name: "Box H",
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 80,
    //   },
    //   {
    //     key: "BoxVol",
    //     name: <Translate value="box_vol" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "BoxWeight",
    //     name: <Translate value="box_weight" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   // {
    //   //   key: "PalletLength",
    //   //   name: "Plt L",
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   filterable: true,
    //   //   width: 80,
    //   // },
    //   // {
    //   //   key: "PalletWidth",
    //   //   name: "Plt W",
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   filterable: true,
    //   //   width: 80,
    //   // },
    //   // {
    //   //   key: "PalletHeight",
    //   //   name: "Plt H",
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   filterable: true,
    //   //   width: 80,
    //   // },
    //   // {
    //   //   key: "PalletVol",
    //   //   name: <Translate value="pallet_vol" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   filterable: true,
    //   //   width: 100,
    //   // },
    //   {
    //     key: "PalletWeight",
    //     name: <Translate value="pallet_weight" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "IsOversize",
    //     name: <Translate value="IsOversize" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //     formatter: ({ value }) => (
    //       <div>
    //         { value ? "true" : "false" }
    //       </div>
    //     ),
    //   },
    //   {
    //     key: "IsOverweight",
    //     name: <Translate value="IsOverweight" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //     formatter: ({ value }) => (
    //       <div>
    //         { value ? "true" : "false" }
    //       </div>
    //     ),
    //   },
    //   {
    //     key: "PortDray",
    //     name: <Translate value="port_dray" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "Location",
    //     name: <Translate value="location" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   // {
    //   //   key: "Quantity",
    //   //   name: isABC ? <Translate value="inbound_qty" /> : <Translate value="qty" />,
    //   //   resizable: true,
    //   //   width: 100,
    //   //   sortable: true,
    //   // },
    //   // {
    //   //   key: "PickupQuantity",
    //   //   name: <Translate value="shipped_qty" />,
    //   //   resizable: true,
    //   //   width: 80,
    //   //   sortable: true,
    //   // },
    //   {
    //     key: "PackageType",
    //     name: <Translate value="pkg_type" />,
    //     resizable: true,
    //     width: 80,
    //     sortable: true,
    //   },
    //   {
    //     key: "UnitPrice",
    //     name: <Translate value="unit_dollarsign" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     formatter: CashFormatter,
    //   },
    //   ...showProductCost() ? [{
    //     key: "CostPrice",
    //     name: <Translate value="cost_price" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //   }] : [],
    //   // {
    //   //   key: 'CostPrice',
    //   //   name: <Translate value="cost_price" />,
    //   //   resizable: true,
    //   //   width: 70,
    //   //   sortable: true,
    //   //   // formatter: CashFormatter,
    //   // },
    //   {
    //     key: "TotalPrice",
    //     name: <Translate value="total_dollarsign" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     formatter: CashFormatter,
    //   },
    //   {
    //     key: "ProductTax",
    //     name: <Translate value="tax" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     formatter: CashFormatter,
    //   },
    //   {
    //     key: "NetWeight",
    //     name: <Translate value="net_weight" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     // formatter: CashFormatter,
    //   },
    //   {
    //     key: "TotalNetWeight",
    //     name: <Translate value="total_weight" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     // formatter: CashFormatter,
    //   },
    // ] : [
    //   {
    //     key: "ProductNum",
    //     name: <Translate value="product_num" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "Location",
    //     name: <Translate value="location" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "RefNum",
    //     name: <Translate value="sku" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 70,
    //   },
    //   {
    //     key: "Name",
    //     name: <Translate value="product_name" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 150,
    //   },
    //   {
    //     key: "Description",
    //     name: <Translate value="description" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 150,
    //   },
    //   {
    //     key: "Quantity",
    //     name: isABC ? <Translate value="inbound_qty" /> : <Translate value="rcvd_qty" />,
    //     resizable: true,
    //     width: 100,
    //     sortable: true,
    //   },
    //   {
    //     key: "ReceivedQuantity",
    //     name: <Translate value="customer_qty" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "ShipmentID",
    //     name: <Translate value="customer_note" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "BillablePallets",
    //     name: <Translate value="billable_pallets" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "PalletQuantity",
    //     name: <Translate value="real_pallets" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //     editable: true,
    //   },
    //   {
    //     key: "BoxPerPallet",
    //     name: <Translate value="box_per_plt" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //     editable: true,
    //   },
    //   {
    //     key: "IsOversize",
    //     name: <Translate value="oversize" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //     formatter: ({ value }) => (
    //       <div>
    //         { value ? "true" : "false" }
    //       </div>
    //     ),
    //   },
    //   {
    //     key: "IsOverweight",
    //     name: <Translate value="overweight" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //     formatter: ({ value }) => (
    //       <div>
    //         { value ? "true" : "false" }
    //       </div>
    //     ),
    //   },
    //   {
    //     key: "DispatchType",
    //     name: <Translate value="warehouse_note" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "DrayageTrucker",
    //     name: <Translate value="dray_trucker" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "BoxLength",
    //     name: "Box L",
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 80,
    //   },
    //   {
    //     key: "BoxWidth",
    //     name: "Box W",
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 80,
    //   },
    //   {
    //     key: "BoxHeight",
    //     name: "Box H",
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 80,
    //   },
    //   {
    //     key: "BoxVol",
    //     name: <Translate value="box_vol" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "BoxWeight",
    //     name: <Translate value="box_weight" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   // {
    //   //   key: "PalletLength",
    //   //   name: "Plt L",
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   filterable: true,
    //   //   width: 80,
    //   // },
    //   // {
    //   //   key: "PalletWidth",
    //   //   name: "Plt W",
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   filterable: true,
    //   //   width: 80,
    //   // },
    //   // {
    //   //   key: "PalletHeight",
    //   //   name: "Plt H",
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   filterable: true,
    //   //   width: 80,
    //   // },
    //   // {
    //   //   key: "PalletVol",
    //   //   name: <Translate value="pallet_vol" />,
    //   //   resizable: true,
    //   //   sortable: true,
    //   //   filterable: true,
    //   //   width: 100,
    //   // },
    //   {
    //     key: "PalletWeight",
    //     name: <Translate value="pallet_weight" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "PortDray",
    //     name: <Translate value="port_dray" />,
    //     resizable: true,
    //     sortable: true,
    //     filterable: true,
    //     width: 100,
    //   },
    //   // {
    //   //   key: "Quantity",
    //   //   name: isABC ? <Translate value="inbound_qty" /> : <Translate value="qty" />,
    //   //   resizable: true,
    //   //   width: 100,
    //   //   sortable: true,
    //   // },
    //   // {
    //   //   key: "PickupQuantity",
    //   //   name: <Translate value="shipped_qty" />,
    //   //   resizable: true,
    //   //   width: 80,
    //   //   sortable: true,
    //   // },
    //   {
    //     key: "PackageType",
    //     name: <Translate value="pkg_type" />,
    //     resizable: true,
    //     width: 80,
    //     sortable: true,
    //   },
    //   {
    //     key: "UnitPrice",
    //     name: <Translate value="unit_dollarsign" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     formatter: CashFormatter,
    //   },
    //   ...showProductCost() ? [{
    //     key: "CostPrice",
    //     name: <Translate value="cost_price" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //   }] : [],
    //   // {
    //   //   key: 'CostPrice',
    //   //   name: <Translate value="cost_price" />,
    //   //   resizable: true,
    //   //   width: 70,
    //   //   sortable: true,
    //   //   // formatter: CashFormatter,
    //   // },
    //   {
    //     key: "TotalPrice",
    //     name: <Translate value="total_dollarsign" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     formatter: CashFormatter,
    //   },
    //   {
    //     key: "ProductTax",
    //     name: <Translate value="tax" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     formatter: CashFormatter,
    //   },
    //   {
    //     key: "NetWeight",
    //     name: <Translate value="net_weight" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     // formatter: CashFormatter,
    //   },
    //   {
    //     key: "TotalNetWeight",
    //     name: <Translate value="total_weight" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     // formatter: CashFormatter,
    //   },
    // ];

    // const jtbColumnBottom = [
    //     {
    //       key: "ProductNum",
    //       name: <Translate value="product_num" />,
    //       resizable: true,
    //       sortable: true,
    //       width: 100,
    //     },
    //     {
    //       key: "RefNum",
    //       name: isTN ? <Translate value="sku" /> : <Translate value={isOLG ? "item_no" : "ref_num"} />,
    //       resizable: true,
    //       sortable: true,
    //       width: isJML ? 200 : 70,
    //     },
    //     {
    //       key: "Name",
    //       name: <Translate value="product_name" />,
    //       resizable: true,
    //       sortable: true,
    //       width: 350,
    //     },
    //     {
    //       key: "Description",
    //       name: <Translate value="description" />,
    //       resizable: true,
    //       sortable: true,
    //       width: 150,
    //     },
    //     {
    //       key: "Quantity",
    //       name: isABC ? <Translate value="inbound_qty" /> : <Translate value="qty" />,
    //       resizable: true,
    //       width: 100,
    //       sortable: true,
    //     },
    //     // {
    //     //   key: "PalletQuantity",
    //     //   name: <Translate value="pallet_qty" />,
    //     //   resizable: true,
    //     //   width: 100,
    //     //   sortable: true,
    //     // },
    //     // {
    //     //   key: "BoxQuantity",
    //     //   name: <Translate value="pallet_qty" />,
    //     //   resizable: true,
    //     //   width: 100,
    //     //   sortable: true,
    //     // },
    //     // {
    //     //   key: "PieceQuantity",
    //     //   name: <Translate value="pallet_qty" />,
    //     //   resizable: true,
    //     //   width: 100,
    //     //   sortable: true,
    //     // },
    //     {
    //       key: "PickupQuantity",
    //       name: <Translate value="shipped_qty" />,
    //       resizable: true,
    //       width: 80,
    //       sortable: true,
    //     },
    //     // {
    //     //   key: "TotalShippingWeight",
    //     //   name: <Translate value="shipping_weight" />,
    //     //   resizable: true,
    //     //   width: 70,
    //     //   sortable: true,
    //     // },
    //     // {
    //     //   key: "PackageType",
    //     //   name: <Translate value="pkg_type" />,
    //     //   resizable: true,
    //     //   width: 80,
    //     //   sortable: true,
    //     // },
    //     {
    //       key: "UnitPrice",
    //       name: <Translate value="unit_dollarsign" />,
    //       resizable: true,
    //       width: 70,
    //       sortable: true,
    //       formatter: CashFormatter,
    //     },
    //     ...showProductCost() ? [{
    //       key: "CostPrice",
    //       name: <Translate value="cost_price" />,
    //       resizable: true,
    //       width: 70,
    //       sortable: true,
    //     }] : [],
    //     // {
    //     //   key: 'CostPrice',
    //     //   name: <Translate value="cost_price" />,
    //     //   resizable: true,
    //     //   width: 70,
    //     //   sortable: true,
    //     //   // formatter: CashFormatter,
    //     // },
    //     {
    //       key: "TotalPrice",
    //       name: <Translate value="total_dollarsign" />,
    //       resizable: true,
    //       width: 70,
    //       sortable: true,
    //       formatter: CashFormatter,
    //     },
    //     {
    //       key: "ProductTax",
    //       name: <Translate value="tax" />,
    //       resizable: true,
    //       width: 70,
    //       sortable: true,
    //       formatter: CashFormatter,
    //     },
    //     // {
    //     //   key: "NetWeight",
    //     //   name: <Translate value="net_weight" />,
    //     //   resizable: true,
    //     //   width: 70,
    //     //   sortable: true,
    //     //   // formatter: CashFormatter,
    //     // },
    //     {
    //       key: "TotalNetWeight",
    //       name: <Translate value="total_weight" />,
    //       resizable: true,
    //       width: 70,
    //       sortable: true,
    //       // formatter: CashFormatter,
    //     },
    // ];
    //
    // const smColumnBottom = [
    //   {
    //     key: "ProductNum",
    //     name: <Translate value="product_num" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //   },
    //   {
    //     key: "RefNum",
    //     name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
    //     resizable: true,
    //     sortable: true,
    //     width: 130,
    //   },
    //   {
    //     key: "Name",
    //     name: <Translate value="product_name" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 300,
    //   },
    //   {
    //     key: "Description",
    //     name: <Translate value="description" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 100,
    //     getRowMetaData: row => row,
    //     formatter: ({ value, dependentValues }) => (
    //       <div>{dependentValues.ProductDescription || value}</div>
    //     )
    //   },
    //   {
    //     key: "PackageSize",
    //     name: <Translate value="package_size" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 150,
    //   },
    //   {
    //     key: "Quantity",
    //     name: <Translate value="qty" />,
    //     resizable: true,
    //     width: 100,
    //     sortable: true,
    //   },
    //   {
    //     key: "NetWeight",
    //     name: <Translate value="net_pcs" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     // formatter: CashFormatter,
    //   },
    //   {
    //     key: "TotalNetWeight",
    //     name: <Translate value="total_pcs" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     // formatter: CashFormatter,
    //   },
    //   {
    //     key: "UnitPrice",
    //     name: <Translate value="unit_dollarsign" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     formatter: CashFormatter,
    //   },
    //   {
    //     key: "TotalPrice",
    //     name: <Translate value="total_dollarsign" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     formatter: CashFormatter,
    //   },
    //   {
    //     key: "PickupQuantity",
    //     name: <Translate value="shipped_qty" />,
    //     resizable: true,
    //     width: 80,
    //     sortable: true,
    //   },
    //   {
    //     key: "BatchLocation",
    //     name: <Translate value="location" />,
    //     resizable: true,
    //     width: 90,
    //     sortable: true,
    //     filterable: true,
    //   },
    //   {
    //     key: "IsNoReturn",
    //     name: <Translate value="no_return" />,
    //     resizable: true,
    //     sortable: true,
    //     // filterable: true,
    //     width: 100,
    //     formatter: ({ value }) => (
    //       <div>
    //         { (value === true || value === 'true') ? "true" : "false" }
    //       </div>
    //     ),
    //   },
    //   {
    //     key: "PackageType",
    //     name: <Translate value="pkg_type" />,
    //     resizable: true,
    //     width: 80,
    //     sortable: true,
    //   },
    //   ...showProductCost() ? [{
    //     key: "CostPrice",
    //     name: <Translate value="cost_price" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //   }] : [],
    //   {
    //     key: "ProductTax",
    //     name: <Translate value="tax" />,
    //     resizable: true,
    //     width: 70,
    //     sortable: true,
    //     formatter: CashFormatter,
    //   },
    // ];

    const generateColumnsBottom = () => {
      // if (isDSQ) {
      //   return dsqColumnBottom;
      // }
      // if (isWIZ) {
      //   return wizColumnBottom;
      // }
      // if (isJTB) {
      //   return jtbColumnBottom;
      // }
      // if (isSH) {
      //   return smColumnBottom;
      // }
      return columns;
    };

    return (
      // Sales Invoice Details
      <Row>
        <Col xs={12}>
          <div id="salesOrders-dataGrid2">
            <ReactDataGrid
              rowKey="SalesQuote_id"
              onGridSort={handleGridSort}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              // columns={columns}
              columns={generateColumnsBottom()}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowHeight={25}
              headerRowHeight={45}
              minHeight={tableHeight}
              onRowUpdated={this.handleRowUpdated}
              onRowSelect={onRowSelect}
            />
          </div>
        </Col>
      </Row>
    );
  }


  saveMagStuff() {
    if (!this.state.magSalesOrderDetail) {
      return;
    }

    const {mag1, mag2} = this.state;

    let magNoteTemp = [];
    if (mag1.DRYRUN) { magNoteTemp.push('DRYRUN')}
        if (mag1.OFFHIRE) { magNoteTemp.push('OFFHIRE')}
        if (mag1.EXTRA_STOP) { magNoteTemp.push('EXTRA_STOP')}
        if (mag1.EXAM) { magNoteTemp.push('EXAM')}
        if (mag1.EXTRA_DELIVERY) { magNoteTemp.push('EXTRA_DELIVERY')}
        if (mag1.STORAGE) { magNoteTemp.push('STORAGE')}
        if (mag1.BOBTAIL_FEE) { magNoteTemp.push('BOBTAIL_FEE')}
        this.state.magSalesOrderDetail.mag_note = magNoteTemp.join(',');

        let magDeliveryStatusTemp = [];
        if (mag2.FREIGHT_HOLD) { magDeliveryStatusTemp.push('FREIGHT_HOLD')}
        if (mag2.CUSTOM_HOLD) { magDeliveryStatusTemp.push('CUSTOM_HOLD')}
        if (mag2.PIERPASS_HOLD) { magDeliveryStatusTemp.push('PIERPASS_HOLD')}
        if (mag2.EXAM) { magDeliveryStatusTemp.push('EXAM')}
        if (mag2.CLOSED_AREA) { magDeliveryStatusTemp.push('CLOSED_AREA')}
        this.state.magSalesOrderDetail.DeliveryStatus = magDeliveryStatusTemp.join(',');

    axios.put(
      (SALES_ORDERS_URL + this.state.magSalesOrderDetail.SalesQuote_id),
      this.state.magSalesOrderDetail,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("Order Saved");
      this.fetchSalesOrdersByDetails(
        this.state.days
      );
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));

    });
  }

  savePicker() {
    let {SelectedPicker, salesOrders} = this.state;
    let {Picker} = this.props;
    const salesOrderIds = [];
    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesQuote_id);
      });
    }
    const salesOrderIdsString = salesOrderIds.join(',');

    let data = null;
    if (Picker) {
      data ={ Picker_User_id: Picker.value };
    }
    axios.put(
      (PICKER_URL + salesOrderIdsString),
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("Picker Assigned");
      this.fetchSalesOrdersByDetails(
        this.state.days
      );
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));

    });
  }

  renderMagContainer() {
    let {magSalesOrderDetail, mag1, mag2} = this.state;

    magSalesOrderDetail.delivery_lfd = magSalesOrderDetail.delivery_lfd ? new Date(magSalesOrderDetail.delivery_lfd) : null;

    const handleContainerChange = (e) => {
      magSalesOrderDetail[e.name] = e.value;
      this.setState( { magSalesOrderDetail });
    }

    const handleContainerDate = (e, keyname) => {
      magSalesOrderDetail[keyname] = e;
      this.setState( { magSalesOrderDetail });
    }

    const handleContainerDrop = (e, keyname) => {
      magSalesOrderDetail[keyname] = e.value;
      this.setState( { magSalesOrderDetail });
    }

    const handleContainerCheck1 = (keyname) => {
      mag1[keyname] = !mag1[keyname];
      this.setState( { mag1 });
    }

    const handleContainerCheck2 = (keyname) => {
      mag2[keyname] = !mag2[keyname];
      this.setState( { mag2 });
    }

    const magTerminalOptions = [
      {label: "EVERPORT", value: "EVERPORT"},
      {label: "LBCT", value: "LBCT"},
      {label: "shippers-MIDDLE", value: "shippers-MIDDLE"},
      {label: "SHIPPERS-ALAMEDA", value: "SHIPPERS-ALAMEDA"},
      {label: 'SHIPPERS-LONGBEACH', value: "SHIPPERS-LONGBEACH"},
      {label: "TRAPAC", value: "TRAPAC"},
      {label: "WBCT", value: "WBCT"},
      {label: 'PCT', value: "PCT"},
      {label: "ITS", value: "ITS"},
      {label: "APM", value: "APM"},
      {label: "C60-MATSON", value: "C60-MATSON"},
      {label: "TTI", value: "TTI"},
      {label: "YUSEN", value: "YUSEN"},
      {label: "FMS", value: "FMS"},
      {label: "PIER-A", value: "PIER-A"},
    ];

    return (
      // Sales Invoice Details
      <Row>
        <Col xs={12}>
          <Col xs={4}>
            <label className="col-xs-4"><Translate value="container_num" /></label>
            <div className="col-xs-8">
              <Input disabled={true} value={magSalesOrderDetail.cntrNum ? magSalesOrderDetail.cntrNum : ""} name="cntrNum" type="text" onChange={(e) => handleContainerChange(e.target)} />
            </div>
            <label className="col-xs-4"><Translate value="bol_num" /></label>
            <div className="col-xs-8">
              <Input disabled={true} value={magSalesOrderDetail.bolNum ? magSalesOrderDetail.bolNum : ""} name="bolNum" type="text" onChange={(e) => handleContainerChange(e.target)} />
            </div>
            <label className="col-xs-4" style={{marginBottom: '15px'}}><Translate value="terminal" /></label>
            <div className="col-xs-8" style={{marginBottom: '15px'}}>
              <Dropdown>
                <Dropdown.Toggle style={{ height: '25px', width: '200px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                  {magSalesOrderDetail.terminal ? magSalesOrderDetail.terminal : 'SELECT'}
                </Dropdown.Toggle>
                <Dropdown.Menu className="super-colors">
                  {magTerminalOptions.map(el => {
                    return (
                      <MenuItem onClick={() => handleContainerDrop(el, 'terminal')}>{el.label}</MenuItem>
                    )
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <label className="col-xs-4" style={{marginBottom: '15px'}}>LFD</label>
            <div className="col-xs-8" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY"
                // max={Today}
                // step={10}
                onChange={(e) => {
                  handleContainerDate(e, 'delivery_lfd')
                }}
                time={false}
                value={magSalesOrderDetail.delivery_lfd}
              />
            </div>
          </Col>
          <Col xs={5}>
            <label className="col-xs-3">HOLD (Select)</label>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="FREIGHT_HOLD"
                checked={mag2.FREIGHT_HOLD}
                onClick={() => {
                  handleContainerCheck2('FREIGHT_HOLD');
                }}
              />
              <span>Freight Hold</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="CUSTOM_HOLD"
                checked={mag2.CUSTOM_HOLD}
                onClick={() => {
                  handleContainerCheck2('CUSTOM_HOLD');
                }}
              />
              <span>Custom Hold</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="PIERPASS_HOLD"
                checked={mag2.PIERPASS_HOLD}
                onClick={() => {
                  handleContainerCheck2('PIERPASS_HOLD');
                }}
              />
              <span>Pierpass Hold</span>
            </div>
            <label style={{marginBottom: '15px'}} className="col-xs-3"></label>
            <div style={{marginBottom: '15px'}} className="col-xs-3">
              <input
                type="checkbox"
                name="EXAM"
                checked={mag2.EXAM}
                onClick={() => {
                  handleContainerCheck2('EXAM');
                }}
              />
              <span>Exam</span>
            </div>
            <div style={{marginBottom: '15px'}} className="col-xs-3">
              <input
                type="checkbox"
                name="CLOSED_AREA"
                checked={mag2.CLOSED_AREA}
                onClick={() => {
                  handleContainerCheck2('CLOSED_AREA');
                }}
              />
              <span>Closed Area</span>
            </div>
            <label style={{marginBottom: '15px'}} className="col-xs-3">&nbsp;</label>
            <label className="col-xs-3">HOLD (Other)</label>
            <div className="col-xs-9">
              <Input value={magSalesOrderDetail.DeliveryStatusOther ? magSalesOrderDetail.DeliveryStatusOther : ""} name="DeliveryStatusOther" type="text" onChange={(e) => handleContainerChange(e.target)} />
            </div>

            <label className="col-xs-3">Note (Select)</label>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="DRYRUN"
                checked={mag1.DRYRUN}
                onClick={() => {
                  handleContainerCheck1('DRYRUN');
                }}
              />
              <span>Dryrun</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="OFFHIRE"
                checked={mag1.OFFHIRE}
                onClick={() => {
                  handleContainerCheck1('OFFHIRE');
                }}
              />
              <span>Offhire</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="EXTRA_STOP"
                checked={mag1.EXTRA_STOP}
                onClick={() => {
                  handleContainerCheck1('EXTRA_STOP');
                }}
              />
            <span>Extra Stop</span>
            </div>

            <label className="col-xs-3"></label>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="EXAM"
                checked={mag1.EXAM}
                onClick={() => {
                  handleContainerCheck1('EXAM');
                }}
              />
              <span>Exam</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="EXTRA_DELIVERY"
                checked={mag1.EXTRA_DELIVERY}
                onClick={() => {
                  handleContainerCheck1('EXTRA_DELIVERY');
                }}
              />
              <span>Extra Delivery</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="STORAGE"
                checked={mag1.STORAGE}
                onClick={() => {
                  handleContainerCheck1('STORAGE');
                }}
              />
              <span>Storage</span>
            </div>

            <label style={{marginBottom: '15px'}} className="col-xs-3"></label>
            <div style={{marginBottom: '15px'}} className="col-xs-3">
              <input
                type="checkbox"
                name="BOBTAIL_FEE"
                checked={mag1.BOBTAIL_FEE}
                onClick={() => {
                  handleContainerCheck1('BOBTAIL_FEE');
                }}
              />
              <span>Bobtail Fee</span>
            </div>
            <label style={{marginBottom: '15px'}} className="col-xs-3">&nbsp;</label>
            <label style={{marginBottom: '15px'}} className="col-xs-3">&nbsp;</label>

            <label className="col-xs-3">Note (Other)</label>
            <div className="col-xs-9">
              <Input value={magSalesOrderDetail.mag_note_other ? magSalesOrderDetail.mag_note_other : ""} name="mag_note_other" type="text" onChange={(e) => handleContainerChange(e.target)} />
            </div>
          </Col>
          <Col xs={3}></Col>
        </Col>
      </Row>
    );
  }

  renderMagLoad() {
    let {magSalesOrderDetail} = this.state;

    magSalesOrderDetail.delivery_lfd = magSalesOrderDetail.delivery_lfd ? new Date(magSalesOrderDetail.delivery_lfd) : null;

    magSalesOrderDetail.pick_appt_date = magSalesOrderDetail.pick_appt_date ? new Date(magSalesOrderDetail.pick_appt_date) : null;
    magSalesOrderDetail.loadout_date = magSalesOrderDetail.loadout_date ? new Date(magSalesOrderDetail.loadout_date) : null;
    magSalesOrderDetail.portwaiting_start_time = magSalesOrderDetail.portwaiting_start_time ? new Date(magSalesOrderDetail.portwaiting_start_time) : null;
    magSalesOrderDetail.portwaiting_finish_time = magSalesOrderDetail.portwaiting_finish_time ? new Date(magSalesOrderDetail.portwaiting_finish_time) : null;

    // if (this.props.salesOrderIsLoading && !this.props.salesOrderError)
    //   return <Spinner />;
    // else if (this.props.salesOrderError) {
    //   return (
    //     <ContentWrapper>
    //       <div className="alert alert-danger">
    //         {JSON.stringify(this.props.salesOrderError)}
    //       </div>
    //     </ContentWrapper>
    //   );
    // }

    // const tableHeight = window.innerHeight < 930 ? 185 : 185;

    // const getRows = () => Data.Selectors.getRows(this.state.salesOrderDetail);

    // const getSize = () => getRows().length;

    // const rowGetter = (rowIdx) => {
    //   const rows = getRows();
    //   return rows[rowIdx];
    // };

    // const generateColumnsBottom = () => {
    //   if (isWIZ) {
    //     return wizColumnBottom;
    //   }
    //   if (isJTB) {
    //     return jtbColumnBottom;
    //   }
    //   return columns;
    // };
    const handleLoadChange = (e) => {
      magSalesOrderDetail[e.name] = e.value;
      this.setState( { magSalesOrderDetail });
    }

    const handleLoadDate = (e, keyname) => {
      magSalesOrderDetail[keyname] = e;
      this.setState( { magSalesOrderDetail });
    }

    return (
      // Sales Invoice Details
      <Row>
        <Col xs={12}>
          <Col xs={4}>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="pickup_appt_date" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY"
                // max={Today}
                // step={10}
                onChange={(e) => {
                  handleLoadDate(e, 'pick_appt_date')
                }}
                time={false}
                value={magSalesOrderDetail.pick_appt_date}
              />
            </div>
            <label className="col-xs-4"><Translate value="pickup_appt_time" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.pick_appt_time ? magSalesOrderDetail.pick_appt_time : ""} name="pick_appt_time" type="text" onChange={(e) => handleLoadChange(e.target)} />
            </div>
            <label className="col-xs-4"><Translate value="pickup_appt_#" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.pick_appt_num ? magSalesOrderDetail.pick_appt_num : ""} name="pick_appt_num" type="text" onChange={(e) => handleLoadChange(e.target)} />
            </div>
          </Col>
          <Col xs={4}>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="loadout_date" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY"
                // max={Today}
                // step={10}
                onChange={(e) => {
                  handleLoadDate(e, 'loadout_date')
                }}
                time={false}
                value={magSalesOrderDetail.loadout_date}
              />
            </div>
            <label className="col-xs-4"><Translate value="chassis_num" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.chassis_num ? magSalesOrderDetail.chassis_num : ""} name="chassis_num" type="text" onChange={(e) => handleLoadChange(e.target)} />
            </div>
          </Col>
          <Col xs={4}>
            <label className="col-xs-4"><Translate value="loadout_port_waiting" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.LOADOUT_PORT_WAITING ? magSalesOrderDetail.LOADOUT_PORT_WAITING : ""} name="LOADOUT_PORT_WAITING" type="text" onChange={(e) => handleLoadChange(e.target)} />
            </div>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="portwaiting_start" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleLoadDate(e, 'portwaiting_start_time')
                }}
                time={true}
                value={magSalesOrderDetail.portwaiting_start_time}
              />
            </div>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="portwaiting_finish" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleLoadDate(e, 'portwaiting_finish_time')
                }}
                time={true}
                value={magSalesOrderDetail.portwaiting_finish_time}
              />
            </div>
          </Col>
        </Col>
      </Row>
    );
  }

  renderMagDelivery() {
    let {magSalesOrderDetail} = this.state;

    magSalesOrderDetail.SCHEDULED_DELIVERY_DATE = magSalesOrderDetail.SCHEDULED_DELIVERY_DATE ? new Date(magSalesOrderDetail.SCHEDULED_DELIVERY_DATE) : null;
    magSalesOrderDetail.ACTUAL_DELIVERY_DATE = magSalesOrderDetail.ACTUAL_DELIVERY_DATE ? new Date(magSalesOrderDetail.ACTUAL_DELIVERY_DATE) : null;
    magSalesOrderDetail.DETENTTION_START_TIME = magSalesOrderDetail.DETENTTION_START_TIME ? new Date(magSalesOrderDetail.DETENTTION_START_TIME) : null;
    magSalesOrderDetail.DETENTION_FINISH_TIME = magSalesOrderDetail.DETENTION_FINISH_TIME ? new Date(magSalesOrderDetail.DETENTION_FINISH_TIME) : null;

    const handleDeliveryChange = (e) => {
      magSalesOrderDetail[e.name] = e.value;
      this.setState( { magSalesOrderDetail });
    }

    const handleDeliveryDrop = (e, keyname) => {
      magSalesOrderDetail[keyname] = e.value;
      this.setState( { magSalesOrderDetail });
    }

    const handleDeliveryDate = (e, keyname) => {
      magSalesOrderDetail[keyname] = e;
      this.setState( { magSalesOrderDetail });
    }

    const magDeliveryTypeOptions = [
      {
        label: 'DROP_HOOK',
        value: 'DROP_HOOK',
      },
      {
        label: 'LIVE_UNLOADING',
        value: 'LIVE_UNLOADING',
      },
    ]

    return (
      // Sales Invoice Details
      <Row>
        <Col xs={12}>
          <Col xs={4}>

            {/* <label className="col-xs-4"><Translate value="delivery_test" /></label>
                                  <div className="col-xs-8">
                                  <Input name="Test2" type="text" onChange={(e) => handleDeliveryChange(e.target)} />
                                  </div> */}

            <label className="col-xs-4" style={{marginBottom: '15px'}}><Translate value="delivery_type" /></label>
            <div className="col-xs-8" style={{marginBottom: '15px'}}>
              <Dropdown>
                <Dropdown.Toggle style={{ height: '25px', width: '150px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                  {magSalesOrderDetail.DELIVERY_TYPE ? magSalesOrderDetail.DELIVERY_TYPE : 'SELECT'}
                </Dropdown.Toggle>
                <Dropdown.Menu className="super-colors">
                  {magDeliveryTypeOptions.map(el => {
                    return (
                      <MenuItem onClick={() => handleDeliveryDrop(el, 'DELIVERY_TYPE')}>{el.label}</MenuItem>
                    )
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>


            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="scheduled_delivery" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleDeliveryDate(e, 'SCHEDULED_DELIVERY_DATE')
                }}
                time={true}
                value={magSalesOrderDetail.SCHEDULED_DELIVERY_DATE}
              />
            </div>
            <label className="col-xs-4" ><Translate value="appointment_#" /></label>
            <div className="col-xs-8" >
              <Input value={magSalesOrderDetail.SCHEDULED_DELIVERY_APPT_NUM ? magSalesOrderDetail.SCHEDULED_DELIVERY_APPT_NUM : ""} name="SCHEDULED_DELIVERY_APPT_NUM" type="text" onChange={(e) => handleDeliveryChange(e.target)} />
            </div>

            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="actual_delivery" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleDeliveryDate(e, 'ACTUAL_DELIVERY_DATE')
                }}
                time={true}
                value={magSalesOrderDetail.ACTUAL_DELIVERY_DATE}
              />
            </div>
          </Col>
          <Col xs={4}>
            <label className="col-xs-4" ><Translate value="detention_waiting_time" /></label>
            <div className="col-xs-8" >
              <Input value={magSalesOrderDetail.DETENTION_WAITING_TIME ? magSalesOrderDetail.DETENTION_WAITING_TIME : ""} name="DETENTION_WAITING_TIME" type="text" onChange={(e) => handleDeliveryChange(e.target)} />
            </div>
            {/* <label className="col-xs-4" ><Translate value="detention_start_time" /></label>
            <div className="col-xs-8" >
            <Input name="DETENTTION_START_TIME" type="text" onChange={(e) => handleDeliveryChange(e.target)} />
            </div>
            <label className="col-xs-4" ><Translate value="detention_finish_time" /></label>
            <div className="col-xs-8" >
            <Input name="DETENTION_FINISH_TIME" type="text" onChange={(e) => handleDeliveryChange(e.target)} />
            </div> */}
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="detention_start_time" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleDeliveryDate(e, 'DETENTTION_START_TIME')
                }}
                time={true}
                value={magSalesOrderDetail.DETENTTION_START_TIME}
              />
            </div>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="detention_finish_time" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleDeliveryDate(e, 'DETENTION_FINISH_TIME')
                }}
                time={true}
                value={magSalesOrderDetail.DETENTION_FINISH_TIME}
              />
            </div>
          </Col>
          <Col xs={4}>
            <label className="col-xs-4" >POD</label>
            <div className="col-xs-8" >
              <Input value={magSalesOrderDetail.POD ? magSalesOrderDetail.POD : ""} name="POD" type="text" onChange={(e) => handleDeliveryChange(e.target)} />
            </div>
          </Col>
        </Col>
      </Row>
    );
  }

  renderMagEmpty() {
    let {magSalesOrderDetail} = this.state;

    magSalesOrderDetail.EMPTY_NOTIFICATION_DATE = magSalesOrderDetail.EMPTY_NOTIFICATION_DATE ? new Date(magSalesOrderDetail.EMPTY_NOTIFICATION_DATE) : null;
    magSalesOrderDetail.EMPTY_PICKUP_DATE = magSalesOrderDetail.EMPTY_PICKUP_DATE ? new Date(magSalesOrderDetail.EMPTY_PICKUP_DATE) : null;
    magSalesOrderDetail.EMPTYIN_APPT_DATETIME = magSalesOrderDetail.EMPTYIN_APPT_DATETIME ? new Date(magSalesOrderDetail.EMPTYIN_APPT_DATETIME) : null;
    magSalesOrderDetail.Empty_Return_FINAL_Date = magSalesOrderDetail.Empty_Return_FINAL_Date ? new Date(magSalesOrderDetail.Empty_Return_FINAL_Date) : null;

    const handleEmptyChange = (e) => {
      magSalesOrderDetail[e.name] = e.value;
      this.setState( { magSalesOrderDetail });
    }

    const handleEmptyDate = (e, keyname) => {
      magSalesOrderDetail[keyname] = e;
      this.setState( { magSalesOrderDetail });
    }
    return (
      // Sales Invoice Details
      <Row>
        <Col xs={12}>
          <Col xs={4}>
            <label className="col-xs-4"><Translate value="empty_status" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.EMPTY_STATUS ? magSalesOrderDetail.EMPTY_STATUS : ""} name="EMPTY_STATUS" type="text" onChange={(e) => handleEmptyChange(e.target)} />
            </div>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="empty_notification" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY"
                // max={Today}
                // step={10}
                onChange={(e) => {
                  handleEmptyDate(e, 'EMPTY_NOTIFICATION_DATE')
                }}
                time={false}
                value={magSalesOrderDetail.EMPTY_NOTIFICATION_DATE}
              />
            </div>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="empty_pickup_date" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY"
                // max={Today}
                // step={10}
                onChange={(e) => {
                  handleEmptyDate(e, 'EMPTY_PICKUP_DATE')
                }}
                time={false}
                value={magSalesOrderDetail.EMPTY_PICKUP_DATE}
              />
            </div>
          </Col>
          <Col xs={4}>
            <label className="col-xs-4"><Translate value="empty_location" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.EMPTY_LOCATION ? magSalesOrderDetail.EMPTY_LOCATION : ""} name="EMPTY_LOCATION" type="text" onChange={(e) => handleEmptyChange(e.target)} />
            </div>
            <label className="col-xs-4"><Translate value="empty-in_terminal" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.EMPTY_IN_TERMINAL ? magSalesOrderDetail.EMPTY_IN_TERMINAL : ""} name="EMPTY_IN_TERMINAL" type="text" onChange={(e) => handleEmptyChange(e.target)} />
            </div>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="empty_appt" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleEmptyDate(e, 'EMPTYIN_APPT_DATETIME')
                }}
                time={true}
                value={magSalesOrderDetail.EMPTYIN_APPT_DATETIME}
              />
            </div>
            <label className="col-xs-4"><Translate value="empty_appt#" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.EMPTY_APPT_NUM ? magSalesOrderDetail.EMPTY_APPT_NUM : ""} name="EMPTY_APPT_NUM" type="text" onChange={(e) => handleEmptyChange(e.target)} />
            </div>
          </Col>
          <Col xs={4}>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="return_final_date" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY"
                // max={Today}
                // step={10}
                onChange={(e) => {
                  handleEmptyDate(e, 'Empty_Return_FINAL_Date')
                }}
                time={false}
                value={magSalesOrderDetail.Empty_Return_FINAL_Date}
              />
            </div>
            <label className="col-xs-4"><Translate value="return_final_terminal" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.Empty_Return_FINAL_TERMINAL ? magSalesOrderDetail.Empty_Return_FINAL_TERMINAL : ""} name="Empty_Return_FINAL_TERMINAL" type="text" onChange={(e) => handleEmptyChange(e.target)} />
            </div>
            <label className="col-xs-4"><Translate value="empty_portwaiting" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.EMPTYIN_PORTWAITING ? magSalesOrderDetail.EMPTYIN_PORTWAITING : ""} name="EMPTYIN_PORTWAITING" type="text" onChange={(e) => handleEmptyChange(e.target)} />
            </div>
          </Col>
        </Col>
      </Row>
    );
  }

  renderProductsTableFJ() {
    if (this.props.salesOrderIsLoading && !this.props.salesOrderError)
      return <WidgetsSpinner />;
    else if (this.props.salesOrderError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">
            {JSON.stringify(this.props.salesOrderError)}
          </div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid

    const tableHeight = window.innerHeight < 930 ? 185 : 185;

    const getRows = () => Data.Selectors.getRows(this.state.salesOrderDetail);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.salesOrderDetail, {
        sortColumn,
        sortDirection,
      });
      this.setState({ salesOrderDetail: state });
    };

    const onClearFilters = () => {
      // all filters removed
      const salesOrderDetail = { ...this.state.salesOrderDetail, filters: {} };
      this.setState({ salesOrderDetail });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.salesOrderDetail.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const salesOrderDetail = {
        ...this.state.salesOrderDetail,
        filters: newFilters,
      };
      this.setState({ salesOrderDetail });
    };

    // Handle the row select function
    const onRowSelect = (rows) => {
      const salesOrderDetail = {
        ...this.state.salesOrderDetail,
        selectedRows: rows,
      };
      this.setState({ salesOrderDetail });
    };

    const VendorNameFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.Name}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    const VendorNumFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    // Column definition
    const showProductCost = () => {
      return !checkPermissionLocal('no_show_product_cost')
    };

    const columns = [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: isTN ? <Translate value="sku" /> : <Translate value={isOLG ? "item_no" : "ref_num"} />,
        resizable: true,
        sortable: true,
        width: isJML ? 200 : 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 350,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Quantity",
        name: isABC ? <Translate value="inbound_qty" /> : <Translate value="qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: "PickupQuantity",
        name: <Translate value="shipped_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      // {
      //   key: 'CostPrice',
      //   name: <Translate value="cost_price" />,
      //   resizable: true,
      //   width: 70,
      //   sortable: true,
      //   // formatter: CashFormatter,
      // },
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
        // formatter: CashFormatter,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
        // formatter: CashFormatter,
      },
    ];

    if (isJML) {
      const index1 = _.findIndex(columns, { key: "NetWeight" });
      columns.splice(index1, 1);
      const index2 = _.findIndex(columns, { key: "TotalNetWeight" });
      columns.splice(index2, 1);
    }

    if (isABC) {
      const indexABC = _.findIndex(columns, { key: "PickupQuantity" });
      const temp = {
        key: "OriginalQuantity",
        name: <Translate value="original_qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      };
      columns.splice(indexABC, 0, temp);
    }

    if (isHMM) {
      const temp = {
        key: "PackageSize",
        name: <Translate value="package_size" />,
        resizable: true,
        width: 100,
        sortable: true,
      };
      columns.splice(5, 0, temp);
    }

    if (isTN) {
      const invCol = {
        key: "Inventory",
        name: <Translate value="inventory" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      const handCol = {
        key: "OnHand",
        name: <Translate value="on_hand" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      const convertNumCol = {
        key: "pc_box",
        name: <Translate value="pack" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      const totalBoxNumCol = {
        key: "total_box",
        name: <Translate value="carton" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      const indexTN = _.findIndex(columns, { key: "PickupQuantity" });
      columns.splice(indexTN, 0, invCol, handCol, convertNumCol, totalBoxNumCol);
    }
    const isMobile = this.context.router.routes[1].path === "mobileSalesOrders";

    const jtbColumnBottom = [
        {
          key: "ProductNum",
          name: <Translate value="product_num" />,
          resizable: true,
          sortable: true,
          width: 100,
        },
        {
          key: "RefNum",
          name: isTN ? <Translate value="sku" /> : <Translate value={isOLG ? "item_no" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: isJML ? 200 : 70,
        },
        {
          key: "Name",
          name: <Translate value="product_name" />,
          resizable: true,
          sortable: true,
          width: 350,
        },
        {
          key: "Description",
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 150,
        },
        {
          key: "Quantity",
          name: isABC ? <Translate value="inbound_qty" /> : <Translate value="qty" />,
          resizable: true,
          width: 100,
          sortable: true,
        },
        {
          key: "PalletQuantity",
          name: <Translate value="pallet_qty" />,
          resizable: true,
          width: 100,
          sortable: true,
        },
        {
          key: "PickupQuantity",
          name: <Translate value="shipped_qty" />,
          resizable: true,
          width: 80,
          sortable: true,
        },
        {
          key: "PackageType",
          name: <Translate value="pkg_type" />,
          resizable: true,
          width: 80,
          sortable: true,
        },
        {
          key: "UnitPrice",
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          width: 70,
          sortable: true,
          formatter: CashFormatter,
        },
        ...showProductCost() ? [{
          key: "CostPrice",
          name: <Translate value="cost_price" />,
          resizable: true,
          width: 70,
          sortable: true,
        }] : [],
        // {
        //   key: 'CostPrice',
        //   name: <Translate value="cost_price" />,
        //   resizable: true,
        //   width: 70,
        //   sortable: true,
        //   // formatter: CashFormatter,
        // },
        {
          key: "TotalPrice",
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          width: 70,
          sortable: true,
          formatter: CashFormatter,
        },
        {
          key: "ProductTax",
          name: <Translate value="tax" />,
          resizable: true,
          width: 70,
          sortable: true,
          formatter: CashFormatter,
        },
        {
          key: "NetWeight",
          name: <Translate value="net_weight" />,
          resizable: true,
          width: 70,
          sortable: true,
          // formatter: CashFormatter,
        },
        {
          key: "TotalNetWeight",
          name: <Translate value="total_weight" />,
          resizable: true,
          width: 70,
          sortable: true,
          // formatter: CashFormatter,
        },
    ];

    const wizColumnBottom = [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value="sku" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "ReceivedQuantity",
        name: <Translate value="received_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "ShipmentID",
        name: <Translate value="shipment_id" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BillablePallets",
        name: <Translate value="billable_pallets" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletQuantity",
        name: <Translate value="real_pallets" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        editable: true,
      },
      {
        key: "BoxPerPallet",
        name: <Translate value="box_per_plt" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        editable: true,
      },
      {
        key: "DispatchType",
        name: <Translate value="dispatch_type" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxLength",
        name: "Box L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxWidth",
        name: "Box W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxHeight",
        name: "Box H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxVol",
        name: <Translate value="box_vol" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxWeight",
        name: <Translate value="box_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      // {
      //   key: "PalletLength",
      //   name: "Plt L",
      //   resizable: true,
      //   sortable: true,
      //   filterable: true,
      //   width: 80,
      // },
      // {
      //   key: "PalletWidth",
      //   name: "Plt W",
      //   resizable: true,
      //   sortable: true,
      //   filterable: true,
      //   width: 80,
      // },
      // {
      //   key: "PalletHeight",
      //   name: "Plt H",
      //   resizable: true,
      //   sortable: true,
      //   filterable: true,
      //   width: 80,
      // },
      // {
      //   key: "PalletVol",
      //   name: <Translate value="pallet_vol" />,
      //   resizable: true,
      //   sortable: true,
      //   filterable: true,
      //   width: 100,
      // },
      {
        key: "PalletWeight",
        name: <Translate value="pallet_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "IsOversize",
        name: <Translate value="IsOversize" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "IsOverweight",
        name: <Translate value="IsOverweight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "PortDray",
        name: <Translate value="port_dray" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "Location",
        name: <Translate value="location" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "Quantity",
        name: isABC ? <Translate value="inbound_qty" /> : <Translate value="qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: "PickupQuantity",
        name: <Translate value="shipped_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      // {
      //   key: 'CostPrice',
      //   name: <Translate value="cost_price" />,
      //   resizable: true,
      //   width: 70,
      //   sortable: true,
      //   // formatter: CashFormatter,
      // },
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
        // formatter: CashFormatter,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
        // formatter: CashFormatter,
      },
    ];

    const generateColumnsBottom = () => {
      if (isWIZ) {
        return wizColumnBottom;
      }
      if (isJTB) {
        return jtbColumnBottom;
      }
      return columns;
    };

    return (
      // Sales Invoice Details
      <Row>
        <Col xs={12}>
          <div id="salesOrders-dataGrid2">
            <ReactDataGrid
              rowKey="SalesQuote_id"
              onGridSort={handleGridSort}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              // columns={columns}
              columns={generateColumnsBottom()}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowHeight={25}
              headerRowHeight={45}
              minHeight={tableHeight}
              onRowUpdated={this.handleRowUpdated}
              onRowSelect={onRowSelect}
            />
          </div>
        </Col>
      </Row>
    );
  }

  shippingIFrameIsLoaded = () => {
    if (!this.state.shippingPdfFrameLoaded) {
      const pdfFrame = window.frames.shippingPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ shippingPdfFrameLoaded: true });
    }
  };

  renderShippingIFrame() {
    if (this.props.shippingListPDF) {
      const file = window.URL.createObjectURL(this.props.shippingListPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.shippingIFrameIsLoaded}
          id="shippingPdf"
          name="shippingPdf"
          src={file}
        />
      );
    }
  }

  packingIFrameIsLoaded = () => {
    if (!this.state.packingListPdfFrameLoaded) {
      const pdfFrame = window.frames.packingPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ packingListPdfFrameLoaded: true });
    }
  };

  renderPackingIFrame() {
    if (this.props.packingListPDF) {
      const file = window.URL.createObjectURL(this.props.packingListPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.packingIFrameIsLoaded}
          id="packingPdf"
          name="packingPdf"
          src={file}
        />
      );
    }
  }

  pickingIFrameIsLoaded = () => {
    if (!this.state.pickingListPdfFrameLoaded) {
      const pdfFrame = window.frames.pickingPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ pickingListPdfFrameLoaded: true });
    }
  };

  renderPickingIFrame() {
    if (this.props.pickingListPDF) {
      const file = window.URL.createObjectURL(this.props.pickingListPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.pickingIFrameIsLoaded}
          id="pickingPdf"
          name="pickingPdf"
          src={file}
        />
      );
    }
  }

  salesOrderIFrameIsLoaded = () => {
    if (!this.state.salesOrderPdfFrameLoaded) {
      const pdfFrame = window.frames.salesOrderPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ salesOrderPdfFrameLoaded: true });
    }
  };

  renderSalesOrderIFrame() {
    if (this.props.salesOrderPDF) {
      const file = window.URL.createObjectURL(this.props.salesOrderPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.salesOrderIFrameIsLoaded}
          id="salesOrderPdf"
          name="salesOrderPdf"
          src={file}
        />
      );
    }
  }

  bolByIdIFrameIsLoaded = () => {
    if (!this.state.bolIdPdfFrameLoaded) {
      const pdfFrame = window.frames.bolIdPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ bolIdPdfFrameLoaded: true });
    }
  };
  renderBolByIdIFrame() {
    if (this.props.bolIdPDF) {
      const file = window.URL.createObjectURL(this.props.bolIdPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.bolByIdIFrameIsLoaded}
          id="bolIdPdf"
          name="bolIdPdf"
          src={file}
        />
      );
    }
  }

  bolWithoutLogIFrameIsLoaded = () => {
    if (!this.state.bolWithoutLogPdfFrameLoaded) {
      const pdfFrame = window.frames.bolWithoutLogPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ bolWithoutLogPdfFrameLoaded: true });
    }
  };

  renderBolWithoutLogIFrame() {
    if (this.props.bolWithoutLogPDF) {
      const file = window.URL.createObjectURL(this.props.bolWithoutLogPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.bolWithoutLogIFrameIsLoaded}
          id="bolWithoutLogPdf"
          name="bolWithoutLogPdf"
          src={file}
        />
      );
    }
  }

  bolLabelIFrameIsLoaded = () => {
    if (!this.state.bolLabelFrameLoaded) {
      const pdfFrame = window.frames.bolLabel;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ bolLabelFrameLoaded: true });
    }
  };

  renderBolLabelIFrame() {
    if (this.props.bolLabel) {
      const file = window.URL.createObjectURL(this.props.bolLabel);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.bolLabelIFrameIsLoaded}
          id="bolLabel"
          name="bolLabel"
          src={file}
        />
      );
    }
  }

  bolByFbaIFrameIsLoaded = () => {
    if (!this.state.bolFbaPdfFrameLoaded) {
      const pdfFrame = window.frames.bolFbaPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ bolFbaPdfFrameLoaded: true });
    }
  };

  PODIframLoaded = () => {
    if (!this.state.PODIframeLoaded) {
      const pdfFrame = window.frames.podPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ PODIframeLoaded: true });
    }
  }
  renderBolByFbaIFrame() {
    if (this.props.bolFbaPDF) {
      const file = window.URL.createObjectURL(this.props.bolFbaPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.bolByFbaIFrameIsLoaded}
          id="bolFbaPdf"
          name="bolFbaPdf"
          src={file}
        />
      );
    }
  }

  // renderPODIFrame() {
  //   if (this.state.selectedPODFile) {
  //     const file = window.URL.createObjectURL(this.state.selectedPODFile);
  //     return (
  //       <iframe
  //         style={{ display: "none" }}
  //         onLoad={this.PODIframLoaded}
  //         id="podPdf"
  //         name="podPdf"
  //         src={file}
  //       />
  //     );
  //   }
  // }

  renderPrint() {
    const salesQuote_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesQuote_id;

    const saleStatus =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SaleStatus;

    // if(!salesQuote_id)
    //   return;
    const url = `${ROOT_URL}v1/sale/printorder/${salesQuote_id}?Bearer=${localStorage.getItem(
      "token"
    )}`;
    const picking_url = `${ROOT_URL}v1/sale/printpickinglist/${salesQuote_id}?Bearer=${localStorage.getItem(
      "token"
    )}`;
    const shipping_url = `${ROOT_URL}v1/sale/printshippinglist/${salesQuote_id}?Bearer=${localStorage.getItem(
      "token"
    )}`;
    const packing_url = `${ROOT_URL}v1/sale/printpackinglist/${salesQuote_id}?Bearer=${localStorage.getItem(
      "token"
    )}`;
    return (
      <div className="padLeft" id={isABC && "buttonsContainer-padLeft"}>
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={!salesQuote_id || !checkPermission("print_sales_order")}
          type="button"
          onClick={() => {
            this.props.printSalesQuoteLap(salesQuote_id, this.state.Status);
          }}
        >
          <em className="fa fa-print" />
          <Translate value={isLAP ? "download_sq" : "print_sq"} />
        </Button>
        
        {/* isSV && this.renderPickingListPrint2() */}
        {/* !(isABC || isSV) && this.renderPickingListPrint() */}
        {/* !(isABC || isSV) && this.renderPackingListPrint() */}
        {/* { isSV && this.renderPackingListPrint(true) } */}
        {/* isSV && this.renderPickingListPrint2(true) */}
        {/* !(isABC || isSV) && this.renderShippingListPrint() */}
        {/* (isCO || isABC) && this.renderSubmitBolImageButton() */}
        {/* isABC && this.renderUploadPODButton() */}
        {/* { isABC && this.renderLocatioinChangeButton() } */}
        {/* isABC && this.renderInboundDateEditButton() */}
        {/* isABC &&
          <Button
            style={{ float: 'right' }}
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              this.setState({
                abcDatePickerShow: !this.state.abcDatePickerShow,
              });
            }}
          >
            <Translate value="advanced_search" />
          </Button>
        */}
      </div>
    );
  }

  renderPickingListPrint2(location) {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesQuote_id);
      });
    }

    const hasQuote = salesOrders.selectedRows.some(el => el.SaleStatus === 'Quote');
    const svPendingDisable = salesOrders.selectedRows.some(el => el.SaleStatus === 'Pending'); //Pending

      return (
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={hasQuote || salesOrderIds.length === 0 || !checkPermission("print_sales_order") || svPendingDisable}
          type="button"
          onClick={() => {
            this.props.printPickingList(salesOrderIds.join(","), location);
          }}
        >
          <em className="fa fa-print" />
         <Translate
          value={
             (isSV && location) ? "picking_list_location" : "picking_list"
           }
         /> 
        </Button>
      );
  }

  renderPickingListPrint() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    const salesQuote_id =
      salesOrders.selectedRows.length === 1 &&
      salesOrders.selectedRows[0].SalesQuote_id;
    if (salesOrders && salesOrders.selectedRows.length > 1) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesQuote_id);
      });
    }

    const hasQuote = salesOrders.selectedRows.some(el => el.SaleStatus === 'Quote');
    const svPendingDisable = salesOrders.selectedRows.some(el => el.SaleStatus === 'Pending'); //Pending

    if (salesOrders.selectedRows.length <= 1) {
      return (
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={hasQuote || !salesQuote_id || !checkPermission("print_sales_order") || svPendingDisable}
          type="button"
          onClick={() => {
            this.props.printPickingList(salesQuote_id);
          }}
        >
          <em className="fa fa-print" />
          <Translate
            value={isMyuMyu || isAFG || isWecom ? "pull_sheet" : "picking_list"}
          />
        </Button>
      );
    }
    if (isAFG || isMyuMyu || isWecom) {
      return (
        <Button
          bsStyle="primary"
          className="print-btn"
          type="button"
          disabled={!checkPermission("print_sales_order")}
          onClick={() => {
            // this.props.printPickingList(salesOrderIds.join(','));
            this.openChangePullSheet();
          }}
        >
          <em className="fa fa-print" />
          <Translate value="pull_sheet" />
        </Button>
      );
    }
    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        type="button"
        disabled={!checkPermission("print_sales_order") || hasQuote || svPendingDisable}
        onClick={() => {
          this.props.printPickingList(salesOrderIds.join(","));
        }}
      >
        <em className="fa fa-print" />
        <Translate value="picking_list" />
      </Button>
    );
  }

  renderPackingListPrint(location) {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    const hasQuote = salesOrders.selectedRows.some(el => el.SaleStatus === 'Quote');
    const svPendingDisable = salesOrders.selectedRows.some(el => el.SaleStatus === 'Pending'); //Pending

    let allHaveInvoiceNum = true;
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesQuote_id);
        if (!salesOrder.InvoiceNum && isHMM) {
          allHaveInvoiceNum = false;
        }
      });
    }

    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        disabled={
          salesOrderIds.length === 0 ||
          !checkPermission("print_sales_order") ||
          !allHaveInvoiceNum ||
          hasQuote ||
          svPendingDisable
        }
        type="button"
        onClick={() => {
          this.props.printPackingList(salesOrderIds.join(","), location);
        }}
      >
        <em className="fa fa-print" />
        <Translate
          value={
            (isSV && location) ? "packing_list_location" : "packing_list"
          }
        />
      </Button>
    );
  }

  renderShippingListPrint() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesQuote_id);
      });
    }
    const hasQuote = salesOrders.selectedRows.some(el => el.SaleStatus === 'Quote');
    const svPendingDisable = salesOrders.selectedRows.some(el => el.SaleStatus === 'Pending'); //Pending

    if (isSH) return null;
    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        disabled={
          salesOrderIds.length === 0 || !checkPermission("print_sales_order") || hasQuote || svPendingDisable
        }
        type="button"
        onClick={() => {
          this.props.printShippingList(salesOrderIds.join(","));
        }}
      >
        <em className="fa fa-print" />
        <Translate value="shipping_list" />
      </Button>
    );
  }

  renderSubmitBolImageButton() {
    const { selectedRows } = this.state.salesOrders;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={
          this.context.router.routes[1].path !== "mobileSalesOrders" ||
          selectedRows.length !== 1
        }
        type="button"
        onClick={() => {
          this.openSubmitImage();
        }}
      >
        <em className="fa fa-upload" />
        <Translate value="submit_image" />
      </Button>
    );
  }

  renderUploadPODButton = () => {
    const { selectedRows } = this.state.salesOrders;

    return (
      <div>
        <input
          type='file'
          ref='uploadPODRef'
          onChange={(e) => {
            const file = e.target.files[0];
            const formData = new FormData();
            formData.append('PODFile', file);
            const succes = () => {
              this.fetchSalesOrdersByDetails(this.state.days);
            };
            podUpload(selectedRows[0].SalesQuote_id, formData, succes);
          }}
          style={{ display: 'none' }}
        />
        <Button
          bsStyle="success"
          className="print-btn"
          type="button"
          disabled={selectedRows.length !== 1}
          onClick={() => {
            this.refs.uploadPODRef.click();
          }}
        >
          <em className="fa fa-upload" />
          <Translate value="POD_upload" />
        </Button>
      </div>
    );
  }

  setLocationChangeModalVisibility = (isLocationChangeModalVisible = false) => this.setState({ isLocationChangeModalVisible });
  setInboundDateChangeModalVisibility = (isInboundDateChangeModalVisibile = false) => this.setState({ isInboundDateChangeModalVisibile });

  handleLocationChangeSuccess = () => {
    // alert('success!');
    this.refreshSOList();
    this.setLocationChangeModalVisibility();
    this.setInboundDateChangeModalVisibility();
  }
  renderLocatioinChangeButton = () => {
    const { selectedRows } = this.state.salesOrders;

    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        type="button"
        disabled={selectedRows.length !== 1}
        onClick={() => {
          this.setLocationChangeModalVisibility(true);
        }}
      >
        <em className="fa fa-pencil" />
        <Translate value="location_edit" />
      </Button>
    );
  }
  renderInboundDateEditButton = () => {
    const { selectedRows } = this.state.salesOrders;

    return (
      <Button
      bsStyle="primary"
      className="print-btn"
      type="button"
      disabled={selectedRows.length !== 1}
      onClick={() => {
        this.setInboundDateChangeModalVisibility(true);
      }}
    >
      <em className="fa fa-pencil" />
      <Translate value="other_info_edit" />
    </Button>
    )
  }

  renderPrintLabelButton() {
    // if (isSKH) {
    //   return null;
    // }
    const salesQuote_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesQuote_id;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        // href={exportUrl}
        disabled={!checkPermission("print_sales_order")}
        onClick={() => {
          this.props.printSalesOrderLabel(salesQuote_id);
        }}
      >
        <em className="fa fa-print" />
        <Translate value="print_label" />
      </Button>
    );
  }

  renderPrintLabelButtonDSQ() {
    const salesQuote_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesQuote_id;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        disabled={!checkPermission("print_sales_order") || this.state.salesOrders.selectedRows.length !== 1}
        onClick={() => {
          this.openDSQPrint();
          // this.props.printSalesOrderLabel(salesQuote_id);
        }}
      >
        <em className="fa fa-print" />
        <Translate value="print_label" />
      </Button>
    );
  }

  renderUploadFileButton = () => {
    const {
      salesOrders: {
        selectedRows,
      }
    } = this.state;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        disabled={selectedRows.length !== 1}
        onClick={() => {
          this.refs["file-upload-ref"].click();
          // this.openDSQPrint();
          // this.props.printSalesOrderLabel(salesQuote_id);
        }}
      >
        <em className="fa fa-upload" />
        <Translate value="upload_file" />
      </Button>
    );
  }

  renderMergeSOButton = () => {
    const {
      salesOrders: {
        selectedRows,
      }
    } = this.state;
    let selectedRowsSameCustomer = true;
    if (selectedRows.length) {
      const Deliver_Customer_id = selectedRows[0].Deliver_Customer_id;
      for(let i = 1; i < selectedRows.length; i ++) {
        if (selectedRows[i].Deliver_Customer_id !== Deliver_Customer_id) {
          selectedRowsSameCustomer = false;
        }
      }
    }
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        disabled={selectedRows.length < 2 || !selectedRowsSameCustomer}
        onClick={() => {
          const ids = _.map(selectedRows, row => row.pk).join(',');
          const soNums = _.map(selectedRows, row => row.SQNum).join(',')
          const success = (mergeSODetails) => {
            this.setState({
              mergeSODetails,
              showShippingOpen: true,
              mergeSOLines: mergeSODetails.Sales_Quote_Lines,
              mergeSOIds: ids,
              mergeSONums: soNums,
            });
          }
          this.props.fetchMultiSOLines(ids, success);
        }}
      >
        {/* <em className="fa fa-merge" /> */}
        <Translate value="merge_so" />
      </Button>
    );
  }

  renderDuplicateSOButton = () => {
    const {
      salesOrders: {
        selectedRows,
      }
    } = this.state;
    return (
      <SpinnerButton
        bsStyle="success"
        disabled={selectedRows.length !== 1 || this.state.duplicateSOLoading}
        icon="fa-copy"
        translation={<Translate value="duplicate_so" />}
        loading={this.state.duplicateSOLoading}
        onClick={() => {
          this.setState({
            duplicateSOLoading: true,
          })
          const success = () => {
            alert('Success!');
            this.refreshSOList();
            this.setState({
              duplicateSOLoading: false,
            })
          }
          const failed = () => {
            this.setState({
              duplicateSOLoading: false,
            })
          }
          this.props.duplicateSOAPI(selectedRows[0].pk, success, failed);
        }}
        />
    );
  }

  renderPrintLabelUSPride = () => {
    const {
      selectedRows,
    } = this.state.salesOrders;

    let hasTracking = false;
    selectedRows.map(r=> {
      if (r.TrackingNum) {
        hasTracking = true;
      }
    });

    if (!this.props.requestingSalesOrderPDF) {
      return (
        <Button
          bsStyle="success"
          type="button"
          className="print-btn"
          disabled={selectedRows.length < 1}
          onClick={() => {
            const salesQuote_id = [];
            selectedRows.forEach(({ SalesQuote_id }) => {
              salesQuote_id.push(SalesQuote_id)
            });
            if (hasTracking) {
              this.openPridePrint();
            } else {
              this.props.printSalesOrderLabelUSPride({ salesQuote_id });
            }
          }}
        >
          <em className="fa fa-print" />
          <Translate value="new_shipping" />
        </Button>
      );
    } else {
      return (
        <SpinnerButton
          bsStyle="success"
          disabled={true}
          icon="fa-print"
          translation={<Translate value="new_shipping" />}
          loading={true}
          onClick={() => {
            console.log('loading');
          }}
        />
      )
    }
  }

  renderReprintLabelUSPride = () => {
    const {
      selectedRows,
    } = this.state.salesOrders;
    let missingTracking = false;
    selectedRows.map(r=> {
      if (!r.TrackingNum) {
        missingTracking = true;
      }
    });

    return (
      <Button
        bsStyle="success"
        type="button"
        className="print-btn"
        disabled={selectedRows.length < 1 || missingTracking}
        onClick={() => {
          const salesQuote_id = [];
          selectedRows.forEach(({ SalesQuote_id }) => {
            salesQuote_id.push(SalesQuote_id);
          });
          this.props.reprintSalesOrderLabelUSPride({ salesQuote_id });
        }}
      >
        <em className="fa fa-print" />
        <Translate value="reprint_shipping" />
      </Button>
    );
  }

  renderPrintLabelButtonAFG() {
    const SalesQuote_id = [];
    const SalesOrder_trackingNum = [];
    let hasInvoice = true;
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.map((r) => {
        if ((r.InvoiceNum === "" || !r.InvoiceNum) && isAFG === true) {
          hasInvoice = false;
        }
        SalesQuote_id.push(r.SalesQuote_id);
        if (r.TrackingNum) {
          SalesOrder_trackingNum.push(r.TrackingNum);
        }
      });
    }
    this.state.trackingNumberSelected = SalesQuote_id;
    return (
      <Button
        bsStyle="success"
        type="button"
        className="print-btn"
        // href={exportUrl}
        disabled={
          hasInvoice === false ||
          SalesQuote_id.length === 0 ||
          !checkPermission("print_sales_order")
        }
        onClick={() => {
          if (
            SalesOrder_trackingNum[0] &&
            SalesOrder_trackingNum[0].length > 0 &&
            (isAFG || isNBT)
          ) {
            this.openPrintTrackingConfirm();
          } else {
            this.props.printSalesOrderLabelBatch(SalesQuote_id);
          }
        }}
      >
        <em className="fa fa-print" />
        <Translate value="print_label" />
      </Button>
    );
  }

  renderSendEmailButton = () => {
    const { selectedRows } = this.state.salesOrders;
    const salesQuote_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesQuote_id;

    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={selectedRows.length !== 1}
        type="button"
        onClick={() => {
          this.setState({
            emailSubjectTemplate: this.genSubjectTemplate(),
            emailContentTemplate: this.genContentTemplate(),
            emailContentModalVisibility: true,
            source: "SQ",
          })
        }}
      >
        <Translate value="send_sq" />
      </Button>
    );
  }

  renderResetLocationButton = () => {
    const { selectedRows } = this.state.salesOrders;
    const salesQuote_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesQuote_id;
    const saleStatus =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SaleStatus;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={selectedRows.length !== 1 || !(saleStatus==='Quote' || saleStatus==='Open' || saleStatus==='Packing')}
        type="button"
        onClick={() => {
          this.props.resetLocation(salesQuote_id);
        }}
      >
        <Translate value="reset_location" />
      </Button>
    );
  }

  renderSOUploadButton = () => {
    const isMobile = this.context.router.routes[1].path === "mobileSalesOrders";

    if ((isABBLE || isSV) && isMobile) {
      const handleUpload = (platform, formData) => {
        const success = () => {
          alert('success');
          this.refreshSOList();
        }
        const failed = (err) => {
          alert(JSON.stringify(err));
        }
        axios({
          method: 'post',
          url:  `${ROOT_URL}v2/abble_import_order?platform=${platform}`,
          data: formData,
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
        .then(res => {
          success();
        })
        .catch(err => {
          failed(err.data);
        })
      }

      return (
        <div>
          <input
            ref='hayneedle_po_upload_ref'
            type='file'
            name='hayneedle'
            id="hayneedle_po_upload_ref"
            onChange={(e) => {
              const files = e.target.files;
              const formData = new FormData();
              formData.append('FILE', files[0]);
              handleUpload('hayneedle', formData);
              e.target.value = null;
            }}
            style={{ display: 'none' }}
          />
          <input
            id="faire_po_upload_ref"
            ref='faire_po_upload_ref'
            type='file'
            name='faire'
            onChange={(e) => {
              const files = e.target.files;
              const formData = new FormData();
              formData.append('FILE', files[0]);
              handleUpload('faire', formData);
              e.target.value = null;
            }}
            style={{ display: 'none' }}
          />
          <input
            id="dropship_upload_ref"
            ref='dropship_upload_ref'
            type='file'
            name='faire'
            onChange={(e) => {
              const files = e.target.files;
              const formData = new FormData();
              formData.append('FILE', files[0]);
              handleUpload('dropship', formData);
              e.target.value = null;
            }}
            style={{ display: 'none' }}
          />
          {
            !isSV &&
            <DropdownButton
              bsStyle="success"
              // disabled={!this.props.currentSalesOrder}
              title={
                <span>
                  {/* <i className="fa fa-print" /> */}
                  <Translate value="upload_so" />
                </span>
              }
            >
              {/* <MenuItem onClick={() => {
                this.refs.hayneedle_po_upload_ref.click();
              }}>
                <Translate value="hayneedle" />
              </MenuItem> */}
              <MenuItem onClick={() => {
                this.refs.faire_po_upload_ref.click();
              }}>
                <Translate value="faire" />
              </MenuItem>
              <MenuItem onClick={() => {
                this.refs.dropship_upload_ref.click();
              }}>
                <Translate value="dropship" />
              </MenuItem>
            </DropdownButton>
          }
        </div>
      )
    }
    return <span />
  }

  setShippingRateVisibility = (isShipingRateVisible = false) => this.setState({ isShipingRateVisible });
  handleTeapplixPrintClick = (row) => {
    const { salesOrders } = this.state;
    this.props.selectTeapplixShipping(row.Code, salesOrders.selectedRows[0].SalesQuote_id);
    this.setShippingRateVisibility();
  }
  renderTeapplixButton  = () => {
    const isMobile = this.context.router.routes[1].path === "mobileSalesOrders";
    const { salesOrders } = this.state;
    const salesOrderIds = [];
    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesQuote_id);
      });
    }
    const salesOrderIdsString = salesOrderIds.join(',');

    if ((isABBLE || isSV || isSKH) && isMobile) {
      const successDelete = () => {
        alert('Success on delete teapplix label');
        this.refreshSOList();
      }

      if (isSKH) {
        return <div>
        <DropdownButton
          bsStyle="success"
          disabled={!salesOrders.selectedRows.length}
          title={
            <span>
              {/* <i className="fa fa-print" /> */}
              <Translate value="teapplix" />
            </span>
          }
        >
          <Button
            bsStyle="primary"
            className="print-btn"
            disabled={!salesOrders.selectedRows.length || this.props.requestingSalesOrderPDF}
            type="button"
            onClick={() => { 
              if (salesOrders.selectedRows[0].Channel === "amazon-US" && salesOrders.selectedRows.length === 1) {
                this.setShippingRateVisibility(true);
              } else {
                this.props.selectTeapplixShipping('', salesOrderIdsString);
              }
             }}
          >
            <i className="fa fa-print" />
            <Translate value="print_label" />
          </Button>
          <Button
            bsStyle="primary"
            className="print-btn"
            disabled={!salesOrders.selectedRows.length|| this.props.requestingSalesOrderPDF}
            type="button"
            onClick={() => { this.props.printTeapplixLabel(salesOrderIdsString); }}
          >
            <i className="fa fa-print" />
            <Translate value="reprint_label" />
          </Button>
          <Button
            bsStyle="danger"
            className="print-btn"
            disabled={!salesOrders.selectedRows.length}
            type="button"
            onClick={() => { this.props.deleteTeapplixShipping(salesOrderIdsString, successDelete); }}
          >
            <em className="fa fa-trash" />
            <Translate value="cancel_label" />
          </Button>
        </DropdownButton>
      </div>
      }

      return (
        <div>
          <DropdownButton
            bsStyle="success"
            disabled={!salesOrders.selectedRows.length}
            title={
              <span>
                {/* <i className="fa fa-print" /> */}
                <Translate value="teapplix" />
              </span>
            }
          >
            <Button
              bsStyle="primary"
              className="print-btn"
              disabled={!salesOrders.selectedRows.length|| this.props.requestingSalesOrderPDF}
              type="button"
              onClick={() => { this.props.printTeapplixLabel(salesOrderIdsString); }}
            >
              <i className="fa fa-print" />
              <Translate value="reprint_label" />
            </Button>
            <Button
              bsStyle="primary"
              className="print-btn"
              disabled={!salesOrders.selectedRows.length || this.props.requestingSalesOrderPDF}
              type="button"
              onClick={() => { this.props.selectTeapplixShipping('FEDEX_GROUND', salesOrderIdsString); }}
            >
              <i className="fa fa-print" />
              <Translate value="print_fedex_ground" />
            </Button>
            <Button
              bsStyle="primary"
              className="print-btn"
              disabled={!salesOrders.selectedRows.length || this.props.requestingSalesOrderPDF}
              type="button"
              onClick={() => { this.props.selectTeapplixShipping('FEDEX_HOME', salesOrderIdsString); }}
            >
              <i className="fa fa-print" />
              <Translate value="print_fedex_home" />
            </Button>
            <Button
              bsStyle="primary"
              className="print-btn"
              disabled={!salesOrders.selectedRows.length || this.props.requestingSalesOrderPDF}
              type="button"
              onClick={() => { this.props.selectTeapplixShipping('FEDEX_2DAY', salesOrderIdsString); }}
            >
              <i className="fa fa-print" />
              <Translate value="print_fedex_2_day" />
            </Button>
            <Button
              bsStyle="primary"
              className="print-btn"
              disabled={!salesOrders.selectedRows.length || this.props.requestingSalesOrderPDF}
              type="button"
              onClick={() => { this.props.selectTeapplixShipping('UPS_GROUND', salesOrderIdsString); }}
            >
              <i className="fa fa-print" />
              <Translate value="print_ups_ground" />
            </Button>
            <Button
              bsStyle="danger"
              className="print-btn"
              disabled={!salesOrders.selectedRows.length}
              type="button"
              onClick={() => { this.props.deleteTeapplixShipping(salesOrderIdsString, successDelete); }}
            >
              <em className="fa fa-trash" />
              <Translate value="cancel_label" />
            </Button>
          </DropdownButton>
        </div>
      )
    }
    return <span />
  }

  renderTeapplixResyncButton = () => {
    const {
      salesOrders,
    } = this.state;
    const handleRecyncClick = () => {
      if (salesOrders.selectedRows.length === 1) {
        this.resyncTeapplix(salesOrders.selectedRows[0].PONum);
      } else {
        this.setTeapplixResyncModalVisibility(true);
      }
    }

    return (
      <Button
      bsStyle="success"
      className="print-btn"
      disabled={!(salesOrders.selectedRows.length === 1 || salesOrders.selectedRows.length === 0)}
      type="button"
      onClick={handleRecyncClick}
    >
      {/* <em className="fa fa-sync" /> */}
      <Translate value="tp_resync" />
    </Button>
    )
  }

  renderAcknowledgeOrdersButton = () => {
    const {
      salesOrders,
    } = this.state;
    const handleAcknowledgeClick = () => {
      const ids = salesOrders.selectedRows.map(r => r.SalesQuote_id).join(',');
      const success = () => {
        alert('Orders Acknowledge Success');
      }
      this.props.acknowledgeApi(ids, success)
    }

    return (
      <Button
      bsStyle="success"
      className="print-btn"
      disabled={!salesOrders.selectedRows.length}
      type="button"
      onClick={handleAcknowledgeClick}
    >
      {/* <em className="fa fa-sync" /> */}
      <Translate value="acknowledge" />
    </Button>
    )
  }
  
  renderChangeShipMethodButton = () => {
    const { selectedRows } = this.state.salesOrders;
  
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={selectedRows.length !== 1}
        type="button"
        onClick={() => {this.openChangeShipMethodModal()}}
      >
        <Translate value="ship_method" />
      </Button>
    )
  }

  renderPickerButton = () => {
    const {
      salesOrders,
    } = this.state;

    return (
      <Button
      bsStyle="success"
      className="print-btn"
      disabled={salesOrders.selectedRows.length < 1}
      type="button"
      onClick={() => this.openPicker()}
    >
      {/* <em className="fa fa-sync" /> */}
      <Translate value="assign_picker" />
    </Button>
    )
  }

  resyncTeapplix = (PONum, successCallBack = () => {}) => {
    const success = (message = 'Success!') => {
      alert(message);
      successCallBack();
      this.refreshSOList();
    }
    const failed = (errMsg = 'Unknown') => {
      alert(errMsg);
    }
    this.props.teapplixResyncWithPONum(PONum, success, failed)
  }

  setTeapplixResyncModalVisibility = (isTeapplixResyncModalVisibile = false) => this.setState({ isTeapplixResyncModalVisibile });

  renderMissingSKUsButton = () => {
    if (!isABBLE) return null;
    const {
      salesOrders,
    } = this.state;
    const handleMissingSKUsClick = () => {
      this.setMissingSKUsModalVisibility(true);
    }

    return (
      <Button
      bsStyle="success"
      className="print-btn"
      disabled={salesOrders.selectedRows.length !== 1}
      type="button"
      onClick={handleMissingSKUsClick}
    >
      {/* <em className="fa fa-sync" /> */}
      <Translate value="missing_skus" />
    </Button>
    )
  }

  setMissingSKUsModalVisibility = (isMissingSKUsModalVisible = false) => this.setState({ isMissingSKUsModalVisible });

  renderAssignDriverButton = () => {
    const {
      salesOrders: { selectedRows },
    } = this.state;
    return (
      <DropdownButton
        bsStyle="primary"
        title={
          <span>
            <i className="fa fa-print" />
            <Translate value=" Assign_to_driver" />
          </span>
        }
        className='assign_to_driver_dropdown'
      >
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={selectedRows.length !== 1}
          type="button"
          onClick={() => {
            this.setState({
              assigningInboundDriver: true,
              assigningOutboundDriver: false,
            }, () => this.setDriverListModalVisibility(true));
          }}
        >
          <em className="fa fa-car" />
          <Translate value="Assign_inbound_driver" />
        </Button>
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={selectedRows.length !== 1}
          type="button"
          onClick={() => {
            this.setState({
              assigningInboundDriver: false,
              assigningOutboundDriver: true,
            }, () => this.setDriverListModalVisibility(true))
          }}
        >
          <em className="fa fa-car" />
          <Translate value="Assign_outbound_driver" />
        </Button>
      </DropdownButton>
    );
  };

  renderUpdateNumberButton() {
    const {
      salesOrders: { selectedRows },
    } = this.state;
    return (
      <DropdownButton
        bsStyle="primary"
        title={
          <span>
            <i className="fa fa-print" />
            <Translate value="update_no" />
          </span>
        }
      >
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={selectedRows.length !== 1}
          type="button"
          onClick={() => {
            this.setISAEditModalVisibility(true);
          }}
        >
          <em className="fa fa-pencil" />
          <Translate value="update_customer_bol" />
        </Button>
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={selectedRows.length !== 1}
          type="button"
          onClick={() => {
            this.setCTNEditModalVisibility(true);
          }}
        >
          <em className="fa fa-pencil" />
          <Translate value="update_ctn_no" />
        </Button>
      </DropdownButton>
    );
  }

  renderExportButton(qb = undefined) {
    const { FromDate, ToDate, days } = this.state;
    const status =
      this.state.Status === "all" ? "" : `&SaleStatus=${this.state.Status}`;
    const dateRange = days || -1;
    const { fromDate, toDate } = toFromDates(dateRange, FromDate, ToDate);
    const route = this.props.route.path;
    const orderType =
      route === "salesQuotes" ? "sales_quote" : "sales_mobile_order";

    let salesOrderIds = "";
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows.length >= 1) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds += `${row.SalesQuote_id},`;
      });
    }
    salesOrderIds = salesOrderIds.substring(0, salesOrderIds.length - 1);

    let filterParams = "";
    if (isOCM) {
      const filterPaires = [];
      _.forOwn(salesOrders.filters, (value, key) => {
        filterPaires.push([key, value.filterTerm].join('='))
      });
      if (filterPaires.length) {
        filterParams = `&${filterPaires.join('&')}`;
      }
    }

    const exportUrl = `${ROOT_URL}v1/sale/${orderType}/search/${
      !qb ? "export" : "export_for_quick_books"
    }/?OrderDate__gte=${fromDate}&OrderDate__lte=${toDate}${status}${filterParams}&Bearer=${localStorage.getItem(
      "token"
    )}`;

    const exportUrl1 = `${ROOT_URL}v1/sale/${orderType}/search/${
      !qb ? "export" : "export_for_quick_books"
    }/${salesOrderIds}?Bearer=${localStorage.getItem("token")}`;

    return (
      <Button
        bsStyle="success"
        type="button"
        href={salesOrderIds === "" ? exportUrl : exportUrl1}
        disabled={!checkPermission("print_sales_order")}
      >
        <em className="fa fa-download" />
        <Translate value={qb ? "excel_qb" : "excel"} />
      </Button>
    );
  }
  
  renderCreateExportButton() {
    const route = this.props.route.path;
    const orderType = route === "salesQuotes" ? "sales_quote" : "sales_mobile_order";

    const handleUpload = (platform, formData) => {
      const success = () => {
        alert('success');
        this.refreshSOList();
      }
      const failed = (err) => {
        alert(JSON.stringify(err));
      }
      axios({
        method: 'post',
        url:  `${ROOT_URL}v2/import_sales_order/?platform=${platform}`,
        data: formData,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      })
      .then(res => {
        success();
      })
      .catch(err => {
        failed(err.data);
      })
    }
    return (
      <div>
        <input
          ref='kohlsb2b_excel_ref'
          type='file'
          name='kohlsb2b'
          id="kohlsb2b_excel_ref"
          onChange={(e) => {
            const files = e.target.files;
            const formData = new FormData();
            formData.append('FILE', files[0]);
            handleUpload('kohlsb2b', formData);
            e.target.value = null;
          }}
          style={{ display: 'none' }}
        />
        <input
          ref='belk_excel_ref'
          type='file'
          name='belk'
          id="belk_excel_ref"
          onChange={(e) => {
            const files = e.target.files;
            const formData = new FormData();
            formData.append('FILE', files[0]);
            handleUpload('belk', formData);
            e.target.value = null;
          }}
          style={{ display: 'none' }}
        />
        <input
          ref='costco_excel_ref'
          type='file'
          name='costco'
          id="costco_excel_ref"
          onChange={(e) => {
            const files = e.target.files;
            const formData = new FormData();
            formData.append('FILE', files[0]);
            handleUpload('costco', formData);
            e.target.value = null;
          }}
          style={{ display: 'none' }}
        />
        
        <DropdownButton
          bsStyle="success"
          title={
            <span>
              <i className="fa fa-downloa" />
              <Translate value="create_excel" />
            </span>
          }
        >
          {
            (orderType==='sales_quote') ?
              <div>
                <MenuItem onClick={() => {
                  this.refs.kohlsb2b_excel_ref.click();
                }}>
                  <Translate value="kohlsb2b" />
                </MenuItem>
                <MenuItem onClick={() => {
                  this.refs.belk_excel_ref.click();
                }}>
                  <Translate value="belk" />
                </MenuItem>
              </div>
            :
              <MenuItem onClick={() => {
                this.refs.costco_excel_ref.click();
              }}>
                <Translate value="costco" />
              </MenuItem>
          }
        </DropdownButton>
      </div>
    );
  }
  
  renderDscoShipmentButton() {
    return (
      <Button
        style={{ marginLeft: '5px' }}
        bsStyle="success"
        type="button"
        onClick={() => { this.refs.dsco_ref.click(); }}
        disabled={false}
      >
        <em className="fa fa-upload" /><Translate value="dsco_shipment" />
      </Button>
    );
  }

  renderExportSelectedButton() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesQuote_id);
      });
    }

    const exportUrl = `${ROOT_URL}v2/so-line-export/${salesOrderIds.join(",")}?Bearer=${localStorage.getItem("token")}`

    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={(!salesOrderIds || salesOrderIds.length < 1)}
      >
        <em className="fa fa-print" />
        <Translate value="excel_lines" />
      </Button>
    );
  }

  dsqExcelTemplate() {
    const exportUrl = `${ROOT_URL}v2/so-template?Bearer=${localStorage.getItem("token")}`;
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={false}
      >
        <em className="fa fa-download" />
        MSO Template
      </Button>
    );
  }

  dsqOutboundTemplate() {
    const exportUrl = `${ROOT_URL}v2/ob-template?Bearer=${localStorage.getItem("token")}`;
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={false}
      >
        <em className="fa fa-download" />
        OB Template
      </Button>
    );
  }

  magExcelTemplate() {
    const exportUrl = `${ROOT_URL}v2/so-template?Bearer=${localStorage.getItem("token")}`;
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={false}
      >
        <em className="fa fa-download" />
        <Translate value="excel_template" />
      </Button>
    );
  }

  jtbExcelTemplate() {
    const exportUrl = `${ROOT_URL}v2/so-template?Bearer=${localStorage.getItem("token")}`
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={false}
      >
        <em className="fa fa-download" />
        <Translate value="ib_excel_template" />
      </Button>
    );
  }

  wizExcelTemplate() {
    const exportUrl = `${ROOT_URL}v2/so-template?Bearer=${localStorage.getItem("token")}`
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={false}
      >
        <em className="fa fa-download" />
        <Translate value="ib_excel_template" />
      </Button>
    );
  }

  bolList() {
    const { selectedRows } = this.state.salesOrders;
    const salesQuote_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesQuote_id;
    return (
      <Button
        bsStyle="success"
        type="button"
        onClick={() => {
          this.openbolListModal();
        }}
        disabled={false}
        >
        <em className="fa fa-list" />
        <Translate value="bol_list" />
      </Button>
    );
  }

  generateBOL() {
    const { selectedRows } = this.state.salesOrders;
    const salesQuote_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesQuote_id;
    return (
      <Button
        bsStyle="success"
        type="button"
        onClick={() => {
          this.openGenerateBOLModal();
        }}
        disabled={selectedRows.length < 1}
        >
        <em className="fa fa-plus" />
        <Translate value="bol" />
      </Button>
    );
  }

  fjExcelTemplate() {
    const exportUrl = `${ROOT_URL}v2/so-template?Bearer=${localStorage.getItem("token")}`
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={false}
      >
        <em className="fa fa-download" />
        <Translate value="ib_excel_template" />
      </Button>
    );
  }

  renderCreateTaskButton() {
    const { selectedRows } = this.state.salesOrders;
    const salesQuote_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesQuote_id;
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={
          this.context.router.routes[1].path !== "mobileSalesOrders" ||
          selectedRows.length !== 1
        }
        onClick={() => {
          this.props.createMobileTask(salesQuote_id);
        }}
      >
        <Translate value="on_fleet" />
      </Button>
    );
  }

  renderChangeWeightButton() {
    const { selectedRows } = this.state.salesOrders;
    const salesQuote_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesQuote_id;
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={
          this.context.router.routes[1].path !== "mobileSalesOrders" ||
          selectedRows.length !== 1
        }
        onClick={() => {
          this.openChangeWeight();
        }}
      >
        <Translate value="change_weight_button" />
      </Button>
    );
  }

  renderChowbusImportButton() {
    return (
      <Button
        bsStyle="success"
        type="button"
        onClick={() => {
          this.openChowbusModal();
        }}
      >
        <Translate value="chowbus" />
      </Button>
    );
  }

  renderPaymentMethodChangeButton() {
    const { selectedRows } = this.state.salesOrders;
    const salesQuote_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesQuote_id;
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={
          this.context.router.routes[1].path !== "mobileSalesOrders" ||
          selectedRows.length !== 1
        }
        onClick={() => {
          // this.openChangeWeight();
          this.openChangePaymentMethodModal();
        }}
      >
        <Translate value="change_payment_method" />
      </Button>
    );
  }

  renderReshipButton() {
    const { selectedRows } = this.state.salesOrders;
    const salesQuote_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesQuote_id;
    let hasInvoice = true;
    if (
      selectedRows[0] &&
      (!selectedRows[0].InvoiceNum || selectedRows[0].InvoiceNum === "")
    ) {
      hasInvoice = false;
    }
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={
          hasInvoice === false ||
          this.context.router.routes[1].path !== "mobileSalesOrders" ||
          selectedRows.length !== 1
        }
        onClick={() => {
          this.openConfirmReship();
        }}
      >
        <Translate value="reship" />
      </Button>
    );
  }

  renderQuoteButton() {
    const { selectedRows } = this.state.salesOrders;
    let onlyQuote = true;
    selectedRows.map((r) => {
      if (r.SaleStatus !== "Pending" && isGGI) {
        onlyQuote = false;
      }
      if (r.SaleStatus !== "Quote" && !isGGI) {
        onlyQuote = false;
      }
    });
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={
          !onlyQuote || selectedRows.length !== 1
        }
        onClick={() => {
          if (!isSKH) {
          this.openConfirmQuote();
          } else {
            this.onConfirmQuote();
          }
        }}
      >
        <Translate value="set_order" />
      </Button>
    );
  }

  renderPendingButton = () => {
    const { selectedRows } = this.state.salesOrders;
    let onlyQuote = true;
    let disabled = false;
    if (selectedRows.length !== 1) {
      disabled = true;
    }
    if (selectedRows.length === 1 && selectedRows[0].SaleStatus !== "Quote") {
      disabled = true;
    }
    if (!checkPermissionLocal('sales_order_approve')) {
      // disabled = true;
    }
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={disabled}
        onClick={() => {
          this.setPendingConfirmModalVisibility(true);
        }}
      >
        <Translate value="set_pending" />
      </Button>
    );
  }

  onConfirmApproveOrders = () => {
    let { salesOrders } = this.state;
    let salesOrderIds = [];
    let salesOrderIdsString = '';
    if (salesOrders && salesOrders.selectedRows.length >= 1) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesQuote_id);
      });
      salesOrderIdsString = salesOrderIds.join(',');
    }

    axios
    .post(
      `${ROOT_URL}v1/sale/sales_order/approve_pending/${salesOrderIdsString}`,
      // formData,
      null,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "token"
          )}`,
        },
      },
    )
    .then(
      (res) => {
        alert("Orders Approved!");
        this.fetchSalesOrdersByDetails(
          this.state.days
        );
      },
      (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
        }
        alert(JSON.stringify(err.data));
      }
    );
  }

  renderApprovePendingButtonSV = () => {
    const { selectedRows } = this.state.salesOrders;
    let disabled = false;

    if (selectedRows && selectedRows.length >= 1) {
      selectedRows.map((row) => {
        if (row.SaleStatus !== 'Pending') { //Pending
          disabled = true;
        }
      });
    }
    if (selectedRows && selectedRows.length < 1) {
      disabled = true;
    }

    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={disabled}
        onClick={() => {
         this.onConfirmApproveOrders();
        }}
      >
        <Translate value="approve_pending" />
      </Button>
    );
  }

  renderToQuoteButton = () => {
    if (!isOCM && !isGGI) return null;
    const { selectedRows } = this.state.salesOrders;
    let disabled = true;
    if (selectedRows.length === 1 && (selectedRows[0].SaleStatus === "Packing" || selectedRows[0].SaleStatus === "Open" || selectedRows[0].SaleStatus === "Pending")) {
      disabled = false;
    }
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={disabled}
        onClick={() => {
          this.setQuoteConfirmModalVisibility(true);
        }}
      >
        <Translate value="set_quote" />
      </Button>
    );
  }

  renderDavisPO() {
    const { selectedRows } = this.state.salesOrders;
    let onlyOpen = true;
    // selectedRows.map(r=> {
    //   if (r.SaleStatus !== 'Open') {
    //     onlyOpen = false;
    //   }
    // });
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={!onlyOpen || selectedRows.length !== 1}
        onClick={() => {
          this.openDavisPO();
        }}
      >
        <Translate value="davis_po" />
      </Button>
    );
  }

  renderDriverImageButton() {
    const { selectedRows } = this.state.salesOrders;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={selectedRows.length !== 1}
        type="button"
        onClick={() => {
          this.openShowDriverImage();
        }}
      >
        <em className="fa fa-print" />
        <Translate value="show_image" />
      </Button>
    );
  }

  renderPrintBolButton() {
    const salesQuote_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesQuote_id;
    return (
      <DropdownButton
        bsStyle="primary"
        title={
          <span>
            <i className="fa fa-print" />
            <Translate value=" print_bol" />
          </span>
        }
      >
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={!salesQuote_id}
          type="button"
          onClick={() => {
            this.props.printBolById(salesQuote_id);
          }}
        >
          <em className="fa fa-print" />
          <Translate value="print_bol_by_id" />
        </Button>
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={!salesQuote_id}
          type="button"
          onClick={() => {
            this.openPrintBol();
          }}
        >
          <em className="fa fa-print" />
          <Translate value="print_bol_by_address" />
        </Button>
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={!salesQuote_id}
          type="button"
          onClick={() => {
            this.props.printBolWithoutLog(salesQuote_id);
          }}
        >
          <em className="fa fa-print" />
          <Translate value="print_bol_without_log" />
        </Button>
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={!salesQuote_id}
          type="button"
          onClick={() => {
            this.props.printBolLabel(salesQuote_id);
          }}
        >
          <em className="fa fa-print" />
          <Translate value="print_bol_label" />
        </Button>
      </DropdownButton>
    );
  }

  renderDriverImage() {
    let imageFile = "/img/dummy.png";
    if (this.state.salesOrders.selectedRows[0]) {
      imageFile = this.state.salesOrders.selectedRows[0].OrderImage;
    }
    return (
      <div style={{ position: "relative" }}>
        <img
          style={{ width: "200px", height: "200px" }}
          src={imageFile}
          onClick={() => window.open(imageFile, "_blank")}
        />
      </div>
    );
  }
  renderSignatureImage() {
    let imageFile = "/img/dummy.png";
    if (this.state.salesOrders.selectedRows[0]) {
      imageFile = this.state.salesOrders.selectedRows[0].SignatureImage;
    }
    return (
      <div style={{ position: "relative" }}>
        <img
          style={{ width: "200px", height: "200px" }}
          src={imageFile}
          onClick={() => window.open(imageFile, "_blank")}
        />
      </div>
    );
  }

  onDrop(row, files) {
    if (!files) {
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const index = row.props.rowIdx;
      const newRows = this.state.salesOrders.selectedRows;
      newRows[index].BolImageUrl = reader.result;
      this.setState({ rows: newRows, file: files[0] });
    };
    // get the first file and convert to blob object (Blob.slice([start [, end [, contentType]]))
    const blob = files[0].slice(0, files[0].size, files[0].type);
    reader.readAsDataURL(blob);
  }

  onRowValueChange = (event, rowValues, type) => {
    // merge updated row with current row and rerender by setting state
    this.setState({ sortColumn: null, sortDirection: null });
    const rows = JSON.parse(JSON.stringify(this.state.rows));
    const editedRows = this.state.editedRows.slice(0);
    rows[rowValues.Index][type] = event.target.value;
    editedRows.forEach((element, idx) => {
      if (element.Index === rows[rowValues.Index].Index) {
        editedRows.splice(idx, 1);
      }
    }, this);
    // push the row into the editedRows array
    editedRows.push(rows[rowValues.Index]);
    this.setState({
      rows,
      editedRows,
    });
  };

  renderAutoSuggest() {
    if (!this.state.filteredByItem) {
      return (
        <div className="control-dropdown">
          <GenericProductSuggest
            value={this.state.suggestValue}
            onChange={(e, { newValue }) => {
              this.setState({ suggestValue: newValue });
            }}
            SearchType={this.state.productSearchType}
            fetchOrdersByProduct={this.fetchSalesOrdersByProduct}
          />
        </div>
      );
    }
    return (
      <div id="suggestion-box">
        {this.state.suggestValue}
        <em
          className="fa fa-times pull-right"
          onClick={() => {
            this.setState(
              {
                filteredByItem: false,
                suggestValue: "",
                filterProductID: null,
              },
              () => {
                this.fetchSalesOrdersByDetails(this.state.days);
              },
            );
          }}
        />
      </div>
    );
  }

  renderInvoiceNoSearchInput = () => {
    return (
      <input
        placeholder={this.state.productSearchType === "CustName" ? "Cust Name" : "Order No."}
        value={this.state.invoiceNoSearchTerm}
        onChange={(e) =>
          this.setState({
            invoiceNoSearchTerm: e.target.value,
          })
        }
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            if (this.state.invoiceNoSearchTerm) {
              if (this.state.productSearchType === 'invoiceNo') {
                const pathname = this.context.router.location.pathname;
                this.props.searchSalesQuoteByNumLap(
                  this.state.invoiceNoSearchTerm,
                  pathname
                );
              } else if (this.state.productSearchType === 'CustName') {
                const pathname = this.context.router.location.pathname;
                this.props.searchSalesQuoteByNumLap(
                  this.state.invoiceNoSearchTerm,
                  pathname,
                  null,
                  null,
                  'CustName'
                );
              }
            } else {
              this.fetchSalesOrdersByDetails(this.state.days);
            }
          }
        }}
        style={{
          outline: "none",
          width: "100%",
          height: "24px",
          padding: "10px 10px",
          fontFamily: "Helvetica, sans-serif",
          fontWeight: "300",
          fontSize: "12px",
          border: "1px solid #aaa",
          borderRadius: "4px",
        }}
      />
    );
  };

  renderTrackingNoSearchInput = () => {
    return (
      <input
        placeholder="Tracking No."
        value={this.state.trackingNoSearchTerm}
        onChange={(e) =>
          this.setState({
            trackingNoSearchTerm: e.target.value,
          })
        }
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            if (this.state.trackingNoSearchTerm) {
              const pathname = this.context.router.location.pathname;
              this.props.searchInvoicesByTrackingNo(
                this.state.trackingNoSearchTerm,
                pathname,
              );
            } else {
              this.fetchSalesOrdersByDetails(this.state.days);
            }
          }
        }}
        style={{
          outline: "none",
          width: "100%",
          height: "24px",
          padding: "10px 10px",
          fontFamily: "Helvetica, sans-serif",
          fontWeight: "300",
          fontSize: "12px",
          border: "1px solid #aaa",
          borderRadius: "4px",
        }}
      />
    );
  };

  handleStatusFilterChange = (status, toggleFilterRowBtn) => {
    // if (toggleFilterRowBtn) {
    //   if (!_.isEmpty(this.state.salesOrders.filters)) {
    //     // running this block will call fetch list api twice 
    //     // bug: click will run onClearFilters method which makes api call
    //     const filterRowBtn = document.querySelectorAll('#sales-orders-list .react-grid-Container .react-grid-Toolbar .btn');
    //     filterRowBtn[0].click();
    //   }
    // }
    this.setState({currentPage: 0});
    let salesOrders = {
      ...this.state.salesOrders,
      selectedRows: [],
    };
    let filterParams = "";
    if (isOCM) {
      const filterPaires = [];
      _.forOwn(salesOrders.filters, (value, key) => {
        filterPaires.push([key, value.filterTerm].join('='))
      });
      filterParams = filterPaires.join('&');
    }
    if (isABC || isABBLE) {
      this.setState({ salesOrders });
    }

    const salesOrdersFilter = this.props.salesOrdersFilter;
    if (!salesOrdersFilter) {
      const route = this.context.router.routes[1].path;
      let seller = this.props.Seller;
      if (this.props.Seller) {
        seller = this.props.Seller.value;
      }
      const fromDate = this.state.FromDate
        ? this.formatDate(this.state.FromDate)
        : moment().format('YYYY-MM-DD');
      const toDate = this.state.ToDate
        ? this.formatDate(this.state.ToDate)
        : moment().format('YYYY-MM-DD');
      let days = this.state.days;
      if (days == null) {
        days = 7;
      }
      const productNum = this.props.ProductNum;
      this.setState({ Status: status }, () => {
        if ((!this.state.FromDate || !this.state.ToDate) && this.state.days === '-1') return;
        this.props.fetchSalesQuotesByFilterLap(
          fromDate,
          toDate,
          days,
          this.state.Status,
          seller,
          productNum,
          route,
          null,
          null,
          null,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.state.Type,
          filterParams,
        );
      });
    } else {
      this.setState({ Status: status });
    }
  };

  handleTypeFilterChange = (Type, toggleFilterRowBtn) => {
    // if (toggleFilterRowBtn) {
    //   if (!_.isEmpty(this.state.salesOrders.filters)) {
    //     // running this block will call fetch list api twice 
    //     // bug: click will run onClearFilters method which makes api call
    //     const filterRowBtn = document.querySelectorAll('#sales-orders-list .react-grid-Container .react-grid-Toolbar .btn');
    //     filterRowBtn[0].click();
    //   }
    // }
    let { salesOrders } = this.state;
    let filterParams = "";
    if (isOCM) {
      const filterPaires = [];
      _.forOwn(salesOrders.filters, (value, key) => {
        filterPaires.push([key, value.filterTerm].join('='))
      });
      filterParams = filterPaires.join('&');
    }

    if (isABBLE) {
      salesOrders.selectedRows = [];
      this.setState({salesOrders});
    }

    this.setState({ currentPage: 0 });
    const route = this.context.router.routes[1].path;
    let seller = this.props.Seller;
    if (this.props.Seller) {
      seller = this.props.Seller.value;
    }
    const fromDate = this.state.FromDate
      ? this.formatDate(this.state.FromDate)
      : moment().format('YYYY-MM-DD');
    const toDate = this.state.ToDate
      ? this.formatDate(this.state.ToDate)
      : moment().format('YYYY-MM-DD');
    let days = this.state.days;
    if (days == null) {
      days = 7;
    }
    const productNum = this.props.ProductNum;
    this.setState({ Type }, () => {
      if ((!this.state.FromDate || !this.state.ToDate) && this.state.days === '-1') return;
      this.props.fetchSalesQuotesByFilterLap(
        fromDate,
        toDate,
        days,
        this.state.Status,
        seller,
        productNum,
        route,
        null,
        null,
        null,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        Type,
        filterParams,
      );
    });
  }

  refreshSOList = () => {
    // const fromDate = this.state.FromDate
    //   ? this.formatDate(this.state.FromDate)
    //   : "1900-01-01";
    // const toDate = this.state.ToDate
    //   ? this.formatDate(this.state.ToDate)
    //   : "3000-01-01";
    const fromDate = this.state.FromDate
      ? this.formatDate(this.state.FromDate)
      : moment(new Date()).format('YYYY-MM-DD');
    const toDate = this.state.ToDate
      ? this.formatDate(this.state.ToDate)
      : moment(new Date()).format('YYYY-MM-DD');;
    let days = this.state.days;
    let seller = this.props.Seller;
    const route = this.context.router.routes[1].path;
    const productNum = this.props.ProductNum;

    let filterParams = "";
    let salesOrders = {
      ...this.state.salesOrders,
      selectedRows: [],
      rows: [],
    };
    if (isOCM) {
      const filterPaires = [];
      _.forOwn(salesOrders.filters, (value, key) => {
        filterPaires.push([key, value.filterTerm].join('='))
      });
      filterParams = filterPaires.join('&');
    }

    this.props.fetchSalesQuotesByFilterLap(
      fromDate,
      toDate,
      days,
      this.state.Status,
      seller,
      productNum,
      route,
      null,
      null,
      null,
      this.state.limit,
      this.state.currentPage,
      this.state.searchFilter,
      this.state.Type,
      filterParams,
    );
  }

  handleBreadCrumbTitle = () => {
    if (isDSQ || isWIZ || isFJ || isJTB || isABCFF) {
      if (this.context.router.routes[1].path === "salesQuotes") {
        this.setState(() => ({ breadcrumbTitle: "inbound_order" }));
      } else if (this.context.router.routes[1].path === "outboundOrders") {
        this.setState(() => ({ breadcrumbTitle: "outbound_order" }));
      } else if (this.context.router.routes[1].path === "mobileSalesOrders") {
        this.setState(() => ({ breadcrumbTitle: "mobile_sales_order" }));
      }
    } else {
      if (this.context.router.routes[1].path === "salesQuotes") {
        this.setState(() => ({ breadcrumbTitle: "sales_quotes" }));
      } else if (this.context.router.routes[1].path === "mobileSalesOrders") {
        this.setState(() => ({ breadcrumbTitle: "mobile_sales_order" }));
      }
    }
  };

  genSubjectTemplate = () => {
    if(isOCM || isEKC || isLMH || isLAP) {
      const row = this.state.salesOrders.selectedRows[0];
      const activeCompany = getLocalStorageData('selectedCompany').label;
      if(row) {
        const sqNum = row.SQNum;
        return `Sales Quote ${sqNum} from ${activeCompany.toUpperCase()}`
      }
    }
    return ''
  }

  genContentTemplate = () => {
    if(isOCM || isEKC || isLMH || isLAP) {
      const activeCompany = getLocalStorageData('selectedCompany').label;
      return `Dear Customer:

Your sales quote is attached. Please review the list of items on order.
Thank you for your business - we appreciate it very much

Sincerely,
${activeCompany.toUpperCase()}.`
    }
    return ''
  }

  handleEmailContentConfirm = (subject, content, email, phone, sendEmail, source) => {
    const row = this.state.salesOrders.selectedRows[0];
    if(row) {
      if (isLAP) {
        this.props.emailPOPost(row.SalesQuote_id, subject, content, email, phone, sendEmail, source);
      } else {
        this.props.emailSO(row.SalesQuote_id, subject, content, email);
      }
      this.handleEmailContentClose();
    }
  }

  handleEmailContentClose = () => {
    this.setState({
      emailContentModalVisibility: false,
      emailSubjectModalTemplate: '',
      emailContentModalTemplate: ''
    })
  }

  render3rdRowButtonsAbble = () => {
    if (!isABBLE) return null;
    return (
      <div id="third-row-contaner" style={{ marginTop: '40px', marginLeft: '147px' }}>
        <ButtonToolbar className="table-buttons-thrid-row">
          <Button
            bsStyle="success"
            className="print-btn"
            type="button"
            onClick={() => {
              this.setMonitorListModalVisibility(true);
            }}
          >
            <Translate value="monitor_orders" />
          </Button>
        </ButtonToolbar>
      </div>
    )
  }

  setMonitorListModalVisibility = (isMonitorListModalVisible = false) => this.setState({ isMonitorListModalVisible });

  renderGGIButtons = () => {
    if (!isGGI) return null;
    return (
      <div id="third-row-contaner" style={{ marginTop: '40px', marginLeft: '147px' }}>
        <input
          type="file"
          ref="file-upload-ref"
          style={{ display: 'none' }}
          onChange={(e) => {
            const {
              salesOrders: {
                selectedRows,
              }
            } = this.state;

            const file = e.target.files[0];
            const formData = new FormData();
            formData.append('File', file);
            this.props.uploadSOFile(selectedRows[0].SalesQuote_id, formData, this.refreshSOList)
          }}
        />
        <ButtonToolbar className="table-buttons-thrid-row">
          {this.renderUploadFileButton()}
        </ ButtonToolbar>
      </div>
    )
  }

  renderOCMButtons = () => {
    if (!isOCM) return null;
    return (
      <div id="third-row-contaner" style={{ marginTop: '40px', marginLeft: '147px' }}>
        <ButtonToolbar className="table-buttons-thrid-row">
          {this.renderMergeSOButton()}
          {this.renderDuplicateSOButton()}
        </ ButtonToolbar>
      </div>
    )
  }

  closeShipping= () => {
    // this.props.clearConvertingToInvoice();
    // this.props.clearUpdateSalesInvoice();
    this.setState({ showShippingOpen: false });
    this.refreshSOList();
  }

  generateOrderTypeRadioOptions = () => {
    const options = [
      {
        option: null,
        id: "normal-radio-filter",
        name: "typeFilterRadios",
        labelName: "normal",
      },
      {
        option: "IsRelocation",
        id: "relocated-radio-filter",
        name: "typeFilterRadios",
        labelName: "relocated",
      },
    ]
    if (!isOCM) {
      return options;
    }
    options.push({
      option: "IsTransfer",
      id: "transfer-radio-filter",
      name: "typeFilterRadios",
      labelName: "transfer",
    })
    return options;
  }
  render() {
    const isMobile = this.context.router.routes[1].path === "mobileSalesOrders";
    // const handleFilterChangePage = (event) => {
    //   // this.setState({currentPage: 0});
    //   this.state.currentPage = 0;
    //   let salesOrders = {
    //     ...this.state.salesOrders,
    //     selectedRows: [],
    //   };
    //   this.setState({ salesOrders });
    //   const route = this.context.router.routes[1].path;

    //   let keys = Object.keys(this.state.searchFilter);
    //   for (let i = 0; i < keys.length; i++) {
    //     if (event.target.name === keys[i]) {
    //       this.state.searchFilter[keys[i]] = event.target.value;
    //     }
    //   }

    //   this.props.fetchSalesQuotesByFilterLap(
    //     this.state.FromDate,
    //     this.state.ToDate,
    //     this.state.days,
    //     this.state.Status,
    //     null,
    //     null,
    //     route,
    //     this.state.dispatchDateLT,
    //     this.state.dispatchDateGT,
    //     null,
    //     this.state.limit,
    //     this.state.currentPage,
    //     this.state.searchFilter,
    //   );
    //   // this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    // }

    const handleFilterChangePage = debounce(
      (event) => {
        // this.setState({currentPage: 0});
        this.state.currentPage = 0;
        let salesOrders = {
          ...this.state.salesOrders,
          selectedRows: [],
        };
        this.setState({ salesOrders });
        const route = this.context.router.routes[1].path;

        let keys = Object.keys(this.state.searchFilter);
        for (let i = 0; i < keys.length; i++) {
          if (event.name === keys[i]) {
            this.state.searchFilter[keys[i]] = event.value;
          }
        }
    
      let filterParams = "";
      if (isOCM) {
        const filterPaires = [];
        _.forOwn(salesOrders.filters, (value, key) => {
          filterPaires.push([key, value.filterTerm].join('='))
        });
        filterParams = filterPaires.join('&');
      }

      this.props.fetchSalesQuotesByFilterLap(
        this.state.FromDate,
        this.state.ToDate,
        this.state.days,
        this.state.Status,
        null,
        null,
        route,
        this.state.dispatchDateLT,
        this.state.dispatchDateGT,
        null,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.state.Type,
        filterParams,
      );
      // this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    },
    200,
    { maxWait: 300 },
  );

    const singleSalesOrderId =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesQuote_id;

    const singleSalesOrderNum =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SQNum;

    let multiSalesOrderId = [];
    let multiSalesOrderNum = [];
    let salesOrderIdString = "";
    let salesOrderNumString = "";
      if (this.state.salesOrders && this.state.salesOrders.selectedRows.length >= 1) {
        this.state.salesOrders.selectedRows.map((row) => {
          multiSalesOrderId.push(row.SalesQuote_id);
          multiSalesOrderNum.push(row.SQNum);
        });
        salesOrderIdString = multiSalesOrderId.join(",");
        salesOrderNumString = multiSalesOrderNum.join(",");
      }

      let svPendingDisable = false;
      if (isSV) {
        if (this.state.salesOrders && this.state.salesOrders.selectedRows.length >= 1) {
          this.state.salesOrders.selectedRows.map((row) => {
            if (row.SaleStatus === 'Pending') { //Pending
              svPendingDisable = true;
            }
          });
        }
      }

    // let dsqTempOrder = [];
    // if (this.state.salesOrders && this.state.salesOrders.selectedRows) {
    //   dsqTempOrder = this.state.salesOrders.selectedRows[0];
    // }

    const DriverListModalStyle = {
      width: "550px",
      height: "200px",
      marginLeft: "-15%",
    };
    const createDialogStyle = {
      width: "550px",
      height: "350px",
      marginLeft: "-15%",
    };
    const bolImageDialogue = {
      width: "700px",
      height: "600px",
      marginLeft: "-15%",
    };
    const createWeightDialogStyle = {
      width: "600px",
      height: "360px",
      marginLeft: "-10%",
    };
    const createPickerDialogStyle = {
      width: "600px",
      height: "200px",
      marginLeft: "-10%",
    };
    const bolListDialogStyle = {
      width: "1050px",
      height: "635px",
      marginLeft: "-27%",
      marginTop: "-310px",
    };
    const generateBOLStyle = {
      width: '500px',
      height: '515px',
      marginLeft: '-10%'
    };
    const dsqPrintDialogStyle = {
      width: "1050px",
      height: "550px",
      marginLeft: "-27%",
      marginTop: "-310px",
    };
    const wizPODDialogStyle = {
      width: "620px",
      height: "550px",
      marginLeft: "-10%",
      marginTop: "-310px",
    };
    const createTrackingDialogStyle = {
      width: "700px",
      height: "290px",
      marginLeft: "-10%",
    };
    const createPullSheetDialogStyle = {
      width: "500px",
      height: "300px",
      marginLeft: "-10%",
    };
    const voidNoteDialogStyle = {
      width: "550px",
      height: "330px",
      marginLeft: "-10%",
    };
    const chowbusDialogStyle = {
      width: "500px",
      height: "300px",
      marginLeft: "-10%",
    };
    const voidReasonSelection = [
      {
        value: "Items Out of Stock",
        label: "Items Out of Stock",
      },
      {
        value: "Customer Request",
        label: "Customer Request",
      },
      {
        value: "Items Damaged",
        label: "Items Damaged",
      },
      {
        value: "Duplicated Order",
        label: "Duplicated Order",
      },
      {
        value: "Invalid Shipping Address",
        label: "Invalid Shipping Address",
      },
      {
        value: "Other",
        label: "Other",
      },
    ];
    let USPridePlatformOptions = [
      {label: 'Walmart', value: 'walmart',},
      {label: 'Wayfair', value: 'wayfair',},
      {label: 'Overstock', value: 'overstock',},
      {label: 'Home Depot', value: 'homedepot',},
    ];
    // if (isSV) {
    //   USPridePlatformOptions = [
    //     {label: 'OMS', value: 'oms',},
    //     {label: 'Fosters', value: 'fosters',},
    //     {label: 'Walmart', value: 'walmart',},
    //     {label: 'Wayfair', value: 'wayfair',},
    //     {label: 'Faire', value: 'faire',},
    //     {label: 'CAMEO EZ', value: 'cameo',},
    //     {label: 'Tundra', value: 'tundra',},
    //     {label: 'QVC', value: 'qvc',},
    //     {label: 'Overstock', value: 'overstock',},
    //     {label: 'Home Depot', value: 'homedepot',},
    //   ];
    // }
    const { USPridePlatform, SelectedPicker } = this.state;
    const userOptions = this.getUsers();
    const changeWeight = <Translate value="change_ship_weight" />;
    const changePaymentMethod = <Translate value="payment_method_change" />;
    const changeShipMethod = <Translate value="shipping_method_change" />;
    const changeShipQty = <Translate value="shipping_qty_change" />;
    const displayTrackingTitle = <Translate value="split_tracking_numbers" />;
    const displayTrackingTitle2 = <Translate value="tracking_nums" />;
    const changePullSheet = <Translate value="pull_sheet_format" />;
    const reshipTitle = <Translate value="reship" />;
    const quoteTitle = <Translate value="set_order" />;
    const pendingTitle = <Translate value="set_pending" />;
    const setQuoteTitle = <Translate value="set_quote" />;
    const davisPOTitle = <Translate value="so_to_po" />;
    const pridePrintTitle = <Translate value="pride_print" />;
    const showImageTitle = <Translate value="show_image" />;
    const submitImageTitle = <Translate value="submit_image" />;
    const printBolTitle = <Translate value="print_bol" />;
    const voidNoteTitle = <Translate value="void_note" />;
    const chowbusImportTitle = <Translate value="chowbus_import" />;
    let salesQuote_id =
      this.state.salesOrders &&
      this.state.salesOrders.selectedRows[0] &&
      this.state.salesOrders.selectedRows[0].SalesQuote_id;
    salesQuote_id = salesQuote_id || "";
    const height = ((this.state.tableHeight / 3) * 2 + 70).toString();
    const tableCollapseFix = { height };
    const detailsTableHeight = (this.state.tableHeight / 2.5 + 45).toString();
    const detailsTableCollapseFix = { height: detailsTableHeight };
    const listPurchasers = [{ value: "", label: "" }];
    const inputFieldKey = Math.random();
    let enableCustomerSearch = false;
    let statusFilterContents = [
      {
        option: "all",
        id: "all-radio-filter",
        name: "statusFilterRadios",
        labelName: "all",
      },
      // {
      //   option: "open",
      //   id: "open-radio-filter",
      //   name: "statusFilterRadios",
      //   labelName: "open",
      // },
      // {
      //   option: "Quote",
      //   id: "quote-radio-filter",
      //   name: "statusFilterRadios",
      //   labelName: "quote",
      // },
      // {
      //   option: "Released",
      //   id: "released-radio-filter",
      //   name: "statusFilterRadios",
      //   labelName: "released",
      // },
      {
        option: "Canceled",
        id: "canceled-radio-filter",
        name: "statusFilterRadios",
        labelName: "canceled",
      },
    ];
    // if (isSV) {
    //   statusFilterContents = [
    //     {
    //       option: "all",
    //       id: "all-radio-filter",
    //       name: "statusFilterRadios",
    //       labelName: "all",
    //     },
    //     {
    //       option: "Pending",
    //       id: "quote-radio-filter",
    //       name: "statusFilterRadios",
    //       labelName: "pending",
    //     },
    //     {
    //       option: "open",
    //       id: "open-radio-filter",
    //       name: "statusFilterRadios",
    //       labelName: "open",
    //     },
    //     {
    //       option: "Released",
    //       id: "released-radio-filter",
    //       name: "statusFilterRadios",
    //       labelName: "released",
    //     },
    //     {
    //       option: "Canceled",
    //       id: "canceled-radio-filter",
    //       name: "statusFilterRadios",
    //       labelName: "canceled",
    //     },
    //     {
    //       option: "Backorder",
    //       id: "backlog-radio-filter",
    //       name: "statusFilterRadios",
    //       labelName: "backorder",
    //     }
    //   ];
    // }
    // if (isOCM && (this.props.selectedCompany.value === 2)) {
    //   const canceledIdx = statusFilterContents.findIndex(status => status.option === 'Canceled');
    //   const packFilter = {
    //     option: "Packed",
    //     id: "packed-radio-filter",
    //     name: "statusFilterRadios",
    //     labelName: "packed",
    //   };
    //   statusFilterContents.splice(canceledIdx, 0, packFilter);
    // }
    // if(isSH) {
    //   const quoteIndex = statusFilterContents.findIndex(status => status.option === 'Quote');
    //   if(quoteIndex !== -1) {
    //     statusFilterContents.splice(quoteIndex, 1);
    //   }
    // }
    // if(isDAICHEONG) {
    //   statusFilterContents.push({
    //     option: "Backlog",
    //     id: "backlog-radio-filter",
    //     name: "statusFilterRadios",
    //     labelName: "backlog",
    //   })
    // }
    // if (isABBLE) {
    //   const ReleasedIndex = _.findIndex(statusFilterContents, { option: "Released" });
    //   const packingOption = {
    //     option: "Packing",
    //     id: "packing-radio-filter",
    //     name: "statusFilterRadios",
    //     labelName: "packing",
    //   };
    //   statusFilterContents.splice(ReleasedIndex, 0, packingOption);
    // }
    // if (isSV) {
    //   const ReleasedIndex = _.findIndex(statusFilterContents, { option: "Released" });
    //   const partialOption = {
    //     option: "Partial",
    //     id: "partial-radio-filter",
    //     name: "statusFilterRadios",
    //     labelName: "partial",
    //   };
    //   statusFilterContents.splice(ReleasedIndex, 0, partialOption);
    // }
    // if (isGGI) {
    //   const ReleasedIndex = _.findIndex(statusFilterContents, { option: "Released" });
    //   const moreOptions = [{
    //     option: "Pending",
    //     id: "pending-radio-filter",
    //     name: "statusFilterRadios",
    //     labelName: "pending",
    //   }, {
    //     option: "Packing",
    //     id: "packing-radio-filter",
    //     name: "statusFilterRadios",
    //     labelName: "packing",
    //   }]
    //   statusFilterContents.splice(ReleasedIndex, 0, ...moreOptions);
    // }
    // if (isOCM || isSV) {
    //   enableCustomerSearch = true
    // }
    // if (isMobile) {
    //   if (isABBLE) {
    //     enableCustomerSearch = true
    //   }
    // }

    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>
        {/* Nav Trail */}
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="sales_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value={this.state.breadcrumbTitle} />
          </Breadcrumb.Item>
        </Breadcrumb>{" "}
        {/* End Nav Trail */}
        <Grid id="sales-orders-list" style={isABC ? { width: '100%' } : {}}>
          {/* Date Range Picker */}
          { (!isABC || this.state.abcDatePickerShow === true) && <Row>
            <Col xs={12}>
              <Panel id="date-range-picker" className="form-horizontal">
                <Row>
                  {/* <Col xs={2}>
                    <h3 className="filter-title">
                      <Translate value="order_type" />
                      <span className="colon">:</span>
                    </h3>
                  </Col>
                  <Col xs={10}>
                    <div id="statusFilterRadios" className="form-horizontal">
                      {genericRadioFilter({
                        content: this.generateOrderTypeRadioOptions(),
                        value: this.state.Type,
                        handleOnClick: type => this.handleTypeFilterChange(type),
                        type: "buttons",
                      })}
                    </div>
                  </Col> */}
                  <Col xs={2}>
                    <h3 className="filter-title">
                      <Translate value="quote_status" />
                      <span className="colon">:</span>
                    </h3>
                  </Col>
                  <Col xs={10}>
                    <div id="statusFilterRadios" className="form-horizontal">
                      {/* <Field name='Status' component={ renderStatusRadios }  /> */}
                      {genericRadioFilter({
                        content: statusFilterContents,
                        value: this.state.Status,
                        handleOnClick: status => this.handleStatusFilterChange(status),
                        type: "buttons",
                      })}
                    </div>
                  </Col>
                  <Col xs={2}>
                    <h3 className="filter-title">
                      <Translate value="quote_date" />
                      <span className="colon">:</span>
                    </h3>
                  </Col>
                  <Col xs={10}>
                    {dateFilterRadios({
                      handleOnClick: (days) => this.fetchSalesOrdersByDetails(days),
                      setFromDate: this.setFromDate,
                      setToDate: this.setToDate,
                      setToRangeSearch: this.setToRangeSearch,
                      FromDate: this.state.FromDate,
                      ToDate: this.state.ToDate,
                      Days: this.state.days,
                    })}
                  </Col>
                  {/* </Row> */}
                </Row>
                { isCalco && (
                  <Row>
                    <Col xs={2}>
                      <h3 className="filter-title">
                        <Translate value="order_delivered" />
                        <span className="colon">:</span>
                      </h3>
                    </Col>
                    <Col xs={10}>
                      {dispatchFilterRadios({
                        handleOnClick: this.fetchSalesOrdersByDispatch,
                        setFromDate: this.setFromDispatchDate,
                        setToDate: this.setToDispatchDate,
                        setToRangeSearch: this.setToDispatchRangeSearch,
                        FromDate: this.state.dispatchDateLT,
                        ToDate: this.state.dispatchDateGT,
                        Days: this.state.dispatchDays,
                      })}
                    </Col>
                  </Row>
                )}
              </Panel>
            </Col>
          </Row>}
          {" "}
          {/* End Date Range Picker */}
          {/* Sales Order Full Table  */}
          <Row>
            <Col xs={12}>
              <Panel
                className="position-relative table-collapse-fix"
                id={
                  (isTN || isUSPride || isDSQ || isWIZ || isFJ || isJTB)
                  ? "table-collapse-fix-450" : (isGGI || isABBLE || isSV) ? "table-collapse-fix-500"
                  : (isABC) ? "table-collapse-fix-940" : isOCM ? "table-collapse-fix-525" : ""
                }
                style={{marginBottom: isABC ? '80px': '0px'}}
              >
                <div style={{ position: "relative" }}>
                  <ButtonToolbar className="table-buttons">
                    <Button
                      bsStyle="success"
                      type="submit"
                      onClick={(event) => {
                        this.clickNew(event);
                      }}
                      disabled={
                        this.context.router.routes[1].path ===
                          "mobileSalesOrders" ||
                        !checkPermission("add_sales_order")
                      }
                    >
                      <em className="fa fa-plus" />
                      <Translate value="create" />
                    </Button>
                    {
                      /* isUSPride &&
                      <div style={{ marginLeft: '89px' }}>
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => {this.openUSPrideCreate(); }}
                          disabled={!checkPermission("add_sales_order")}
                        >
                          <em className="fa fa-plus" />
                          <Translate value="create_with_excel" />
                        </Button>
                      </div> */
                    }

                    {
                      /* (isSV) &&
                      <div style={{ marginLeft: '89px' }}>
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => {this.openUSPrideCreate(); }}
                          disabled={!checkPermission("add_sales_order")}
                        >
                          <em className="fa fa-plus" />
                          &nbsp;Excel Create
                        </Button>
                      </div> */
                    }

                    {
                      /* (isDSQ || isWIZ || isFJ || isJTB || isMAG) &&
                      (this.context.router.routes[1].path ===
                        "salesQuotes") && (
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => {
                            this.refs.msoCreateInputRef2.click();
                          }}
                          // disabled={!checkPermission("add_sales_order")}
                          disabled={false}
                        >
                          <em className="fa fa-plus" />
                          &nbsp;Excel Create (SO)
                        </Button>
                      ) */
                      }
                       {
                         /* (isDSQ || isWIZ || isFJ || isJTB || isMAG) &&
                      (this.context.router.routes[1].path ===
                        "mobileSalesOrders") && (
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => {
                            this.refs.msoCreateInputRef2MSO.click();
                          }}
                          // disabled={!checkPermission("add_sales_order")}
                          disabled={false}
                        >
                          <em className="fa fa-plus" />
                          &nbsp;Excel Create (MSO)
                        </Button>
                      ) */
                      }
                       {/* {(isSV) &&
                      (this.context.router.routes[1].path ===
                        "mobileSalesOrders") && (
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => {
                            this.refs.msoCreateInputRef2.click();
                          }}
                          // disabled={!checkPermission("add_sales_order")}
                          disabled={false}
                        >
                          <em className="fa fa-plus" />
                          <Translate value="create_with_excel" />
                        </Button>
                      )
                      } */}
                        {
                          /* (isDSQ) &&
                      (this.context.router.routes[1].path ===
                        "outboundOrders") && (
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => {
                            this.refs.msoCreateInputRef3.click();
                          }}
                          // disabled={!checkPermission("add_sales_order")}
                          disabled={false}
                        >
                          <em className="fa fa-plus" />
                          <Translate value="outbound_with_excel" />
                        </Button>
                      ) */
                      }
                    {
                    /* (isDSQ || isWIZ || isFJ || isJTB || isMAG || isSV) &&
                      (this.context.router.routes[1].path ===
                        "salesQuotes" || this.context.router.routes[1].path ===
                        "mobileSalesOrders") && (
                        <input
                          type="file"
                          style={{ display: "none" }}
                          onClick={(e)=> { e.target.value = null; }}
                          onChange={(e) => {
                            const formData = new FormData();
                            formData.append("FILE", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  `${ROOT_URL}v2/import-so-xls`,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  },
                                )
                                .then(
                                  (res) => {
                                    alert("Orders imported successfully");
                                    this.fetchSalesOrdersByDetails(
                                      this.state.days
                                    );
                                  },
                                  (err) => {
                                    if (err.data) {
                                      alert(err.data);
                                    } else {
                                      alert("Server issue detected, please contact admin.");
                                    }
                                  }
                                );
                            }
                          }}
                          ref="msoCreateInputRef2"
                        />
                      ) */
                    }
                      { 
                        /* isSKH && (this.context.router.routes[1].path === "mobileSalesOrders") && (
                        <input
                          type="file"
                          style={{ display: "none" }}
                          onClick={(e)=> { e.target.value = null; }}
                          onChange={(e) => {
                            const formData = new FormData();
                            formData.append("File", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  `${ROOT_URL}v2/sales/upload_dsco_shipment`,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  },
                                )
                                .then(
                                  (res) => {
                                     alert('success');
                                  },
                                  (err) => {
                                    alert(JSON.stringify(err.data));
                                  }
                                );
                            }
                          }}
                          ref="dsco_ref"
                        />
                      ) */
                      }
                      {
                    /* (isDSQ || isWIZ || isFJ || isJTB || isMAG || isSV) &&
                      (this.context.router.routes[1].path ===
                        "salesQuotes" || this.context.router.routes[1].path ===
                        "mobileSalesOrders") && (
                        <input
                          type="file"
                          style={{ display: "none" }}
                          onClick={(e)=> { e.target.value = null; }}
                          onChange={(e) => {
                            const formData = new FormData();
                            formData.append("FILE", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  `${ROOT_URL}v2/import-mso-xls`,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  },
                                )
                                .then(
                                  (res) => {
                                    alert("Orders imported successfully");
                                    this.fetchSalesOrdersByDetails(
                                      this.state.days
                                    );
                                  },
                                  (err) => {
                                    if (err.data) {
                                      alert(err.data);
                                    } else {
                                      alert("Server issue detected, please contact admin.");
                                    }
                                  }
                                );
                            }
                          }}
                          ref="msoCreateInputRef2MSO"
                        />
                      ) */
                      }
                      {
                    /* (isDSQ || isWIZ || isFJ || isJTB || isMAG) &&
                      (this.context.router.routes[1].path ===
                        "outboundOrders") && (
                        <input
                          type="file"
                          style={{ display: "none" }}
                          onClick={(e)=> { e.target.value = null; }}
                          onChange={(e) => {
                            const formData = new FormData();
                            formData.append("FILE", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  `${ROOT_URL}v2/import-outbound-xls`,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  },
                                )
                                .then(
                                  (res) => {
                                    alert("Outbound Orders imported successfully");
                                    this.fetchSalesOrdersByDetails(
                                      this.state.days
                                    );
                                  },
                                  (err) => {
                                    if (err.data) {
                                      alert(err.data);
                                    } else {
                                      alert("Server issue detected, please contact admin.");
                                    }
                                  }
                                );
                            }
                          }}
                          ref="msoCreateInputRef3"
                        />
                      ) */
                      }
                      {
                    /* (isWIZ) &&
                      (this.context.router.routes[1].path ===
                        "outboundOrders") && (
                        <input
                          type="file"
                          style={{ display: "none" }}
                          onClick={(e)=> { e.target.value = null; }}
                          onChange={(e) => {
                            let wURL = `${ROOT_URL}v2/sales/pod/` + this.state.salesOrders.selectedRows[0].SalesQuote_id + `/`;
                            const formData = new FormData();
                            formData.append("FILE", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  wURL,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  },
                                )
                                .then(
                                  (res) => {
                                    alert("POD uploaded successfully");
                                    this.fetchSalesOrdersByDetails(
                                      this.state.days
                                    );
                                  },
                                  (err) => {
                                    if (err.data) {
                                      alert(err.data);
                                    } else {
                                      alert("Server issue detected, please contact admin.");
                                    }
                                  }
                                );
                            }
                          }}
                          ref="msoCreateInputRef4"
                        />
                      ) */
                      }
                    {
                      /* isTN &&
                      (this.context.router.routes[1].path ===
                        "salesQuotes") && (
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => { this.refs.msoCreateInputRef.click(); }}
                          disabled={!checkPermission("add_sales_order")}
                        >
                          <em className="fa fa-plus" />
                          <Translate value="create_with_excel" />
                        </Button>
                      ) */
                    }
                    {
                      /* isTN &&
                      (this.context.router.routes[1].path ===
                        "salesQuotes") && (
                        <input
                          type="file"
                          style={{ display: "none" }}
                          onClick={(e)=> { e.target.value = null }}
                          onChange={(e) => {
                            const formData = new FormData();
                            formData.append("FILE", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  // `${ROOT_URL}v2/import_orders_xls`,
                                  `${ROOT_URL}v2/import_orders_tn`,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  }
                                )
                                .then(
                                  (res) => {
                                    alert("SO Imported Successfully");
                                    this.fetchSalesOrdersByDetails(
                                      this.state.days,
                                    );
                                  },
                                  (err) => {
                                    if (err.data) {
                                      alert(err.data);
                                    } else {
                                      alert("Server issue detected, please contact admin.");
                                    }
                                  }
                                );
                            }
                          }}
                          ref="msoCreateInputRef"
                        />
                      ) */
                    }
                    <Button
                      bsStyle="warning"
                      type="button"
                      disabled={
                        this.state.salesOrders.selectedRows.length !== 1 ||
                        !checkPermission("change_sales_order")
                      }
                      onClick={(event) => {
                        this.setCurrentSalesOrder(event);
                      }}
                    >
                      <em className="fa fa-pencil" />
                      <Translate value="edit" />
                    </Button>
                    <Button
                      bsStyle="danger"
                      type="reset"
                      disabled={
                        this.shouldVoidButtonDisable() ||
                        !checkPermission("delete_sales_order")
                      }
                      onClick={() => {
                        this.openCheckAuthorize("void");
                      }}
                    >
                      <em className="fa fa-trash" />
                      <Translate value="void" />
                    </Button>
                    {
                      /* (isTN || isDSQ || isWIZ || (isFJ && this.context.router.routes[1].path !== 'outboundOrders') || isJTB) && <Button
                      bsStyle="primary"
                      // type="reset"
                      disabled={!this.state.salesOrders.selectedRows.length}
                      onClick={() => {
                        const soPKs = this.state.salesOrders.selectedRows.map(row => row.SalesQuote_id);
                        const success = () => {
                          this.refreshSOList();
                        }
                        expressMultipleSOInvoices(soPKs, success);
                      }}
                    >
                      <em className="fa fa-file" />
                      <Translate value="express_invoice" />
                    </Button> */
                    }
                    {
                      /* (isABBLE && checkPermission("view_express_invoice")) &&
                      <Button
                        bsStyle="primary"
                        // type="reset"
                        disabled={!this.state.salesOrders.selectedRows.length}
                        onClick={() => {
                          const soPKs = this.state.salesOrders.selectedRows.map(row => row.SalesQuote_id);
                          const success = () => {
                            this.refreshSOList();
                          }
                          expressMultipleSOInvoices(soPKs, success);
                        }}
                      >
                        <em className="fa fa-file" />
                        <Translate value="express_invoice" />
                      </Button> */
                     }
                     {
                      /* (isSV && false) &&
                      <Button
                      bsStyle="primary"
                      // type="reset"
                      disabled={!this.state.salesOrders.selectedRows.length || svPendingDisable}
                      onClick={() => {
                        const soPKs = this.state.salesOrders.selectedRows.map(row => row.SalesQuote_id);
                        const success = () => {
                          this.refreshSOList();
                        }
                        expressMultipleSOInvoices(soPKs, success);
                      }}
                    >
                      <em className="fa fa-file" />
                      <Translate value="express_invoice" />
                    </Button> */
                    }
                    {/* padLeft */}
                    {this.renderPrint()}
                    {/* {this.renderShippingIFrame()}
                    {this.renderPackingIFrame()}
                    {this.renderPickingIFrame()} */}
                    {this.renderSalesOrderIFrame()}
                    {/* {this.renderBolByIdIFrame()}
                    {this.renderBolWithoutLogIFrame()}
                    {this.renderBolLabelIFrame()}
                    {this.renderBolByFbaIFrame()} */}
                  </ButtonToolbar>
                  <div className="table-filters" style={{ zIndex: 1 }}>
                    {
                      !isWIZ &&
                      <label
                        style={{ marginRight: "0px" }}
                        className="control-label"
                      >
                        {/* <Translate value="select_seller" /> */}
                        <Translate value="sales" />:
                      </label>
                    }
                    {!isWIZ && this.renderUsers()}

                    <ButtonToolbar className="table-buttons">
                      {/* <Button bsStyle='primary' disabled={this.state.salesOrders.selectedRows.length != 1} onClick={this.loadsPost}>
                                  <Translate value="loads_post" />
                                </Button> */}
                      {/* { this.quoteButton() }
                      { this.renderExportButton() }
                      { isSKH && this.renderCreateExportButton() }
                      { isSKH && (this.context.router.routes[1].path === "mobileSalesOrders") && this.renderDscoShipmentButton() }
                      { isTN && this.renderExportSelectedButton() }
                      { isCalco && this.renderExportButton("qb") }
                      { isMyuMyu && this.renderCreateTaskButton() }
                      { (isAFG) && this.renderChangeWeightButton() }
                      { isRivera && this.renderPaymentMethodChangeButton() } */}
                      {/* this.renderReshipButton() */}
                      {/* !isSV && this.renderQuoteButton() */}
                     {/*  { isGGI && this.renderPendingButton()}
                      {isSV && this.renderApprovePendingButtonSV()}
                      {this.renderToQuoteButton()} */}
                      {/* { isABC && this.renderAssignDriverButton() }
                      { isABC && this.renderUpdateNumberButton() }
                      { (isCO || isABC) && this.renderPrintBolButton() }
                      { (isCalco || isEcity) && this.renderDriverImageButton() }
                      { isMyuMyu && this.renderChowbusImportButton() }
                      { (isMyuMyu || isAFG) && this.renderDavisPO() } */}
                      { !isCalco && !isAFG && !isABC && !isFIT && !isDSQ && !isNBT && !isABBLE && !isSV && this.renderPrintLabelButton() }
                      {/* { (isAFG || isFIT || isNBT) && this.renderPrintLabelButtonAFG() }
                      { isDSQ && this.renderPrintLabelButtonDSQ()}
                      { isUSPride && this.renderPrintLabelUSPride() }
                      { isUSPride && this.renderReprintLabelUSPride() } */}
                      {/* { (isSV && this.context.router.routes[1].path === 'mobileSalesOrders') && this.dsqExcelTemplate() } */}
                      {/* { (isDSQ && this.context.router.routes[1].path === 'salesQuotes') && this.dsqExcelTemplate() }
                      { (isDSQ && this.context.router.routes[1].path === 'outboundOrders') && this.dsqOutboundTemplate()}
                      { (isJTB && this.context.router.routes[1].path === 'salesQuotes') && this.jtbExcelTemplate() }
                      { (isWIZ && this.context.router.routes[1].path === 'salesQuotes') && this.wizExcelTemplate() }
                      { (isFJ && this.context.router.routes[1].path === 'salesQuotes') && this.fjExcelTemplate() }
                      { (isMAG && this.context.router.routes[1].path === 'salesQuotes') && this.magExcelTemplate() }
                      { isWIZ && this.bolList()}
                      { isWIZ && this.generateBOL()} */}

                      {/* {(isWIZ) &&
                        (this.context.router.routes[1].path ===
                          "outboundOrders") && (
                          <Button
                            bsStyle="success"
                            type="submit"
                            onClick={() => {
                              // this.refs.msoCreateInputRef4.click();
                              this.openWIZPOD();
                            }}
                            disabled={this.state.salesOrders.selectedRows.length !== 1}
                          >
                            <em className="fa fa-list" />
                            <Translate value="pod" />
                          </Button>
                        )
                      }

                      { (isOCM || isEKC) && this.renderSendEmailButton()}
                      { isOCM && this.renderResetLocationButton()} */}
                      {/* { this.renderSOUploadButton()}
                      { (isABBLE || isSKH) && this.renderTeapplixButton()}
                      { (isSV && this.context.router.routes[1].path === 'mobileSalesOrders') &&this.renderTeapplixButton()}
                      { (isABBLE || isSKH) && this.renderTeapplixResyncButton()}
                      { isSKH && this.renderAcknowledgeOrdersButton() }
                      { isSKH && this.context.router.routes[1].path === 'mobileSalesOrders' && this.renderChangeShipMethodButton() } */}
                      
                      {/* { isSV && this.renderPickerButton()} */}
                      {/* { (isSV && this.context.router.routes[1].path === 'mobileSalesOrders') &&this.renderTeapplixResyncButton()}
                      {this.renderMissingSKUsButton()} */}
                      { (isLAP) && this.renderSendEmailButton()}
                    </ButtonToolbar>
                  </div>
                  {/* {this.render3rdRowButtonsAbble()}
                  {
                    (isABC && this.context.router.routes[1].path !== 'salesQuotes') &&
                    <Row style={{marginTop: '40px'}}>
                      <Col>
                        <label className="col-sm-3" style={{ width: '120px' }}><Translate value="so_num" /></label>
                        <label className="col-sm-3" style={{ width: '120px' }}><Translate value="company" /></label>
                        <label className="col-sm-3" style={{ width: '120px' }}>FBA</label>
                        <label className="col-sm-3" style={{ width: '120px' }}>BOL</label>
                        <label className="col-sm-3" style={{ width: '120px' }}>ISA</label>
                        <label className="col-sm-3" style={{ width: '120px' }}>Ship Status</label>
                        <label className="col-sm-3" style={{ width: '120px' }}>Container</label>
                      </Col>
                    </Row>
                  } */}
                  {
                    /* (isABC && this.context.router.routes[1].path !== 'salesQuotes') &&
                    <Row>
                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="SQNum" type="text" onChange={(e) => handleFilterChangePage(e.target)} />
                      </Col>
                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="CompanyName" type="text" onChange={(e) => handleFilterChangePage(e.target)} />
                      </Col>
                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="FBACode" type="text" onChange={(e) => handleFilterChangePage(e.target)} />
                      </Col>

                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="CustomerBOLNo" type="text" onChange={(e) => handleFilterChangePage(e.target)} />
                      </Col>
                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="IsaNo" type="text" onChange={(e) => handleFilterChangePage(e.target)} />
                      </Col>
                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="ShippingStatus" type="text" onChange={(e) => handleFilterChangePage(e.target)} />
                      </Col>
                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="ContainerNo" type="text" onChange={(e) => handleFilterChangePage(e.target)} />
                      </Col>
                    </Row> */
                  }
                  {
                    /* (isABC && this.context.router.routes[1].path === 'salesQuotes') &&
                    <div style={{height: "90px"}}></div> */
                  }
                  {
                    (!isABC || this.context.router.routes[1].path === 'salesQuotes') &&
                    <div
                      id="autosuggest-div"
                      className={(isTN || isABC || isUSPride || isDSQ || isWIZ || isFJ || isJTB || isMAG || isABBLE || isSV) && "TNAutosuggest-div"}
                    >
                      <Row style={{ height: "30px" }}>
                        <Col xs={10}>
                          <TypeRadios
                            isQuote={isLAP}
                            InvoiceNoSearch
                            TrackingNoSearch={isAFG ? true : null}
                            value={this.state.productSearchType}
                            handleOptionChange={this.handleOptionChange}
                            customerSearch={enableCustomerSearch}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={6}>
                          <Row>
                            <Col xs={12}>
                              {(this.state.productSearchType === "invoiceNo" || this.state.productSearchType === "CustName") &&
                                this.renderInvoiceNoSearchInput()}
                              {this.state.productSearchType !== "invoiceNo" &&
                                this.state.productSearchType !== "trackingNo" &&
                                this.state.productSearchType !== "CustName" &&
                                this.renderAutoSuggest()}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  }
                </div>
                {/* Sales Order Full Table */}
                {/* {this.renderGGIButtons()} */}
                {/* {this.renderOCMButtons()} */}
                {this.renderTable()}
              </Panel>
            </Col>
          </Row>{" "}
          {/* End Sales Order Full Table  */}
          {/* Sale Order Details */}
          <Row>
            <Col xs={12}>
              { (!isABC && !isFJ && !isDSQ && !isWIZ && !isJTB && !isMAG) &&
                <h2>
                  <Translate value="sale_quote_details" />
                </h2>
              }
              {
                /* (isDSQ || isWIZ || isJTB) &&
                <h2>
                <Translate value="order_details" />
                </h2> */
              }
              {
                (!isABC && !isFJ && !isMAG) &&
                <Panel className="details-table-collapse-fix">
                  {this.renderProductsTable()}
                </Panel>
              }
              { 
                /* isFJ &&
                <h2>
                  <Translate value="order_details" />
                </h2> */
              }
              { 
                /* isFJ &&
                <Panel className="details-table-collapse-fix">
                  {this.renderProductsTable()}
                </Panel> */
              }
              { 
                /* isMAG &&
                <h2>
                  <Translate value="container_info" /> ({ this.state.magSalesOrderDetail.SalesQuote_id ? this.state.magSalesOrderDetail.SQNum : "None"})
                    <Button
                      bsStyle="success"
                      type="button"
                      style={{marginLeft: '50px'}}
                      disabled={!this.state.magSalesOrderDetail.SalesQuote_id}
                      onClick={(event) => {
                        this.saveMagStuff(event);
                      }}
                    >
                      <em className="fa fa-save" />
                      <Translate value="save_order_info" />
                    </Button>
                </h2> */
              }
              { 
                /* isMAG &&
                <Panel className="details-table-collapse-fix">
                  {this.renderMagContainer()}
                </Panel> */
              }

              { 
                /* isMAG &&
                <h2>
                  <Translate value="load_pickup_info" /> ({ this.state.magSalesOrderDetail.SalesQuote_id ? this.state.magSalesOrderDetail.SQNum : "None"})
                </h2> */
              }
              { 
                /* isMAG &&
                <Panel>
                  {this.renderMagLoad()}
                </Panel> */
              }

              { 
                /* isMAG &&
                <h2>
                  <Translate value="delivery_info" /> ({ this.state.magSalesOrderDetail.SalesQuote_id ? this.state.magSalesOrderDetail.SQNum : "None"})
                </h2> */
              }
              { 
                /* isMAG &&
                <Panel>
                  {this.renderMagDelivery()}
                </Panel> */
              }
              { 
                /* isMAG &&
                <h2>
                  <Translate value="empty_info" /> ({ this.state.magSalesOrderDetail.SalesQuote_id ? this.state.magSalesOrderDetail.SQNum : "None"})
                </h2> */
              }
              { 
                /* isMAG &&
                <Panel style={{marginBottom: '200px'}}>
                  {this.renderMagEmpty()}
                </Panel> */
              }
            </Col>
          </Row>
          {/* Sale Order Details */}
        </Grid>
        <LocationChange
          setModalVisibility={this.setLocationChangeModalVisibility}
          isVisible={this.state.isLocationChangeModalVisible}
          selectedRows={this.state.salesOrders.selectedRows}
          onSuccess={this.handleLocationChangeSuccess}
        />
        <InboundDateChange
          setModalVisibility={this.setInboundDateChangeModalVisibility}
          isVisible={this.state.isInboundDateChangeModalVisibile}
          selectedRows={this.state.salesOrders.selectedRows}
          onSuccess={this.handleLocationChangeSuccess}
        />
        <SkyLightStateless
          dialogStyles={createWeightDialogStyle}
          isVisible={this.state.changeWeightOpen}
          onCloseClicked={() => {
            this.closeChangeWeight();
          }}
          title={changeWeight}
        >
          <WeightChangeModalMulti
            salesOrderId={singleSalesOrderId}
            fetchShippingWeightTracking={this.props.fetchShippingWeightTracking}
            finalShippingWeight={this.state.finalShippingWeight}
            onSave={this.onChangeWeightSubmit}
            onSavePrint={this.onChangeWeightSubmitPrint}
            onChange={this.onShippingWeightChange}
          />
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={bolListDialogStyle}
          isVisible={this.state.bolListModalVisibility}
          onCloseClicked={() => {
            this.closebolListModal();
          }}
          title={"BOL List"}
        >
          <BOLListModal
            // salesOrderId={singleSalesOrderId}
            salesOrderNum={singleSalesOrderNum}
            closebolListModal={this.closebolListModal}
            printSalesOrderLabelBOL={this.props.printSalesOrderLabelBOL}
            testHAHA={this.props.printSalesOrderLabel}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={generateBOLStyle}
          isVisible={this.state.generateBOLModalVisibility}
          onCloseClicked={() => {
            this.closeGenerateBOLModal();
          }}
          title={"Generate BOL"}
        >
          <GenerateBOLModal
            salesOrderIdString={salesOrderIdString}
            salesOrderNumString={salesOrderNumString}
            closeGenerateBOLModal={this.closeGenerateBOLModal}
          />
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={dsqPrintDialogStyle}
          isVisible={this.state.dsqPrintVisibility}
          onCloseClicked={() => {
            this.closeDSQPrint();
          }}
          title={"Select Products"}
        >
          <DSQPrintModal
            // salesOrderId={singleSalesOrderId}
            // salesOrderNum={singleSalesOrderNum}
            printSalesOrderLabelDSQ={this.props.printSalesOrderLabelDSQ}
            singleSalesOrderId={singleSalesOrderId}
            closebolListModal={this.closeDSQPrint}
          />
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={wizPODDialogStyle}
          isVisible={this.state.wizPODVisibility}
          onCloseClicked={() => {
            this.closeWIZPOD();
          }}
          title={"POD (" + singleSalesOrderNum + ")"}
        >
          <WIZPODModal
            // salesOrderId={singleSalesOrderId}
            // salesOrderNum={singleSalesOrderNum}
            // printSalesOrderLabelDSQ={this.props.printSalesOrderLabelDSQ}
            singleSalesOrderId={singleSalesOrderId}
            closeWIZPOD={this.closeWIZPOD}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createPickerDialogStyle}
          isVisible={this.state.PickerOpen}
          onCloseClicked={() => {
            this.closePicker();
          }}
          title={<Translate value="assign_picker" />}
        >
          <div className="centerStyle">
            <div  style={{width: "250px"}}>
            <Field name="Picker" component={Selection} options={userOptions} />
            </div>
            {/* <Dropdown>
              <Dropdown.Toggle
                style={{
                  width: "200px",
                  backgroundColor: "white",
                  border: "1px solid #555555",
                  color: "black",
                  fontWeight: "400",
                  marginTop: "10px",
                }}
              >
                {this.state.SelectedPicker && this.state.SelectedPicker}
                {!this.state.SelectedPicker && "Select"}
              </Dropdown.Toggle>
              <Dropdown.Menu className="super-colors">
                {userOptions.map((el) => {
                  return (
                    <MenuItem onClick={() => this.onPickerChange(el)}>
                      {el.label}
                    </MenuItem>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown> */}
            <div style={{ marginTop: "10px" }}>
              <Button
                bsStyle="success"
                type="submit"
                onClick={(event) => {
                  this.savePicker();
                }}
                disabled={SelectedPicker===''}
              >
                {/* <em className="fa fa-plus" /> */}
                <Translate value="assign" />
              </Button>
            </div>
          </div>
        </SkyLightStateless>


        <SkyLightStateless
          dialogStyles={createWeightDialogStyle}
          isVisible={this.state.USPrideCreateOpen}
          onCloseClicked={() => {
            this.closeUSPrideCreate();
          }}
          title={<Translate value="create_with_excel" />}
        >
          <div className="centerStyle">
            <Dropdown>
              <Dropdown.Toggle
                style={{
                  width: "154px",
                  backgroundColor: "white",
                  border: "1px solid #555555",
                  color: "black",
                  fontWeight: "400",
                  marginTop: "10px",
                }}
              >
                {this.state.USPridePlatform && this.state.USPridePlatform}
                {!this.state.USPridePlatform && "Select"}
              </Dropdown.Toggle>
              <Dropdown.Menu className="super-colors">
                {USPridePlatformOptions.map((el) => {
                  return (
                    <MenuItem onClick={() => this.onUSPridePlatformChange(el)}>
                      {el.label}
                    </MenuItem>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
            <div style={{ marginTop: "10px" }}>
              <Button
                bsStyle="success"
                type="submit"
                onClick={(event) => {
                  this.refs.createSORef.click();
                }}
                disabled={
                  !checkPermission("add_sales_order")
                  || (USPridePlatform==='')
                }
              >
                <em className="fa fa-plus" />
                <Translate value="import_and_submit" />
              </Button>
              <input
                type='file'
                ref='createSORef'
                key={inputFieldKey}
                onClick={(e) => {
                  e.target.value = null;
                }}
                onChange={(e) => {
                  const formData = new FormData();
                  const file = e.target.files[0];
                  formData.append('FILE', file);
                  generateSOWithExcelUSPride(formData, USPridePlatform, '', () => {
                    alert('success, reloading the page');
                    this.refreshSOList();
                    this.onUSPridePlatformChange('');
                  });
                }}
                style={{ display: 'none' }}
              />
            </div>
          </div>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createWeightDialogStyle}
          isVisible={this.state.paymentMethodModalVisibility}
          onCloseClicked={() => {
            this.closePaymentMethodModal();
          }}
          title={changePaymentMethod}
        >
          <PaymentMethodModal
            salesOrder={this.state.salesOrders.selectedRows}
            successSaved={this.handleSOPaymentMethodSaved}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={generateBOLStyle}
          isVisible={this.state.shipMethodModalVisibility}
          onCloseClicked={() => { this.closeChangeShipMethodModal(); }}
          title={changeShipMethod}
        >
          <ShipMethodModal
            salesOrder={this.state.salesOrders.selectedRows}
            successSaved={this.handleSOShipMethodSaved}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={DriverListModalStyle}
          isVisible={this.state.shipQtyModalVisibility}
          onCloseClicked={() => { this.closeChangeShipQtyModal(); }}
          title={changeShipQty}
        >
          <ShipQtyModal
            id={this.state.changeShipQtyId}
            successSaved={this.handleSOShipQtySaved}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createTrackingDialogStyle}
          isVisible={this.state.displayTrackingOpen}
          onCloseClicked={() => {
            this.closeDisplayTracking();
          }}
          title={isAFG ? displayTrackingTitle : displayTrackingTitle2}
        >
          <SplitTrackingNumberModal
            salesOrderId={singleSalesOrderId}
            jmlPrintLabel={this.props.jmlPrintLabel}
            fetchJmlTracking={this.props.fetchJmlTracking}
            fetchShippingWeightTracking={this.props.fetchShippingWeightTracking}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.printTrackingConfirmOpen}
          onCloseClicked={this.closePrintTrackingConfirm}
          title={<Translate value="confirm_print_tracking" />}
        >
          <Row className="centerStyle">
            <h4>
              <Translate value="msg_confirm_print_tracking" />
            </h4>
          </Row>
          <br />
          <br />
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={this.closePrintTrackingConfirm}
              type="button"
            >
              <Translate value="no" />
            </Button>
            <Button
              bsStyle="success"
              onClick={this.printTrackingConfirm}
              type="button"
            >
              <Translate value="yes" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createPullSheetDialogStyle}
          isVisible={this.state.changePullSheetOpen}
          onCloseClicked={() => {
            this.closeChangePullSheet();
          }}
          title={changePullSheet}
        >
          <div>
            <Row>
              <Col sm={4}>
                <label>
                  <Translate value="order_amount" />
                </label>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <Input type="number" onChange={this.onPullSheetChange} />
              </Col>
              <Col sm={3}>
                <ButtonToolbar>
                  <Button
                    bsStyle="primary"
                    onClick={() => {
                      this.onChangePullSheetSubmit();
                    }}
                  >
                    <Translate value="submit" />
                  </Button>
                </ButtonToolbar>
              </Col>
            </Row>
          </div>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.checkAuthorizeOpen}
          onCloseClicked={this.closeCheckAuthorize}
        >
          <ConfirmActionModal
            case="confirmPassword"
            closeC={this.checkAuthorize}
            checkPasswordFailure={this.props.checkPasswordFailure}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={voidNoteDialogStyle}
          isVisible={this.state.voidNoteModalVisibility}
          onCloseClicked={this.closeVoidNote}
          title={voidNoteTitle}
        >
          <Row className="centerStyle">
            <div style={{ width: "250px", marginTop: "10px" }}>
              <p style={{ marginBottom: "3px", fontWeight: "bold" }}>
                <Translate value="void_reason" />:
              </p>
              <Dropdown>
                <Dropdown.Toggle
                  style={{
                    width: "250px",
                    backgroundColor: "white",
                    border: "1px solid #555555",
                    color: "black",
                    fontWeight: "400",
                  }}
                >
                  {this.state.voidReason && this.state.voidReason}
                  {!this.state.voidReason && "Select"}
                </Dropdown.Toggle>
                <Dropdown.Menu className="super-colors">
                  {voidReasonSelection.map((el) => {
                    return (
                      <MenuItem onClick={() => this.onVoidReasonChange(el)}>
                        {el.label}
                      </MenuItem>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div
              style={{
                width: "350px",
                marginTop: "20px",
                marginBottom: "35px",
              }}
            >
              <p style={{ marginBottom: "3px", fontWeight: "bold" }}>
                <Translate value="void_note" />:
              </p>
              <Input
                type="textarea"
                rows={3}
                onChange={this.onVoidNoteChange}
              />
            </div>
          </Row>
          <ButtonToolbar className="button-toolbar-center">
            <Button bsStyle="danger" onClick={this.closeVoidNote} type="button">
              <Translate value="cancel" />
            </Button>
            <Button
              bsStyle="success"
              onClick={() => {
                this.onConfirmVoidNote();
              }}
              type="button"
            >
              <Translate value="confirm_void" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={chowbusDialogStyle}
          isVisible={this.state.chowbusModalVisibility}
          onCloseClicked={this.closeChowbusModal}
          title={chowbusImportTitle}
        >
          <Row className="centerStyle" style={{ marginBottom: "20px" }}>
            <label>
              <Translate value="spreadsheet" />
            </label>
            <input
              style={{ border: "1px solid #aaa" }}
              type="file"
              name="file"
              onChange={this.onChangeChowbusImport}
            />
          </Row>

          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={this.closeChowbusModal}
              type="button"
            >
              <Translate value="cancel" />
            </Button>
            <Button
              bsStyle="success"
              onClick={() => {
                this.onConfirmChowbusImport();
              }}
              type="button"
            >
              <Translate value="import" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.confirmReshipOpen}
          onCloseClicked={() => {
            this.closeConfirmReship();
          }}
          title={reshipTitle}
        >
          <Row className="centerStyle">
            <h4>
              <Translate value="msg_confirm_reship" />
            </h4>
          </Row>
          <br />
          <br />
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={this.closeConfirmReship}
              type="button"
            >
              <Translate value="no" />
            </Button>
            <Button
              bsStyle="success"
              onClick={() => {
                this.onConfirmReship();
              }}
              type="button"
            >
              <Translate value="yes" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.showDriverImageOpen}
          onCloseClicked={() => {
            this.closeShowDriverImage();
          }}
          title={showImageTitle}
        >
          {this.renderDriverImage()}
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.showSignatureImageOpen}
          onCloseClicked={() => {
            this.closeSignatureImage();
          }}
          title={showImageTitle}
        >
          {this.renderSignatureImage()}
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={bolImageDialogue}
          isVisible={this.state.submitImageOpen}
          onCloseClicked={() => { this.closeSubmitImage(); }}
          title={submitImageTitle}
        >
          <BolImagesTable
            salesQuote_id={this.state.salesOrders.selectedRows.length === 1 &&
              this.state.salesOrders.selectedRows[0].SalesQuote_id}
            handleImageClosed={() => { this.closeSubmitImage(); }}
          />
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.printBolOpen}
          onCloseClicked={() => {
            this.closePrintBol();
          }}
          title={printBolTitle}
        >
          <Row className="centerStyle">{this.renderAddresses()}</Row>
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="success"
              onClick={() => {
                this.props.printBolByFba(this.state.bolAddressFBA);
              }}
              type="button"
            >
              <Translate value="Print" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.confirmQuoteOpen}
          onCloseClicked={() => {
            this.closeConfirmQuote();
          }}
          title={quoteTitle}
        >
          <Row className="centerStyle">
            <h4>
              <Translate value="msg_assign_customer" />
            </h4>
          </Row>
          <Row className="centerStyle">
            <div style={{ width: "350px" }}>
              <Field
                name="hmmCustomer"
                placeholder={
                  <span style={{ fontStyle: "normal" }}>
                    {this.state.quoteSelectedCustomerPlaceholder}
                  </span>
                }
                component={SelectionWithProps}
                options={this.state.quoteCustomerOptions}
                onSelect={(value) => {
                  this.onQuoteCustomerChange(value);
                }}
              />
            </div>
          </Row>
          {
            isABBLE && <div>
              <Row className="centerStyle">
                <h4>
                  <Translate value="warehouse" />:
                </h4>
              </Row>
              <Row className="centerStyle">
                <div style={{ width: "350px" }}>
                  <Field
                    name="hmmWarehouse"
                    placeholder={
                      <span style={{ fontStyle: "normal" }}>
                        {this.state.quoteSelectedWarehousePlaceholder}
                      </span>
                    }
                    component={SelectionWithProps}
                    options={this.state.quoteWarehouseOptions}
                    onSelect={(value) => {
                      this.onQuoteWarehouserChange(value);
                    }}
                  />
                </div>
              </Row>
            </div>
          }
          {
            !isABBLE && <div>
              <Row className="centerStyle">
                <h4>
                  <Translate value="shipping_address" />:
                </h4>
              </Row>
              <Row className="centerStyle">
                <div style={{ width: "350px" }}>
                  <Field
                    name="customerShipping"
                    placeholder={
                      <span style={{ fontStyle: "normal" }}>
                        {this.state.quoteSelectedShippingPH}
                      </span>
                    }
                    component={SelectionWithProps}
                    options={this.state.quoteShippingOptions}
                    onSelect={(value) => {
                      this.onQuoteShippingChange(value);
                    }}
                  />
                </div>
              </Row>
            </div>
          }
          <br />
          <br />
          <Row className="centerStyle">
            <h4>
              <Translate value="msg_confirm_quote" />
            </h4>
          </Row>
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={this.closeConfirmQuote}
              type="button"
            >
              <Translate value="no" />
            </Button>
            <Button
              bsStyle="success"
              disabled={!this.state.quoteSelectedCustomerId}
              onClick={() => {
                this.onConfirmQuote();
              }}
              type="button"
            >
              <Translate value="yes" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.confirmQuotePending}
          onCloseClicked={() => {
            this.setPendingConfirmModalVisibility();
          }}
          title={pendingTitle}
        >
          <Row className="centerStyle">
            <h4>
              <Translate value="pending_confirm" />
            </h4>
          </Row>
          <Row className="centerStyle">
            <h4>
              <Translate value="msg_confirm_pending" />
            </h4>
          </Row>
          <br />
          <br />
          <br />
          <br />
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={this.setPendingConfirmModalVisibility}
              type="button"
            >
              <Translate value="no" />
            </Button>
            <Button
              bsStyle="success"
              onClick={() => {
                const { salesOrders: {
                  selectedRows,
                } } = this.state;
                const id = selectedRows[0].SalesQuote_id;
                const success = () => {
                  this.refreshSOList();
                  this.setPendingConfirmModalVisibility();
                }
                this.props.setSOToPending(id, success);
              }}
              type="button"
            >
              <Translate value="yes" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.confirmOpenToQuote}
          onCloseClicked={() => {
            this.setQuoteConfirmModalVisibility();
          }}
          title={setQuoteTitle}
        >
          <Row className="centerStyle">
            <h4>
              <Translate value="quote_confirm" />
            </h4>
          </Row>
          <Row className="centerStyle">
            <h4>
              <Translate value="msg_confirm_setso_quote" />
            </h4>
          </Row>
          <br />
          <br />
          <br />
          <br />
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={this.setQuoteConfirmModalVisibility}
              type="button"
            >
              <Translate value="no" />
            </Button>
            <Button
              bsStyle="success"
              onClick={() => {
                const { salesOrders: {
                  selectedRows,
                } } = this.state;
                const id = selectedRows[0].SalesQuote_id;
                const success = () => {
                  this.refreshSOList();
                  this.setQuoteConfirmModalVisibility();
                }
                this.props.setSOToQuote(id, success);
              }}
              type="button"
            >
              <Translate value="yes" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.davisPOVisibility}
          onCloseClicked={() => {
            this.closeDavisPO();
          }}
          title={davisPOTitle}
        >
          <br />
          <br />
          <Row className="centerStyle">
            <h4>
              <Translate value="msg_po_to_so_dropship" />
            </h4>
          </Row>
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={() => this.closeDavisPO()}
              type="button"
            >
              <Translate value="no" />
            </Button>
            <Button
              bsStyle="success"
              onClick={() => this.onConfirmDavisPO()}
              type="button"
            >
              <Translate value="yes" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.pridePrintVisibility}
          onCloseClicked={() => {
            this.closePridePrint();
          }}
          title={pridePrintTitle}
        >
          <br />
          <br />
          <Row className="centerStyle">
            <h4 style={{paddingLeft: '15px', paddingRight: '15px'}}>
              <Translate value="pride_msg_print_shipping" />
            </h4>
          </Row>
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={() => this.closePridePrint()}
              type="button"
            >
              <Translate value="cancel" />
            </Button>
            <Button
              bsStyle="success"
              onClick={() => this.onConfirmPridePrint()}
              type="button"
            >
              <Translate value="continue" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={DriverListModalStyle}
          isVisible={this.state.driverListModalVisibility}
          onCloseClicked={this.setDriverListModalVisibility}
          title={"Assign MSOs to Driver"}
        >
          <DriverListModal
            assigningInboundDriver={this.state.assigningInboundDriver}
            assigningOutboundDriver={this.state.assigningOutboundDriver}
            selectedOrders={this.state.salesOrders.selectedRows || []}
            handleSuccess={this.handleAssignSOToDriverSuccess}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={DriverListModalStyle}
          isVisible={this.state.isaEditModalVisibility}
          onCloseClicked={this.setISAEditModalVisibility}
          title={"isa number update"}
        >
          <ISAEditModal
            selectedSalesOrder={this.state.salesOrders.selectedRows[0]}
            handleISANoUpdateSuccess={this.handleISANoUpdateSuccess}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={DriverListModalStyle}
          isVisible={this.state.ctnEditModalVisibility}
          onCloseClicked={this.setCTNEditModalVisibility}
          title={"ctn number update"}
        >
          <CTNEditModal
            selectedSalesOrder={this.state.salesOrders.selectedRows[0]}
            handleCTNNoUpdateSuccess={this.handleCTNNoUpdateSuccess}
          />
        </SkyLightStateless>
        <EmailContentModal
          visible={this.state.emailContentModalVisibility}
          subject={this.state.emailSubjectTemplate}
          content={this.state.emailContentTemplate}
          onConfirm={this.handleEmailContentConfirm}
          onClose={this.handleEmailContentClose}
          selectedRows={this.state.salesOrders ? this.state.salesOrders.selectedRows : []}
          source={"SQ"}
        />
        <TeapplixResyncModal
          isVisible={this.state.isTeapplixResyncModalVisibile}
          setModalVisibility={this.setTeapplixResyncModalVisibility}
          resyncTeapplix={this.resyncTeapplix}
        />
        <MissingSKUsModal
          isVisible={this.state.isMissingSKUsModalVisible}
          setModalVisibility={this.setMissingSKUsModalVisibility}
          salesOrders={this.state.salesOrders}
        />
        <MonitorNoteModal
          isVisible={this.state.isMonitorNoteModalVisible}
          setModalVisibility={this.setMonitorNoteModalVisibility}
          monitorRow={this.state.monitorRow}
          handleMonitorOrderSuccess={this.handleMonitorOrderSuccess}
        />
        <MonitorRemoveModal
          isVisible={this.state.isCancelMonitorModalVisible}
          setModalVisibility={this.setCancelMonitorModalVisibility}
          monitorRow={this.state.monitorRow}
          handleCancelMonitorOrderSuccess={this.handleMonitorOrderSuccess}
        />
        <MonitorListModal
          isVisible={this.state.isMonitorListModalVisible}
          setModalVisibility={this.setMonitorListModalVisibility}
          selectedWarehouse={this.props.selectedWarehouse}
        />
        <ShippingRateModal 
          isVisible={this.state.isShipingRateVisible}
          setModalVisibility={this.setShippingRateVisibility}
          salesOrders={this.state.salesOrders}
          handleTeapplixPrintClick={this.handleTeapplixPrintClick}
        />
        <div id="sales-shipping-modal">
          <SkyLightStateless dialogStyles={createDialogShippingStyle} isVisible={this.state.showShippingOpen} onCloseClicked={this.closeShipping} title={<Translate value="sales_order_express_invoice" />}>
            <SalesShippingModal
              rows={this.state.mergeSOLines}
              currentSalesOrder={this.state.mergeSODetails}
              InvoiceNum={this.state.mergeSODetails && this.state.mergeSODetails.InvoiceNum}
              isMergeSo={true}
              mergeSOIds={this.state.mergeSOIds}
              mergeSONums={this.state.mergeSONums}
              selectedCompany={this.props.selectedCompany}
            />
          </SkyLightStateless>
        </div>
      </ContentWrapper>
      //---------------
      // End HTML
      //---------------
    );
  }
}

export default SalesOrder;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/salesQuotes.jsx